webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/f5qjST/%3F1728259339717&title=Ebert%27s%20Bigger%20Little%20Movie%20Glossary&summary=An%20expanded%20glossary%20of%20movie%20clich%EF%BF%BDs%20from%20the%20Pulitzer%20Prize%13winning%20film%20critic.%20The%20popular%20film%20critic%20offers%20a%20compilation%20of%20witty%20and%20wise%20observations%20about%20the%20film%20lexicon%2C%20including%20%1CFruit%20Cart%2C%1D%20a%20chase%20scene%20through%20an%20ethnic&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/f5qjST/%3F1728259339717",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=An%20expanded%20glossary%20of%20movie%20clich%EF%BF%BDs%20from%20the%20Pulitzer%20Prize%13winning%20film%20critic.%20The%20popular%20film%20critic%20offers%20a%20compilation%0Dhttps://textcafe.co/books/f5qjST/%3F1728259339717&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/f5qjST/%3F1728259339717&posttype=link&caption=An%20expanded%20glossary%20of%20movie%20clich%EF%BF%BDs%20from%20the%20Pulitzer%20Prize%13winning%20film%20critic.%20The%20popular%20film%20critic%20offers%20a%20compilation%20of%20witty%20and%20wise%20observations%20about%20the%20film%20lexicon%2C%20including%20%1CFruit%20Cart%2C%1D%20a%20chase%20scene%20through%20an%20ethnic",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/f5qjST/%3F1728259339717&description=An%20expanded%20glossary%20of%20movie%20clich%EF%BF%BDs%20from%20the%20Pulitzer%20Prize%13winning%20film%20critic.%20The%20popular%20film%20critic%20offers%20a%20compilation%20of%20witty%20and%20wise%20observations%20about%20the%20film%20lexicon%2C%20including%20%1CFruit%20Cart%2C%1D%20a%20chase%20scene%20through%20an%20ethnic&media=https://textcafe.co/books/f5qjST/tc-custom/9780740792465.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/s?k=9780740792465&i=stripbooks&linkCode=qs&tag=mobilebookcom-20',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=Q-U8ZWC-Ip0C&amp;rdid=book-Q-U8ZWC-Ip0C&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9780740792465').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/f5qjST/tc-custom/9780740792465.jpg?1728259339717',
        alt: 'Ebert&#x27;s Bigger Little Movie Glossary'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "little_01", "little_02", "love_1", "little_03", "little_05", "little_06", "little_07", "little_08", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/f5qjST/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_little_01__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_little_01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_little_01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_little_02__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_little_02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_little_02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_love_1__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_love_1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_love_1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_little_03__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_little_03___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_little_03__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_little_05__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_little_05___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_little_05__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_little_06__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_little_06___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_little_06__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_little_07__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_little_07___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_little_07__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_little_08__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_little_08___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_little_08__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_little_09__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_little_09___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_little_09__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_little_10__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_little_10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_little_10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_little_11__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_little_11___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_little_11__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_little_12__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_little_12___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_little_12__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_love_2__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_love_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_love_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_little_04__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_little_04___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_little_04__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_last__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_last__);
/*jshint esversion: 6 */





















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/little_01",
    "name": "little_01",
    "component": __WEBPACK_IMPORTED_MODULE_4__components_little_01___default.a
  }, {
    "path": "/little_02",
    "name": "little_02",
    "component": __WEBPACK_IMPORTED_MODULE_5__components_little_02___default.a
  }, {
    "path": "/love_1",
    "name": "love_1",
    "component": __WEBPACK_IMPORTED_MODULE_6__components_love_1___default.a
  }, {
    "path": "/little_03",
    "name": "little_03",
    "component": __WEBPACK_IMPORTED_MODULE_7__components_little_03___default.a
  }, {
    "path": "/little_05",
    "name": "little_05",
    "component": __WEBPACK_IMPORTED_MODULE_8__components_little_05___default.a
  }, {
    "path": "/little_06",
    "name": "little_06",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_little_06___default.a
  }, {
    "path": "/little_07",
    "name": "little_07",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_little_07___default.a
  }, {
    "path": "/little_08",
    "name": "little_08",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_little_08___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_18__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/f5qjST/tc-custom/9780740792465.jpg?1728259339717",
      "alt": "This image is the cover for the book Ebert's Bigger Little Movie Glossary"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ebert's Bigger Little Movie Glossary\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("An expanded glossary of movie clichés from the Pulitzer Prize–winning film critic. ")]), _c('br'), _c('br'), _vm._v("The popular film critic offers a compilation of witty and wise observations about the film lexicon, including “Fruit Cart,” a chase scene through an ethnic or foreign locale, or “The Non-Answering Pet,” referring to a dead pet in a horror movie.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Roger Ebert\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Andrews McMeel Publishing\n   ")])])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "little-movien"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "100%",
      "src": "images/img_01.jpg"
    }
  })])])])])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "little-movien"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "100%",
      "src": "images/img_02.jpg"
    }
  })])])])])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-inside": "avoid",
      "text-align": "center",
      "margin": "0"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://earlybirdbooks.com/freebook/index.html?q=62854932d6c2b37d43a454ca&utm_campaign=front",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "love-andrews-mcmeel.jpg"
    }
  })])])])])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "little-movien"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "100%",
      "src": "images/img_03.jpg"
    }
  })])])])])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "little-movien"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "100%",
      "src": "images/img_04.jpg"
    }
  })])])])])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "little-movien"
    }
  }, [_c('div', {
    staticClass: "generated-style"
  }, [_c('p', {
    staticClass: "content",
    attrs: {
      "id": "toc-anchor"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "#/little_07"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "#/little_08"
    }
  }, [_vm._v("Glossary Entries")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_vm._v("Appendices")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "#/little_09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Things You Would Never Know"), _c('br'), _vm._v(" without the Movies")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "#/little_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mark O’Donnell’s "), _c('br'), _vm._v("Laws of Cartoon Motion")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "#/little_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Greg Matty’s "), _c('br'), _vm._v("Creature Ferocity Index")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "#/little_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Cynic’s Guide to the Language "), _c('br'), _vm._v("in Film Festival Catalog Descriptions"), _c('br'), _vm._v(" by Doug Saunders")])])]), _vm._v(" "), _c('div', {
    staticClass: "generated-style"
  })])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "little-movien"
    }
  }, [_c('div', {
    staticClass: "generated-style"
  }, [_c('p', {
    staticClass: "content",
    attrs: {
      "id": "toc-anchor"
    }
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "cap"
  }, [_vm._v("T")]), _vm._v("he birth of the critical impulse comes in different ways to different people, and to some it comes not at all. Reconstructing my own development as a critic, I usually cite Dwight Macdonald’s columns in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Esquire")]), _vm._v(" as the key early influence. In the late 1950s and 1960s, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Esquire")]), _vm._v(" was the best magazine in America, and I treated it like a road map to life. Macdonald was pointed, unforgiving, hard to please, and very funny.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1-ind"
  }, [_vm._v("But there was, I find, an even earlier influence. That would be "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mad")]), _vm._v(" magazine, which had an almost incalculable effect on America in the 1950s. In the world of bland Eisenhower calm, there were whirlpools of satire: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mad, ")]), _vm._v("Bob and Ray, Stan Freberg, Lenny Bruce. I was going to the movies once or twice a week, and when I read the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mad")]), _vm._v(" satires of movies, I learned about clichés, stereotypes, obligatory scenes, standard dialogue, and preposterous plot developments. I began to apply what I learned to the movies I was seeing, and by the time I was in high school, that had become a habit.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1-ind"
  }, [_vm._v("Perhaps this "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Glossary")]), _vm._v(" grew out of those old issues of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mad.")]), _vm._v(" Years later, as a film critic for the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago Sun-Times,")]), _vm._v(" I sat down at a typewriter and wrote down twenty or thirty “glossary entries” for a Sunday column. Why? It seemed like a good idea at the time. Recently I’ve been scanning some of my earliest reviews into digital form, and in re-reading them, I find that I was forever pointing out the ways in which movies followed generic conventions, whether to honor or dishonor them. It seemed to be the way my mind worked.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1-ind"
  }, [_vm._v("The first column led to others. When I started publishing annual collections of reviews in 1986, a list of glossary entries appeared in each book. Readers started sending in contributions of their own. In 1991, my reviews and the glossary were picked up by CompuServe, and I was given a section of the ShowBiz Forum. Now a trickle became a flood (nice cliché).")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1-ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ebert’s Little Movie Glossary")]), _vm._v(" was published in 1994, and also appeared in a British edition titled "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Little Book of Hollywood Clichés.")]), _vm._v(" And I received still more submissions; I started using a new one every other week in my column “The Movie Answer Man.”")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1-ind"
  }, [_vm._v("Now here is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ebert’s Bigger Little Movie Glossary.")]), _vm._v(" It’s about twice the size of the first edition, although most of the earlier entries have been retained (I would not want to do without the Fruit Cart or the Talking Killer). About two-thirds of the entries are by readers, including some prolific ones. To them, my thanks.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1-ind"
  }, [_vm._v("The purpose of the book is to entertain, of course, but perhaps it might also shame filmmakers into avoiding the most shopworn conventions. The Fruit Cart syndrome has actually been satirized in more than one film, and I await the day when the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Glossary")]), _vm._v(" itself is filmed. I imagine an entire film made of clichés, archetypes, and stereotypes; then I reflect that such a movie is released more or less weekly.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1-ind"
  }, [_vm._v("Will there be a third edition someday? Who knows? Contributions still flow in. You can mail them to me at the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sun-Times,")]), _vm._v(" 401 N. Wabash, Chicago 60610. Or E-mail me at 74774.2267@compuserve.com. New entries appear in the Answer Man column, which is syndicated to 305 papers and appears on-line on CompuServe, or at www.suntimes.com/ebert.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1-ind"
  }, [_vm._v("As this book went to press, I lost my friend and colleague Gene Siskel, who supplied some of these entries, and coined Siskel’s Test: “Is this movie as interesting as a documentary of the same actors having lunch?” That’s a question every filmmaker would be wise to ask before embarking on a new project.")]), _vm._v(" "), _c('p', {
    staticClass: "auther-name"
  }, [_vm._v("Roger Ebert")])])])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "little-movien"
    }
  }, [_c('div', {
    staticClass: "generated-style",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "img ",
    attrs: {
      "alt": "",
      "src": "images/img_44.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Academy Mandate.")]), _vm._v(" The feeling by Oscar winners that an award for their film work is a validation of their personal beliefs. Examples: Vanessa Redgrave’s “Zionist hoodlum” speech; Oliver Stone’s insistence that his awards for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Platoon ")]), _vm._v("were an anti–Vietnam War statement by the Academy; Richard Attenborough’s accepting the Oscar for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gandhi ")]), _vm._v("the movie on behalf of Gandhi the man; James Cameron asking for a moment of silence for the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Titanic ")]), _vm._v("victims, etc. ")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Accentuating Evil.")]), _vm._v(" The xenophobic and frequently anglophobic practice of defining villains by their distinctive accents, from twangy southern sheriffs to meticulously dictioned elitist snobs to wheezing Teutonic mad scientists. The hiring of British actors to play accented villains is particularly prevalent. Examples: Alec Guinness in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hitler: The Last Ten Days, ")]), _vm._v("Laurence Olivier in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Marathon Man, ")]), _vm._v("Peter Sellers in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dr. Strangelove, ")]), _vm._v("Jeremy Irons in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reversal of Fortune, The Lion King, Die Hard 3, ")]), _vm._v("etc.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwsyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Acquariamcam.")]), _vm._v(" Underwater action scenes, even in the dirty waters of major ports, are always crystal clear, pristine, and well lit. Although characters are submerged longer than it would take me to get a popcorn refill, upon surfacing they start talking immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jim Carey, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New Lenox, Ill.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "img ",
    attrs: {
      "alt": "",
      "src": "images/img_05.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Actress Inferior Position.")]), _vm._v(" In movie sex scenes, which are usually directed by men, the POV at the moment of climax is almost always the man’s, so that we see the actress, not the actor, losing control.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Gene Siskel")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("AC-WAT-NOBI Movie.")]), _vm._v(" A Cop with a Theory No One Believes In.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Robert Tarry Grouchy, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("University of Calgary")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Against All Odds Rule.")]), _vm._v(" In an apparently fatal situation from which there is no possible hope of survival, it is certain the characters will survive. In a situation where there is any apparent chance of survival, there will be at least some deaths.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. R. Kunz")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("The Agent Did It!")]), _vm._v(" In any film involving an unknown killer, if a moderately well-known actor is given costar billing yet only appears for, say, five minutes in the first hour and a half, he or she is almost guaranteed to be revealed at the climax as the murderer, complete with flamboyant mad scene leading up to a spectacular death.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Michael Schlesinger,"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Culver City, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Aging Blood Syndrome.")]), _vm._v(" Tendency of movie blood to look more and more like gushes of slightly crimson motor oil every year (as in all nineties horror and action movies), as opposed to anything possibly resembling real blood (as in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Wild Bunch")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Lukas Kendall, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Martha’s Vineyard, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("“Ain’t Nobody Here but Us Chickens.”")]), _vm._v(" Whenever someone is alone at home at night and they hear a sound in the house and ask aloud, “(Name), is that you?” it "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("never")]), _vm._v(" is.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("James Portanova")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Airline Flight Rules.")]), _vm._v(" Movie characters travel only first class. They are never seated near crying babies. All flights are full, but they are always able to walk right on and take their seats without waiting behind someone cramming a suitcase into an overhead rack. Although other passengers on the flight may recline their seats, the main characters can only be seated in the full upright position, because if they reclined the result would be an unattractive camera angle up their nostrils.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("James Fuhrman, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("West Hollywood, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Air Vent Escape Route.")]), _vm._v(" If the hero is imprisoned in a building owned by the villains, there will inevitably be an air vent cover that is not screwed in and is easily removed. The passageway will be large enough to accommodate any size person. The escape route will pass over the room where the bad guys are discussing the details of their diabolical plan, which the hero will now be able to foil.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dona Kight, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Alan Alda Rule.")]), _vm._v(" Any character in a murder mystery who is excessively helpful to the main character invariably turns out to be the killer (if he or she isn’t dead by the second reel). Named for Alda because he’s done it at least twice.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v(" Rob Matsushita, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Madison, Wis.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Alarm Clock Rule.")]), _vm._v(" If an electric clock is given a close-up, it will be either twenty-nine minutes past the hour, or one minute to the hour. The time will progress one minute, waking up the hero with a song that is important to the plot.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Rhys Southan, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Richardson, Tex.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Alien Berlitz Communication Rule (ABC Rule).")]), _vm._v(" Movie aliens are able to learn the local language (English, French, Japanese, etc.) in an amazingly short time. Frequently this includes the ability to reproduce recognizable Earth-like accents. See also “Universal Translator.”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Richard Rohrdanz, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("West Kennebunk, Maine")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Ali MacGraw’s Disease.")]), _vm._v(" Movie illness in which only symptom is that the sufferer grows more beautiful as death approaches.")]), _vm._v(" "), _c('p', {
    staticClass: "auther-name"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("All-Seeing Camera.")]), _vm._v(" The remarkable ability of a stationary surveillance camera or news camera operated by a lone cameraman to film or video an incident from several different angles and distances all at once. When played back, the resulting film or videotape exactly duplicates the original point of view of the audience, right down to the sequence of the montage. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Enemy of the State, ")]), _vm._v("etc.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v(" Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("All the News That’s Scripted, We Print.")]), _vm._v(" All media coverage depicted in a movie will prominently feature the main character, no matter how incidental his or her involvement is to the big story. His picture makes Page One, and CNN thoroughly documents his simple presence in a crowd. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Godzilla, ")]), _vm._v("in which TV news reports pass up footage of a giant rampaging lizard in favor of shots of Matthew Broderick carrying his luggage, digging a hole, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("James Arnall, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('img', {
    staticClass: "img ",
    staticStyle: {
      "page-break-before": "always"
    },
    attrs: {
      "alt": "",
      "src": "images/img_06.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Angelic Bicyclist.")]), _vm._v(" Whenever movie characters are seen blissfully riding their bicycles with eyes closed and arms outstretched like angel’s wings, there is a strong likelihood that they are about to collide with a massive object and be killed.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jeff Shannon, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Seattle")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Angel Limited-Involvement Rule.")]), _vm._v(" Modern movie angels mostly seem to visit Earth in order to smoke cigarettes, eat pizza, and show what regular Joes they are. Although famine, war, disease, and higher prices torment the globe, they solve such problems as a guy who has stopped dating because he’s lost his faith in women.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Animal Kingdom, Sights and Sound Of.")]), _vm._v(" (1) In at least one scene in any movie about the “jungle”—no matter where in the world—the sound track must feature the demented call "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(“who-who-who-ah-ah-ah-ah-HA-HA”) ")]), _vm._v("of an Australian kookaburra (the “Laughing Jackass Bird”). (2) Except when dogs pee on someone’s foot for comic effect, animals on film never micturate or defecate. (3) Before 1970, any predatory mammal—wildcat, wolf, or bear—was vicious and bad, deserving to be shot by the good guy. Now they’ve become noble and powerful—and somehow less carnivorous; perhaps they have discovered tofu.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Steve W. Zack, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nedding, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Anti-Anti-Auto Theft Device.")]), _vm._v(" Any actor can start any car by pulling any two wires from under the dash and touching them together to make them spark. This not only starts the car but it also defeats the steering column’s locking mechanism.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Colom Keating, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Santa Monica, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Antiheroine Skin Rule.")]), _vm._v(" In a Horny Teenager Movie, the “bad girl” who is the object of the hero’s desire will always expose more flesh than the girl whom he ends up with at the end of the film, despite equal sexual activity. If the “good girl” is shown topless in a love scene, it must be accompanied by slow music. In a Dead Teenager Movie, the girl who exposes the least skin is inevitably the only survivor. ")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jim O’Brien")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Antiques of Death.")]), _vm._v(" Straight razors, ice picks, paperweights, fireplace pokers, meat cleavers, crowbars, dueling pistols, ceremonial daggers, swords, sabers, battle-axes, giant marble ashtrays, and other archaic, clichéd weapons of mayhem that always seem to be handy for movie murders, even though few homes might actually have any such antiques readily available for an impromptu killing.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v(" Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Archivist Killer Syndrome.")]), _vm._v(" Many serial killers could also find employment as the authors of double acrostics and conundrums. In searching for such killers, hero detectives invariably find an abandoned apartment with newspaper clippings and photos on the wall showing the killer’s (a) victims, (b) pursuer, (c) next victim, and (d) a message to his pursuers. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("In the Line of Fire, Seven.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("David T. G. Riches, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Etobicoke, Ontario")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "img ",
    attrs: {
      "alt": "",
      "src": "images/img_07.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Ark Movie.")]), _vm._v(" Dependable genre in which a mixed bag of characters is trapped on a colorful mode of transportation. Examples: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Airport ")]), _vm._v("(airplane), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Poseidon Adventure ")]), _vm._v("(ocean liner), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Marooned ")]), _vm._v("(space satellite), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Cassandra Crossing ")]), _vm._v("(train), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aliens ")]), _vm._v("(outer space), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Hindenberg ")]), _vm._v("(dirigible), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Taking of Pelham One Two Three ")]), _vm._v("(subway train), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Abyss ")]), _vm._v("(undersea station), and of course the best of them all, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Stagecoach.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Ashes to Lashes.")]), _vm._v(" In any scene involving the scattering of ashes, the ashes will blow back into the faces of the mourners. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Big Lebowski.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Asian Grandfather Rule (Yan’s Law).")]), _vm._v(" All elderly Asians in movies speak in aphorisms like Sydney Toler in the old Charlie Chan movies.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Bill Becwar, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wauwatosa, Wis.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Asian Woman Rule.")]), _vm._v(" Any Asian woman with a greater than incidental part in a movie always falls in love with the hero, no matter how big a slob he seems to her (or any other) culture.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Bill Becwar, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wauwatosa, Wis.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("“As Long as You’re Up, Get Me a 2 × 4.”")]), _vm._v(" When a fight in a bar breaks out, nearly everyone in the place begins fighting, spontaneously and without cause—even with people they have been sitting next to for some time.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jim Simon, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Villa Park, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Auto Audio Rule.")]), _vm._v(" The sound a vehicle makes in a movie chase scene will in no way correspond to any sound made by same vehicle in real life (tires squealing on dirt or around corners at low speed, etc.).")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Edward Savio, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("San Francisco")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "img ",
    attrs: {
      "alt": "",
      "src": "images/img_08.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Auto Autopilot Exemption.")]), _vm._v(" An actor required to deliver key dialogue while driving a car is allowed to take his or her eyes off the road and maintain steady eye contact with the front-seat passenger for up to five seconds without being subject to real-life consequences like rear-ending a cement mixer or taking out pedestrians.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("David Mayerovitch, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Toronto")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Autobiographical Cameo Perk.")]), _vm._v(" If a flattering movie is made about a person who is still alive, watch for that person to make a fleeting cameo in the film, a perk for relinquishing the rights to his existence. Examples: Melvin Dumar selling sandwiches in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Melvin and Howard, ")]), _vm._v("Jim Garrison playing Earl Warren in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JFK, ")]), _vm._v("Blaze Starr as a stripper in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blaze, ")]), _vm._v("or Jim Lovell playing an admiral in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Apollo 13. ")]), _vm._v("(This is parodied in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pee-Wee’s Big Adventure ")]), _vm._v("when Pee-Wee Herman makes a cameo appearance in the movie-within-the movie.)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Auto Death Knell.")]), _vm._v(" If a character dies in a car crash, he will do so in a way that causes the horn to blare continuously.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("John Shannon, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oceanside, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Automatically Arriving Automobiles.")]), _vm._v(" Whenever cars in a chase go through a four-way junction, unrelated cars must appear from each direction and skid into the center. These cars may either stop unharmed or crash into each other in the center, upon which all the drivers will get out and shake fists at each other. No cars actually involved in the chase are ever involved in the crash.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Stephen Rowley, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Melbourne, Australia")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Automatic Bike Bell.")]), _vm._v(" Any bicycle passing through the frame will be accompanied by the ring of a bike bell on the sound track.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Automatic Customer Bell.")]), _vm._v(" All establishing shots of small town Main Streets are inevitably accompanied by the sound of a bell ringing as a customer opens a door.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Automatic Miss Syndrome.")]), _vm._v(" In every movie in which the hero or heroine is fleeing from automatic weapons fire, the bullets will strike either in front or behind or, in a more aesthetically pleasing pattern, in parallel rows on either side.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Kim Rotzoll, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Urbana, Ill.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Automatic Vest Display.")]), _vm._v(" A character who has mysteriously survived being shot at point-blank range always immediately unbuttons his shirt to reveal his bulletproof vest, usually only to himself.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "img ",
    attrs: {
      "alt": "",
      "src": "images/img_45.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Backseater Mortality Phenomenon.")]), _vm._v(" Whenever the hero is the pilot of a warplane that has a crew of two or more, any crewman that is not a pilot is marked for death. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Top Gun, Flight of the Intruder, Enemy Mine, By Dawn’s Early Light, ")]), _vm._v("and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Empire Strikes Back.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jeff Cross, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Marblehead, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Back Seat Inviso-Syndrome.")]), _vm._v(" Film characters are invariably unable to see a person crouched in the back seat of a car (even a convertible) when, in the real world, it is an impossible place for a person to hide.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Eric Skovan, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Poughkeepsie, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Bad Guy Credentials Demo.")]), _vm._v(" In any movie where the villain is a really, really bad guy, whose dysfunction and malice transcend that of the ordinary evildoer, he establishes that fact early in the film by coldly killing one of his own men. See Darth Vader, many Bond villains, Russian Mafia leader in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Jackal, ")]), _vm._v("etc.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dirk Knemeyer, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bowling Green, Ohio")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "img ",
    attrs: {
      "alt": "",
      "src": "images/img_09.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Bad Movie Rental Warning Rule.")]), _vm._v(" If a rental movie box has a warning such as “If scenes of graphic horror offend you, do not rent this film!”—do not rent this film.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Sam Waas, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Houston")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Bad Smoker Rule.")]), _vm._v(" In any cop movie made since the mid-seventies, the bad guys smoke, while the good guy is trying to quit.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Baguette Envy.")]), _vm._v(" In every scene which includes a person carrying a bag of groceries, the bag will invariably contain a long, skinny, French baguette loaf, and exactly 8.5 inches of it will be exposed.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Michael J. Pilling, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maple Ridge, B.C., Canada")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Baked Potato People.")]), _vm._v(" The nice, good, sweet little people who form a chorus in the hero’s background, especially during any movie set in a mental home (cf. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Dream Team, Crazy People")]), _vm._v("). The lesson is always the same: It’s the real world that’s crazy, and the crazy people who speak real truth. (Inspired by a sign seen by Billy Baxter of New York City on a baked potato in a steak house: “I’ve been tubbed, I’ve been rubbed, I’ve been scrubbed. I’m lovable, huggable, and eatable!”)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Balloon Rule.")]), _vm._v(" Good movies rarely contain a hot-air balloon. Most egregious use of a hot-air balloon: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Men Don’t Leave, ")]), _vm._v("where the heroine is cured of clinical depression by a ride in one. (Readers keep writing in with exceptions to this rule, including "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Witness, ")]), _vm._v("but the general principle still applies.)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Balls of Steel Rule.")]), _vm._v(" Bad guys who suffer a blow to the groin are down for the count, just like in real life. Good guys shrug it off and are back in action within seconds. See, in particular, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Total Recall, ")]), _vm._v("in which Sharon Stone kicks Schwarzenegger in the groin a half-dozen times within a matter of minutes. Arnold only grits his teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("John Snell")]), _vm._v(" "), _c('img', {
    staticClass: "img ",
    staticStyle: {
      "page-break-before": "always"
    },
    attrs: {
      "alt": "",
      "src": "images/img_10.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Barber’s Itch Rule.")]), _vm._v(" Major stars in a film about army recruits going through basic training will never have their head shaved completely. Their hair will merely be short (for example, Bill Murray and Harold Ramis in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Stripes,")]), _vm._v(" Richard Gere in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("An Officer and a Gentleman")]), _vm._v("). Likewise, a star entering prison will only have a tasteful trim (Robert Redford in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Brubaker")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jon Niccum, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kansas City, Mo.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Barroom Bum Slide.")]), _vm._v(" Most bar fights in the movies end with the loser being pushed so hard he slides halfway down the bar. In real life, this is impossible.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Douglas W. Topham, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Woodland Hills, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Bartender Establishing Shot.")]), _vm._v(" All movie bartenders, when first seen, are wiping the inside of a glass with a rag. ")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("David W. Smith, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westminister, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("“Based on a true story.”")]), _vm._v(" Hollywood shorthand, meaning: Depressing, morbid, downbeat, including scenes so shocking or lascivious that no producer would include them in a movie unless he could excuse himself by saying these things actually happened.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Rich Elias,"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Delaware, Ohio")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Bathroom Rule.")]), _vm._v(" No one ever goes into a movie toilet to perform a natural function. Instead characters use the bathroom to take illegal drugs, commit suicide, have sex, smoke, get killed, exchange money, or sneak out through the bathroom window.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Eugene Accardo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Brooklyn, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("“Because It’s Called Sound Effects” Rule.")]), _vm._v(" In real life, when someone hangs up the phone on you, you hear a click and then silence (about thirty seconds of dead air before an obnoxious tone). In the movies, when someone hangs up at the other end, you get a new dial tone immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("John Farmer, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Manhattan Beach, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Because They Are There.")]), _vm._v(" The top ten lines you can always count on in a mountain-climbing movie: (1) “We have to move fast. We’ve started late in the season. But if we leave behind the oxygen and most of our equipment and travel light, we can get up there and back before the winter storms.” (2) “I know they’re still alive.” (3) “Leave me here. I can’t walk. My legs are broken. By yourself, you have a chance.” (4) “Just let me do this one last climb. Then I’ll settle down with you and the baby.” (5) “Tell them they’ll get an extra fifty rupees a day, at the end, if they complete this part of the march.” (6) “Sahib! The fresh snow has covered up the crevices! The men say they will go no further today!” (7) “Every previous expedition along this route has had trouble with the porters.” (8) “I’d trust him on the other end of my rope.” (9) “Take me along. You know I’m a better climber than those guys.” (10) “Because it’s there.”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Beep Bleep.")]), _vm._v(" The sneaky trick of inserting the honk of a car horn onto the sound track to cover an obscene word or phrase. Whistles, bells, animal noises, and claps of thunder are also used. Sometimes used to turn an R-rated film into a PG-13, but more frequently used to clean up the TV version. See also “Crap Gap” and “Inanity Profanity.”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('img', {
    staticClass: "img ",
    staticStyle: {
      "page-break-before": "always"
    },
    attrs: {
      "alt": "",
      "src": "images/img_11.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Beeping Rule.")]), _vm._v(" In movies where cops, reporters, hackers, and others are using a computer to locate a suspect or special file, the successful retrieval of said subject is heralded with dramatic beeps, flashing messages, and other electronic indications that “something important has been found.” The only time an ordinary computer ever beeps is when it refuses to carry out a command.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("James Moore, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("San Jose, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Beginning, The.")]), _vm._v(" Word used in the titles of sequels to movies in which everyone was killed at the end of the original movie, making an ordinary sequel impossible. Explains to knowledgeable filmgoers that the movie will concern, for example, what happened in the Amityville house before the Lutzes moved in. Other examples: The First Chapter, The Early Days, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Benevolent Blurbster.")]), _vm._v(" A week before a movie opens, all the reviews seem to be ecstatic. Sunday papers and advance TV ads are filled with shouts of unqualified praise, usually attributed to unfamiliar critics from obscure outlets. These “critics” exist primarily for the purpose of supplying such advance quotes, which they are happy to do for the thrill of seeing their names in print. Often they do not even write an actual review, but compose only the blurbs, which they fax or telephone to grateful publicists. Wise moviegoers wait until quotes from real critics from respected sources start appearing in the ads.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Bergman-Allen Hypothesis.")]), _vm._v(" Ingmar Bergman regards existential depression as a flaw in the universe. For Woody Allen, it’s just hereditary.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Rich Elias, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Delaware, Ohio")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Best Play of the Game Rule.")]), _vm._v(" Every bad sports movie ends with the hero making an extraordinary catch/play/"), _c('br'), _vm._v("hit in slow motion to win the game at the final gun/bell/"), _c('br'), _vm._v("buzzer.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Webster Watnik")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("“Betcha Can’t Name That Tune” Ploy.")]), _vm._v(" Almost all movie pianists, such as Clint Eastwood in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("In the Line of Fire, ")]), _vm._v("are perfectly happy playing nothing but chords. By never straying anywhere near a recognizable melody, they avoid paying royalties.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Emo Phillips, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Betsy ")]), _c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Syndrome.")]), _vm._v(" Identifying an actor in print by his or her latest film, regardless of how weak it was. Inspired by a newspaper article that appeared toward the end of Sir Lawrence Olivier’s career, referring to him as “Lawrence "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(The Betsy) ")]), _vm._v("Olivier.”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Brian Jones")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Big Gun Recoil Rule.")]), _vm._v(" Any large gun must fire with such force that it causes the barrel or some other part of the gun to recoil. In defiance of the laws of physics, this rule applies even to laser cannons in sci-fi movies. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Star Trek V, Star Wars")]), _vm._v(" trilogy.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jeff Cross, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Marblehead, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Big Lie, The.")]), _vm._v(" Refers to all scenes where bad guy paints a beautiful picture and then adds a version of, “One more thing, Benny. I Lied.”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Mike Sheehan")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Big Name Poster Rule. ")]), _vm._v("When the entire trailer or poster "), _c('br'), _vm._v("for a movie consists of the names of the two stars, as in STALLONE-STONE or WESLEY-WOODY, this suggests that getting those two names represents most of the film’s budget, and that finding a script was a lower priority.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Mark McDermott, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Park Forest, Ill.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Big Nod, The.")]), _vm._v(" Comes after the Last Word. After a character is fatally wounded, first he lies motionless and recites an incredibly meaningful statement. Then his head nods to one side.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Rex E. Russo")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Big Wet Dog Shakedown.")]), _vm._v(" All wet dogs shake themselves dry only while standing next to well-dressed movie characters.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Steve Wideman")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Bilingual Nazi Officer Rule.")]), _vm._v(" Nazi officers always speak English when talking to each other, even though Nazi sergeants can be heard in the background barking orders in German.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Tim Benton, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Huntsville, Ala.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Birthin’ Rule.")]), _vm._v(" Any character more than seven months pregnant will give birth by the end of the film, usually in an unusual place, such as an elevator, a cemetery, or the back seat of a car in a traffic jam. The baby is always delivered by someone squeamish and inexperienced who will discover the miracle of life and get the baby named after him or her.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Lisa Martin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Toronto")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Black Rock Rule.")]), _vm._v(" When a movie starts with the hero arriving in a small town to look up a long lost friend or relative, the person is almost certainly already dead and half the town is in on it. Named for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bad Day at Black Rock.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Joe DiCostanzo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York City")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Blockbuster–Brady Bill Postulate.")]), _vm._v(" Since at least one out of every three movie covers at the average video store shows someone holding a gun, you should probably wait at least five business days before renting them.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jeffrey R. Field, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kansas City")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Bloody Fingertip Rule.")]), _vm._v(" If a character sees anything looking like blood, he must put his finger in it and hold it up before realizing that it is blood. Corollary: If the substance is not blood, the character must smell it or taste it before realizing what it is.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Gerald Fitzgerald, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dallas")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Body Switch Movie.")]), _vm._v(" The brain of one character somehow finds itself in the body of another. Requires actors to confront an actor’s nightmare, i.e., acting as if they were another actor.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Bogeyman Shot.")]), _vm._v(" Unaware victim is shot in close-up looking toward the camera, while a huge lopsided space is left vacant for the monster/killer to appear in.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Paul S. Wooley, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Portland, Oreg.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Bomb Defusion Rule.")]), _vm._v(" No bomb can be defused if it is more than ten seconds away from detonation.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Gerald Fitzgerald, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dallas")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Boob Tube.")]), _vm._v(" There is never anything worth watching on TV in the movies.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jerry Ritcey")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Boom-Boom Rule.")]), _vm._v(" Whenever a building or a car explodes, the explosion will be repeated in its entirety from several different camera angles.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Sam Carlson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Duluth, Minn.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Born in the USA.")]), _vm._v(" Any movie set in an unnamed U.S. city will be revealed by the credits to have been filmed in Toronto or Vancouver.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. R. Kunz")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Box Rule.")]), _vm._v(" Beware movies advertised with a row of little boxes across the bottom, each one showing the face of a different international star and the name of a character (e.g., “Curt Jurgens as the Commandant”). Also, most films made from Agatha Christie novels.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Boy-Meets-Girl Rules.")]), _vm._v(" If two characters have a Meet Cute, they’ll be together by the end of the movie. If they have an antagonistic meet, they’ll be together by the middle of the movie.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Barbara Bridges, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Los Angeles")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Brando Acceptability Yardstick.")]), _vm._v(" After Marlon Brando did "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Superman ")]), _vm._v("strictly for the money, he cleared the way for Gene Hackman, Jack Nicholson, Faye Dunaway, Warren Beatty, Dustin Hoffman, Al Pacino, and others to take big bucks to appear in silly comic book roles. (Illustrated in Blake Edward’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("S.O.B. ")]), _vm._v("when Julie Andrews is asked to do a nude scene because Liv Ullman has done one.)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Brass Ring Rule.")]), _vm._v(" Any time you overhear incidental dialogue from minor characters about some impossible feat, occasionally attempted but never achieved, someone, usually the hero, will accomplish the feat within the last ten minutes of the movie.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Brannon Moore, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Seattle")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Breaking Bad News:")]), _vm._v(" Anyone holding a vase or other glass object will drop that object upon hearing bad news. Usually the object will fall and shatter in slow motion, typically from multiple angles.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Terry McManus, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Breathing Corpse Syndrome.")]), _vm._v(" No one in the movies or on television has ever looked convincingly dead, a condition much harder to fake than an orgasm.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Prof. Terry Eagleton, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oxford University, England")])]), _vm._v(" "), _c('img', {
    staticClass: "img ",
    staticStyle: {
      "page-break-before": "always"
    },
    attrs: {
      "alt": "",
      "src": "images/img_12.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Brick Wall Paradox.")]), _vm._v(" If a character, while swinging on a rope in an affluent suburb, slams face-first into a brick wall, that character never experiences any injuries other than moaning and sliding off of the wall. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Home Alone, Cops and Robbersons")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Rod Ahlbrandt, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Laramie, Wyo.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("British Roman Rule.")]), _vm._v(" All leaders of the Roman Empire have British accents. Why don’t filmmakers want Romans to at least have Italian accents?")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Eugene Accardo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Brooklyn")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Broken Compass Principle.")]), _vm._v(" In New York City chase scenes, cars are able to turn off of avenues onto other avenues. This is impossible, since the avenues are parallel.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("David Burd, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("East Stroudsburg, Pa.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Brotman’s Law.")]), _vm._v(" “If nothing has happened by the end of the first reel, nothing is going to happen.” (Decreed by Chicago movie exhibitor Oscar Brotman.)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Buddy-Brother Road Film.")]), _vm._v(" Three-way combo of buddy movie, road movie, and brothers who learn to love each other. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Coupe de Ville, Rain Man, The Wizard.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("John Weckmueller, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Menomonie, Wis.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Bud “The Stud” Drumplehoff’s Law.")]), _vm._v(" Dramatic films don’t have crew member nicknames in the credits. Comedies do.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Greg Brown, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Bullet Velocity Rule.")]), _vm._v(" In action movies, the speed of a bullet is slowed down enough so that our hero can jump out of the way. In sci-fi movies, the speed of light (lasers/ phasers/blasters) is slowed down enough so that the hero/ship can jump/move out of the way and the audience can see the beam moving. The actual formula is: Hollywood Bullet Speed = (Real Bullet Speed) / (Importance of Character), where the more important a character is, the higher the number.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dave Edson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Eugene, Oreg.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Bullitt Rule.")]), _vm._v(" Any car chase in San Francisco will be downhill, even though the most likely places from which someone would flee are all downtown, at the bottom of all of the hills.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Neil Milsted, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bullitt ")]), _c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Shift.")]), _vm._v(" Cars in high-speed chases can shift through more gears than they have. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bullitt, ")]), _vm._v("where Steve McQueen’s car upshifts more than sixteen times.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Edward Savio, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("San Francisco")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Bumbling Night Watchman.")]), _vm._v(" Any scene involving the good guy burgling an office at night will inevitably include a semicompetent night watchman, whose sole purpose is to inject an element of danger into an otherwise boring event. Actions performed by the watchman usually include shining a flashlight through the window, rattling doorknobs, watching security monitors, etc., all done in a manner that allows the good guy to continue undetected until just after he discovers the needed information or object. He will then flee the scene with the watchman in pursuit.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Rick Newby, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("College Place, Wash.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Bun and Spectacles Rule.")]), _vm._v(" Any woman who appears in a movie with her hair in a tight bun and wearing glasses (usually large, thick round ones) will inevitably turn out to be the beautiful heroine. She will magically acquire perfect vision and a sexy wardrobe.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Tom Drane")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Bureau of Lame and Anemic Name Changes (BLANC). ")]), _vm._v("Supersecret Hollywood Agency specializing in changing unusual and clever film titles into titles that are banal and uncommercial. Samples: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cop Gives Waitress $2 Million Tip")]), _vm._v(" became "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("It Could Happen to You;")]), _vm._v(" S"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("exual Perversity in Chicago")]), _vm._v(" became "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("About Last Night . . . ; Stab")]), _vm._v(" became "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Still of the Night;")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cloak and Diapers")]), _vm._v(" became "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Undercover Blues;")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rocket Boys")]), _vm._v(" became "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("October Sky, ")]), _vm._v("etc.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("But Is It Today’s?")]), _vm._v(" In a time travel movie, the hero finds out the date by picking up a newspaper in a trash can.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Steven Souza,"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Honolulu, Hawaii")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("But They Didn’t Count on . . . One Man.")]), _vm._v(" In trailers for action movies, this ominous voice-over announces a plot in which the hero single-handedly foils the plans of a band of terrorists or master criminals in spectacular and bloody fashion. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Die Hard.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Chris Galvin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Columbus, Ohio")])]), _vm._v(" "), _c('img', {
    staticClass: "img ",
    staticStyle: {
      "page-break-before": "always"
    },
    attrs: {
      "alt": "",
      "src": "images/img_13.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "img ",
    attrs: {
      "alt": "",
      "src": "images/img_46.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Caine-Hackman Theory.")]), _vm._v(" Every day of the week, twenty-four hours a day, it is possible to find a movie somewhere on cable TV starring either Michael Caine or Gene Hackman.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1R "
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Cited in the screenplay for ")]), _c('span', {
    staticClass: "moorbr"
  }, [_vm._v("PCU")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v(",  by ")]), _vm._v("Adam Leff "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and ")]), _vm._v("Zak Penn"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Camel, Slow-Moving.")]), _vm._v(" All camels in Middle Eastern thrillers are crossing the road for the sole purpose of slowing down a pursuit vehicle.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Camouflage Ramp Certainty Principle.")]), _vm._v(" During chase scenes, at least one car will hurtle over a vehicle ramp badly disguised as a normal part of the urban landscape. After flying into the air, the car will usually either strike something and implausibly explode (bad guys) or preposterously survive a landing which should rip the car’s suspension to shreds (good guys).")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Douglas M. Garrou, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Seattle")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Cape Fear ")]), _c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Syndrome.")]), _vm._v(" Derangement that causes heroines, upon learning they are in great danger, to go immediately to an isolated cabin (houseboat, sailboat in the harbor, farm) alone, knowing that no one, especially their friends, will be able to find them.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Charles Boos, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Evanston, Ill.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Caring Blanket Tuck-In.")]), _vm._v(" Effective in conveying the soft heart of an otherwise unappealing character (e.g., James Woods in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cop")]), _vm._v("). Also used in scenes involving the hero, usually as a set-up for a scene in which tucked-in child suddenly finds itself in great danger (e.g., Glenn Ford in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Big Heat")]), _vm._v(").")]), _vm._v(" "), _c('img', {
    staticClass: "img ",
    staticStyle: {
      "page-break-before": "always"
    },
    attrs: {
      "alt": "",
      "src": "images/img_14.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Tony Whitehouse, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Verbier, Switzerland")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Carl Owens Rooftop Spacer.")]), _vm._v(" Any male can accurately predict his ability to jump from one rooftop to another. Women jump and end up hanging from their fingernails and being yanked to safety by the guy who jumped seconds before.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Barak and Elizabeth Moore, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jerusalem, Israel")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Carphand Tunnel Syndrome.")]), _vm._v(" In the movies, hackers who type for upward of ten hours a day are unable to put text on their screens any faster than the average second-grader can read along.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Cartop Chases.")]), _vm._v(" When there is a foot chase in traffic, the hero will inevitably jump up on top of a car that is stuck in traffic, and leap from car to car, even though it would be faster and safer to stay on the ground (e.g., George Clooney in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Peacemaker")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Neil Gabriele, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Casting Is Destiny.")]), _vm._v(" Many Hollywood movies are shaped more by what the audience expects from their stars than by what their writers put into their scripts.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Rich Elias, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Delaware, Ohio")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Cat Sneeze Effect.")]), _vm._v(" In movies, when “silenced” guns are fired, they always make the same sound, resembling a cat sneezing. This is nothing like what any gun, silenced or otherwise, sounds like in real life. Also, no matter how big a gun freak a character is, he always refers to these guns as “silenced.” Gun experts in real life call them “suppressed.”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Raphael Carter, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tempe, Ariz.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Cemetery Weather.")]), _vm._v(" Cemeteries generate their own weather. In a surprisingly large number of scenes at cemeteries, particularly if a funeral is in progress, it is raining—and not just sprinkles, but biblical downpours.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("G. W. Roles, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Washington, D.C.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Centered Passenger Rule.")]), _vm._v(" When there is one passenger in the back seat of a car, he always sits right in the middle, to be more easily seen by the camera.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Centerfold Folly.")]), _vm._v(" With the exception of Marilyn Monroe, no actress who has appeared nude in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Playboy ")]), _vm._v("to advance her acting career has ever actually advanced her acting career.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Chain-Link Fence Rule.")]), _vm._v(" Every alley that the police chase a criminal down ends in a chain-link fence that the criminal climbs.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Kenneth C. Parkes")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Chamber Music.")]), _vm._v(" Hollywood cops in low-budget movies always show their intention to finally confront the villain by withdrawing their pistols and chambering a round. Since a cop is always supposed to be ready to fire his gun if needed, why do they carry them unchambered? Because it looks cool to stick in a round.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dawson Rambo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tucson, Ariz.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Chase-and-Crash Scenes.")]), _vm._v(" Replaces the third act or any other form of plot resolution in the modern thriller. After the hero has left dozens of burning cars and trucks behind him, we never see emergency vehicles responding to the carnage. Despite working under a Wrongheaded Commanding Officer, (q.v.), the hero cop is never called on the carpet because yesterday he drove his squad car through the walls of several warehouses.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Checker Cab Magnetism.")]), _vm._v(" Any character who calls for "), _c('br'), _vm._v("a cab in a New York movie will be picked up by an old-fashioned Checker cab, although they have not been manufactured in years and, at last count, there were only four still on the streets.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Amy Cash, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Elmont, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Checkmate Reflex.")]), _vm._v(" To quickly establish the hero (or villain) as a true (but erratic) genius, he will play a game of chess early in the movie, and quickly trash his opponent with a surprise mate-in-one (e.g., Jeff Goldblum in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Independence Day")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Ivar Laberg, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oslo, Norway")])]), _vm._v(" "), _c('img', {
    staticClass: "img ",
    staticStyle: {
      "page-break-before": "always"
    },
    attrs: {
      "alt": "",
      "src": "images/img_15.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Child of Sorrow Syndrome.")]), _vm._v(" When the hero, regretting the choices he’s made in life, returns home in defeat, his bitter self-indictment will be interrupted by his wife, who will say, “I’m having a baby.” See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mr. Holland’s Opus, It’s a Wonderful Life, ")]), _vm._v("etc.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jim Beckerman, "), _c('span', {
    staticClass: "city-state"
  }, [_vm._v("The Record,")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Hackensack, N.J.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Child Safety Rule.")]), _vm._v(" In any monster movie or disaster film, any child under the age of thirteen must survive. In rare instances where a child is killed, the death may not be shown directly.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Gerald Fitzgerald, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dallas, Tex.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Chinese Chase Rule.")]), _vm._v(" In any Asian city, or any city with a Chinatown, all chase scenes happen to occur on Chinese New Year, and lead directly through a parade.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Neil Milsted, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Chinese Takeaway.")]), _vm._v(" If any American action film of the last decade contains a particularly inventive stunt, there’s a better-than-even chance it was swiped from a Hong Kong action film the director recently saw on video.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Michael Schlesinger, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("VP for Acquisitions and "), _c('br'), _vm._v(" Repertory Sales, Sony Pictures, Culver City, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Chirping Computer Syndrome.")]), _vm._v(" Computers in movies always make little chirping sounds when characters hit the screen. Computers and terminals haven’t made noises like this since the days of the teletype.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Fred Cantwell, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ewing, N.J.")])]), _vm._v(" "), _c('img', {
    staticClass: "img ",
    staticStyle: {
      "page-break-before": "always"
    },
    attrs: {
      "alt": "",
      "src": "images/img_16.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Cinematic Business Pathology Syndrome (CBPS).")]), _vm._v(" Affliction that causes sociopathic or criminal behavior by officers of a corporation. Malady is characterized by several symptoms. Look for: (1) company located in a run-down building with a shiny new sign; (2) headquarters in a coldly contemporary building on a corporate campus devoid of people; (3) company sign is plain, rectangular, and flat, with unimaginative artwork; (4) company name includes words like “amalgamated,” “consolidated,” “-dyne,” “-tron,” or “chem”; (5) company name includes word “enterprises” following the name of a man who is bald, is fat, or smokes a cigar; (6) company premises are dilapidated while company’s owner rides in chauffeured limo.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Paul A. Lee, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Germantown, Wis.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Cinematic Ear Drum Phenomenon.")]), _vm._v(" When movie heroes get blown out of windows, across streets, into trees, etc., they can still hear just fine. In real life, instead of dialogue like “I’ll be back,” explosion survivors would be saying, “What? What? Speak up! I can’t hear you!”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Don Howard, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("San Jose, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Citizen’s Band Unbound.")]), _vm._v(" When two people in the movies talk over CB or walkie-talkies, they often interrupt each other in the middle of a sentence, as if they were talking on a telephone. This is impossible because the sets receive on the same frequency they broadcast on. See the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Die Hard ")]), _vm._v("movies.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Stephen Foote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Barnesboro, Pa.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Classic Car Rule.")]), _vm._v(" Whenever a beautiful classic car—usually the prized possession of an unsympathetic father—is introduced at the beginning of a film, that car will be wrecked by the end of it. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Risky Business, Ferris Bueller’s Day Off, Coupe de Ville, ")]), _vm._v("etc.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Cleanliness Is Next to Sexiness.")]), _vm._v(" Female characters never bathe or shower except in connection with sex, violence, or implied lesbianism.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Clean Up Movie.")]), _vm._v(" A motley crew of misfits can’t get their act together until a new teacher/coach/nun comes along and straightens them out. Suddenly, they’re the best class/"), _c('br'), _vm._v("team/choir around. Examples: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Summer School, Sister Act ")]), _vm._v("(both parts), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mr. Baseball, Kindergarten Cop, ")]), _vm._v("etc.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Steve Mycynek, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Des Plaines, Ill.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Cleopatra in the Commissary Phenomenon.")]), _vm._v(" In any movie about the movies, in any scene shot on a studio back lot, countless extras walk around in outrageous period costumes that haven’t been used in years, and recognizable historical figures like Cleopatra, Lincoln, and Napoleon are often seen lined up at the catering line for lunch. (E.g., the two Redcoats in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Get Shorty.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Greg Brown, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Clichéphobia.")]), _vm._v(" Condition afflicting people raised on movies. Symptoms arise when real life situations echo movie clichés, and sufferers must take action to avoid what would be the inevitable denouement in a movie. For example: After saying, “Hey, this is the most perfect day of my life,” the clichéphobic realizes that such a statement will mean he’s dead before the end of the reel. Or, when a last-minute seat unexpectedly opens up on a fully booked airline flight, the clichéphobic will become convinced that this means the plane is doomed to crash.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Michael Mates and Katherine Applegate,"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Sarasota, Fla.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("CLIDVIC (Climb from Despair to Victory).")]), _vm._v(" Formula for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rocky ")]), _vm._v("and all the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rocky ")]), _vm._v("rip-offs. Breaks plot into three parts: (1) defeat and despair; (2) rigorous training, usually shown in the form of would-be MTV videos; (3) victory, preferably ending in freeze-frame of triumphant hero.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Climbing Villain.")]), _vm._v(" Villains being chased at the end of a movie inevitably disregard all common sense and begin climbing up something—a staircase, a church tower, a mountain—thereby trapping themselves at the top.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Tony Whitehouse, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Verbier, Switzerland")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Clint Howard Scene.")]), _vm._v(" In any Ron Howard movie, the scene where his brother, Clint, makes one of his rare acting appearances (in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Backdraft ")]), _vm._v("as the medical examiner, in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Far and Away ")]), _vm._v("as the sweat shop foreman, etc.).")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dawson E. Rambo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pelham Manor, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Clothes Make the Impostor.")]), _vm._v(" Whenever a hit man has to kill someone in a guarded hospital room, he will duck into a linen closet, emerge wearing a lab coat and carrying a clipboard, and walk around the hospital as if invisible. None of the other doctors or nurses will notice that this guy has never worked there before.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Michael Furl, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kankakee, Ill.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Clunky Exposition Complex.")]), _vm._v(" Fills in vast amounts of background through awkward dialogue. (“You know Betty, we’ve been married now for five years, and you work in the bean canning factory. I of course have been farming now for all of my life, but despite that, we’re still pretty good detectives. I’m sure you remember the assassination of the president of the 4H Club.”)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Suzanne Boos, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Evanston, Ill.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Cocking Principle.")]), _vm._v(" When a weaker character is holding a gun on a stronger character who doesn’t believe the threat, the weaker character merely has to cock the gun, and the stronger character will back down. Especially effective when small or weak character has to use both hands to cock.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("David W. Smith, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westminister, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("COFKeyType (Computer Operation by Frenetic Keyboard Typing).")]), _vm._v(" In almost all movies involving the operation of computers, the user operates the machine by incongruent and frenetic banging on the keyboard, ignoring the mouse and system graphic interface elements. This results in instantaneous, nanosecond access and downloading of data. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jurassic Park, Disclosure.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Carlos Greene, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mexico City")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Coincidental Lighting.")]), _vm._v(" In any scene in a thriller involving a thunderstorm, when any character is looking for a pet or friend, there will be a deafening clap of thunder and a flash of lightning illuminating a corpse, or the murderer. If the character is searching for something, the lightning will illuminate the fact that the something is dramatically missing.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jim Lee, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cary, N.C.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Cole Rule, The.")]), _vm._v(" No movie made since 1977 containing a character with the first name “Cole” has been any good. (Exception: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Days of Thunder, ")]), _vm._v("which was good but not all that good.)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Collapsing Display Trick.")]), _vm._v(" Pull one can from a pyramid, and they all fall onto the floor. Used by directors who set a scene in a store, and have nothing of substance to achieve there.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Collapsing Staircase.")]), _vm._v(" When a character is rescued from a staircase during a disaster movie or thriller, the staircase always collapses the moment the rescue is completed.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Scot Murphy, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Highland Park, Ill.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Coming and Going Attraction.")]), _vm._v(" If you’ve seen the trailer, you’ve seen the movie.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Greg Brown, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Complimentary Dirt Rule.")]), _vm._v(" Explosions always enhance a star’s looks by placing just the right touch of dirt across the cheekbones—never on the end of the nose.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Brenda You, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Convenient Cat.")]), _vm._v(" Any time a good guy is being stealthy and knocks something over, alerting the bad guys, there will be a cat to take the rap. The guard will say, “Ahh, it was just the damned "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cat!")]), _vm._v("” Note that this even works in scenes where a cat has no business being in the first place, such as a museum or computer room.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Steve Wideman")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Cooperative Shooter Rule. ")]), _vm._v("No matter what kind of cover the hero hides behind, it will stop enemy bullets. In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beverly Hills Cop 3,")]), _vm._v(" Eddie Murphy uses a park bench for cover, and the bad guys shoot all the slats and none of the gaps.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Don Howard, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("San Jose, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Cooter Rule, The.")]), _vm._v(" When the young, good-looking hero goes back to his boyhood farmhouse, he’ll inevitably have a fight at the dinner table with an older, less-attractive brother. The fight is usually about abandoning the farm and “spitting on Daddy’s memory” or the hero’s annoying use of correct grammar. The hero storms out of the house and sits down on a fence in the backyard. He is followed by his sweet, long-suffering sister-in-law. She says, “Trap, you’re gonna have to forgive Cooter/Hunter/Trip/Billy Bob. He loves you. He don’t mean nothin’. It’s just his way, is all.”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Lisa Stansbury, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jacksonville, Fla.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Corrupt Sheriff Rule.")]), _vm._v(" All sheriffs who are not the heroes of their movies are corrupt, and in the employ of the largest landowner in the area. Exception: If the sheriff is not corrupt he will be dead by the end of the movie.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Joe DiCostanzo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York City")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("C. P. S. Rule.")]), _vm._v(" When a character drives somewhere in an overcrowded, gridlocked city such as L.A. or New York City, there is always a Convenient Parking Space directly in front of his destination.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("John Jakes, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hilton Head Island, S.C.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Crap Gap.")]), _vm._v(" The actor’s mouth moves but the sound of his voice saying a dirty word has disappeared (thus, often making it sound as though he has the hiccups). Also known as “Beep Bleep” and “Inanity Profanity.”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Creep Chord.")]), _vm._v(" The loud, discordant musical chord that is used in slasher movies to underline the moments, usually false alarms, when one character slips up behind another and scares him or her half to death. (Technical term: “Sting,” or “stinger.”)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Creeper’s Peepers.")]), _vm._v(" You can easily spot demonically possessed characters (or actual denizens of Hell) by their glowing red eyes. They seem to switch on involuntarily whenever the characters are alone, in shadow, thinking about how wonderfully evil they are.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Mark J. Wolmering, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("East Hartford, Conn.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Creeping Doorknob.")]), _vm._v(" Any time there is a close-up shot of a doorknob, it will start turning very slowly, and usually without being noticed by a room’s occupants—unless the occupants are trying to hide, in which case they will watch in horror as the knob turns.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Rick Newby, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("College Place, Wash.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Crime Sometimes Pays.")]), _vm._v(" Villains who outshine heroes are resurrected in sequels as quasi-good guys. Examples include King Kong, Godzilla, Jaws in the James Bond movies, the Terminator, and Rambo. Even more frightening: when villain become heroes by remaining villains (Freddie, Michael, and Jason).")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Crystal Sideboard Rule.")]), _vm._v(" In any movie featuring an older businessman married to a younger woman, if his home or office contains a sideboard with cut-crystal decanters of dark spirits, there is a 50 percent chance the wife will be dead or in jeopardy by the end of the movie. These odds increase to 75 percent if the husband is played by William Devane, and to 100 percent if the movie is a “cable original.”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dawson Rambo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tucson, Ariz.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "img ",
    attrs: {
      "alt": "",
      "src": "images/img_47.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Daddy’s Girl Rule.")]), _vm._v(" Whenever a lead character is engaged to a rich girl who is his boss’s daughter, by the end of the film he will have perpetrated a major screwup, lost his job, lost his fiancée, and gone off happily with somebody else.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Ian Mantgani, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Liverpool, England")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Dawning Light Moment.")]), _vm._v(" The words “So "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that’s ")]), _vm._v("what this is about!” in any movie invariably translate as, “you’re cheating on me with someone else!”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Deadly Change of Heart.")]), _vm._v(" When the cold heart of a villain softens and he turns into a good guy, the plot will quickly require him to be killed, usually after maudlin final words.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Dead Man Dancing.")]), _vm._v(" Whenever the bad guy in a movie is holding a “dead man” switch that will set off a bomb if let go, the good guy will wrestle him for it, and together they will perform spectacular fights, stunts, and other gymnastics, falling down stairs and rolling out of the way of gunfire. During all this time, the switch is never released.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Robert Epps, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Prather, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Dead Man Talking.")]), _vm._v(" A character who is dead before the end of the movie is still allowed to narrate the film, making you believe he survives, as long as it moves the story forward. (E.g., Joe Pesci in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Casino, ")]), _vm._v("William Holden in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sunset Boulevard.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Rhys Southan, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Richardson, Tex.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Dead Teenager Movie.")]), _vm._v(" Generic term for any movie primarily concerned with killing teenagers, without regard for logic, plot, performance, humor, etc. Often imitated, never worse than in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Friday the 13th ")]), _vm._v("sequels. Requires complete loss of common sense on the part of the characters. Sample dialogue: “All of our friends have been found horribly mutilated. It is midnight and we are miles from help. Hey, let’s take off our clothes, walk through the dark woods, and go skinny-dipping!”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Dead Werewolf Defense.")]), _vm._v(" In any horror film involving a human transforming into a monster, the hero never has to explain to the police the naked dead human body that is left after he has killed the monster. This despite the fact that no one in authority ever believes in the monster in the first place.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Joe DiCostanzo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York City")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Death is Wet.")]), _vm._v(" Every single morgue in a movie uses dripping or running water on the sound track.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Del Close’s Rule.")]), _vm._v(" Never share a foxhole with a character who carries a photo of his sweetheart.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Del Close, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Delta H of Crania.")]), _vm._v(" The factor in modern probability theory that accounts for the tendency of movie slot machines to pay off when smashed into headfirst by someone in a brawl. Can also be applied to actuarial systems involving jukeboxes that start playing appropriately ironic songs under similar conditions.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Denim Safety.")]), _vm._v(" Ingenious handgun safety mechanism which automatically engages itself when the weapon is jammed into the waistband of a pair of jeans and automatically disengages itself when the weapon is drawn and the muzzle is clear of the actor’s naughty bits.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Deserting before Dessert.")]), _vm._v(" No one finishes a meal in the movies. Meals are interrupted by important calls, the appearance of an ex-lover, or a trivial argument. No one eats more than two bites of a hot dog, cotton candy, popcorn. If dessert is served, it will end up in someone’s lap or dumped on his or her head. Only exception: STARVING MAN SCENE, which shows famished character polishing off the last speck of food, then placing his knife and fork on the plate to form an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("X.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote,"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Detour Rule.")]), _vm._v(" In any thriller, it is an absolute certainty that every road detour sign is a subterfuge to kidnap the occupants of a car. (Cf. Camel, Slow-Moving, “Hay Wagon!” etc.)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Devolution in Action.")]), _vm._v(" Problem caused when highly competent parents, able to dodge burning meteors, falling buildings, etc., risk their lives to save idiot offspring, who respond to danger by moving toward it, whining “daddy!” when they see they’ve caught fire. These parents should focus on keeping themselves alive in order to breed fitter offspring.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Mary Riley, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Dewey Decimal Dialogue.")]), _vm._v(" All conversations set in a library (1) involve at least one exchange between people standing on either side of a shelf and talking to each other through the stacks, and (2) always inspire at least one indignant “Shhhh!” from an elderly librarian. (2a) If a great many books must be carried anywhere in a character’s arms, they will be dropped with a loud noise.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Die Three Times Law.")]), _vm._v(" In modern movies it has become a law that the villain must die three times. First he gets killed—but isn’t really dead! Then he gets killed—but he’s still alive. Then he gets killed.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("David Burd, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("East Stroudsburg, Pa.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Difficult We Do Immediately, The.")]), _vm._v(" Usually happens in the middle of a movie, when the main characters build or repair something which would normally take weeks in about two minutes or less (example: refurbishing a boat which hasn’t left the dock in twenty years). See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Six Days, Seven Nights.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jim Simon, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Villa Park, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Dirt Equals Virtue.")]), _vm._v(" In technology movies, a small, dingy, cluttered little lab and eccentric personnel equal high principles; large, well-lighted facilities mask sinister motives. Paul A. Lee, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Germantown, Ohio")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Disappearing Nude.")]), _vm._v(" A woman seen nude in bed with the hero in the opening scene will never be seen again.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("David Stevens, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Irving, Tex.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Disbelief of Suspension.")]), _vm._v(" Rope and plank bridges are never shown in a film unless they are going to fail. Ropes will be cut, burned, or frayed. In the case of planks, someone’s foot will fall through the rotten wood.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Libby Webster, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Columbus, Ind.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Disclosing Whisper Law.")]), _vm._v(" If a character is looking for an object, and the audience doesn’t know what the object is, the character will mumble it out loud to himself as he frantically searches for it. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mission Impossible.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Rhys Southan, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Richardson, Tex.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Disconnection.")]), _vm._v(" Any character who says, “I can’t tell you over the phone . . .” doesn’t have long to live, and will die at the rendezvous: (a) without uttering a word, (b) mumbling a red herring, or (c) giving an obtuse clue (e.g., “Beware of the dwarf” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Foul Play")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Don Howard, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("San Jose, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Disney Ethical Exception.")]), _vm._v(" The bad guys or “the team to beat” can cheat and win any time except in the Big Game. Then, no matter how tiny the infraction, he/she/they will be disqualified for not following the rules. However, underdogs can cheat and win at any time and never be questioned. This is the Disney Ethical Exception, so called after all the Disney films where the incompetent but lovable underdogs win because of bizarre inventions "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Son of Flubber), ")]), _vm._v("freak accidents "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(The Computer Wore Tennis Shoes), ")]), _vm._v("supernatural powers "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(The Love Bug), ")]), _vm._v("or magical potions "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(The Strongest Man in the World).")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('img', {
    staticClass: "img ",
    staticStyle: {
      "page-break-before": "always"
    },
    attrs: {
      "alt": "",
      "src": "images/img_17.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Divine Dog Syndrome.")]), _vm._v(" In movies, humans are violently killed with impunity, but dogs are never killed. Thus, an alien race studying films would conclude that dogs are gods.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Paul Cassel")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Docudrama.")]), _vm._v(" TV term for extended-length program which stars a disease or social problem and costars performers willing to give interviews on how they experienced personal growth through their dramatic contact with same.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Dog Bites Man Rule.")]), _vm._v(" Whenever a character is asked to read an important story in a newspaper, he will inevitably provide a small laugh by reading the wrong story. In movies, no one is capable of scanning a headline and recognizing a story of personal consequence.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Paul N. Yerkey, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Amherst, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Doggone It Rule.")]), _vm._v(" Movies put dogs in stories and then don’t let them do what a real dog would do. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fatal Attraction, ")]), _vm._v("where Michael Douglas’s family owns a dog that is home during the noisy and gruesome bathtub scene but never comes sniffing around to investigate.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Mary Steinberg, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Don’t Just Save the Rain Forest—Recycle It!")]), _vm._v(" No matter what film you select from the classic Johnny Weismueller “Tarzan” series, one of these sequences will be present: (a) an elephant stampede or (b) Tarzan atop a gigantic crocodile, over thirty feet long, and spinning endlessly over and over as he repeatedly stabs it. These are literally the same sequences lifted in their entirety with new reaction shots of the protagonists dropped in later for continuity.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("David H. Coleman, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tarzana, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Don’t Leave Home without It.")]), _vm._v(" A child’s backpack invariably contains everything needed to survive most disasters, and is also a help in traveling back in time. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Kid in King Arthur’s Court ")]), _vm._v("and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Far from Home: Adventures of Yellow Dog.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Prillie Huls, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Joseph, Ill.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Don’t Make Me Smile and Reveal How I Really Feel Sequence.")]), _vm._v(" This is an obligatory scene in any movie where a man wants a woman to like him, and the woman thinks she might like him but isn’t sure, and the woman’s child already really likes the guy. Man and child are having fun together when mom comes to the door and says to the child, “Time for dinner.” Pause, then fake-sternly, “Now!”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Doomed Patient Dialogue.")]), _vm._v(" “Hey, wait a minute! You’re not my regular nurse!”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Kim Rotzoll, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Urbana, Ill.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Dorothy Lamour Syndrome.")]), _vm._v(" Token female character in a scene with two male leads is reduced to looking back and forth between the conversing males. Ms. Lamour had an excuse—Hope and Crosby were usually off the script. Often seen in movies back to the 1940s; in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("13 Rue Madeleine ")]), _vm._v("the primary action taken by the lone female spy is to look back and forth in confusion while the two male spies argue just before a parachute jump.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Lesa Campbell")]), _vm._v(" "), _c('img', {
    staticClass: "img ",
    staticStyle: {
      "page-break-before": "always"
    },
    attrs: {
      "alt": "",
      "src": "images/img_18.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Dossier Rule.")]), _vm._v(" In a movie where the villain is a rogue CIA/KGB/special forces agent, invariably there is a scene where one of the good guys pulls out a folder stamped “Top Secret.” The file contains a blurry photograph of the bad guy "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Apocalypse Now, Cliffhanger).")]), _vm._v(" Compare the “Slide Show Rule”—similar, except the head good guy has a magic lantern show, projects a blurry picture of the bad guy, and intones, “He’s a former member of the KGB/IRA/Red Brigade” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Nighthawks, In the Line of Fire).")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Chris Fisanick, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Barnesboro, Pa.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Double Step.")]), _vm._v(" In an extended dance scene or any other sequence in which a character must demonstrate professional skill, the absurdly simple opening move the actor learns for the close-up before they cut away to the highly trained double’s virtuoso performance.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Down Under Rule.")]), _vm._v(" No film set in Australia is allowed to use the word Australia in its title where “Down Under” is an acceptable alternative. For example, we don’t get "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Rescuers in Australia ")]), _vm._v("or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Quigley in Australia.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Stephen Rowley, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Melbourne, Australia")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Dramatic Late Arrival Shot.")]), _vm._v(" A talented kid has a mother who forbids her to perform. The kid goes on anyway. Just when she’s in the spotlight for her big number, the door opens at the back of the auditorium, and who walks in? The mother, of course, who in a later shot inevitably allows herself to relent, smile, and be proud of her kid after all.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("“Dr. Curie Will See You Now” Rule.")]), _vm._v(" Any time a character’s gender is not identified until we have had time to make an assumption, it will turn out to be of the opposite gender. For example, a macho motorcycle rider negotiates a series of obstacles, rides up to the camera, and removes his helmet only to reveal—gasp!—that “he” is a “she!”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Brian Jones")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Dressing Room Rule.")]), _vm._v(" In any scene where there is a dressing room in a store, the door or curtain will open to briefly reveal a secondary or supporting character, topless.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("David Stevens, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Irving, Tex.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Dr. Exposition, I Presume.")]), _vm._v(" All movie scientists who are neither the hero nor working for the bad guy are always doctors, and are, without fail, in the story only to present a crucial bit of information or explain some scientific concept to the hero, following which they are killed while doing further research on the problem.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Brannon Moore, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Seattle")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Duck Call Shortcut.")]), _vm._v(" All waterfowl in TV nature specials make the same sound, regardless of species. It is the sound of a hunter’s duck call, and is usually accompanied by the sound of fingers paddling around in water. No matter how much "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("National Geographic")]), _vm._v(" spends to take pictures of our planet’s thousands of duck species, they can’t bear to spend more than ten bucks on a sound effect.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Raphael Carter, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tempe, Ariz.")])]), _vm._v(" "), _c('img', {
    staticClass: "img ",
    staticStyle: {
      "page-break-before": "always"
    },
    attrs: {
      "alt": "",
      "src": "images/img_19.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Dude’s Landing.")]), _vm._v(" In any movie where greenhorn city folks arrive in rugged terrain, there is always a scene of a grizzled local old-timer, his eyes narrowed, watching them arrive. He wisely foresees what they’re in for.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "img ",
    attrs: {
      "alt": "",
      "src": "images/img_48.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ebert’s Three Laws of Motion Pictures")]), _c('span', {
    staticClass: "no-style-override-12"
  }, [_c('br'), _vm._v("1. A movie is not about what it is about, but about how it is about it. "), _c('br'), _vm._v("2. No good movie is too long. No bad movie is short"), _c('br'), _vm._v(" enough. "), _c('br'), _vm._v("3. No good movie is depressing. All bad movies are "), _c('br'), _vm._v(" depressing.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("8mm Omen.")]), _vm._v(" Films that start with old home movies are never about happy lives.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Ellipses Principle.")]), _vm._v(" Any film that combines reviewers’ quotes with ellipses can’t be any good. A review that says “This movie was . . . amazing” probably read “This movie was so awful it is amazing how it ever got made.” Reviews of three words or less (e.g., “Funny . . . ,” “What a movie . . .”) are especially cause for concern.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dave Kalin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("San Francisco")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Ellis’s Law.")]), _vm._v(" A single African-American or Italian in a cast of nonethnic people is usually a good guy. If a film contains more than four African-Americans or Italians in speaking roles, they’re all gang members. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lethal Weapon ")]), _vm._v("or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("My Cousin Vinny ")]), _vm._v("for positives, almost any other film for negatives.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Emergency Tour Guide.")]), _vm._v(" The person in every crowd at a disaster scene who fully extends an arm to point at the obvious thing that everyone is already looking at or running from. Example: The woman near the end of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Armageddon ")]), _vm._v("who points at the fireball in the sky that everyone on the whole planet is already watching.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Chris Jones, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Snellville, Ga.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Empathy Deficit Disorder.")]), _vm._v(" Affliction where film audiences can’t seem to understand that not every scene in which a character appears with a mental disorder is funny. See Dustin Hoffman in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rain Man ")]), _vm._v("and Richard Gere in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mr. Jones. ")]), _vm._v("The audiences I saw these movies with laughed from start to finish, thinking if the character was mentally ill and there was even one amusing scene, the entire movie was slapstick comedy.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Kathleen Wilson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Roanoke, Va.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Empty Box Syndrome.")]), _vm._v(" Any car in a chase approaching a wall of stacked boxes will not only invariably run into it, but will find that the boxes are empty and scatter impressively (which certainly wouldn’t happen if boxes labeled, say, “Air Conditioner” were actually full).")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Steven Raimi")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("End Credit Ratio.")]), _vm._v(" The longer the end credits are, the more money there was spent on special effects, and the less money there was spent on plot, characterization, and dialogue.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dawson E. Rambo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pelham Manor, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Ending, Giving Away the.")]), _vm._v(" Critics get hate mail from readers when they reveal too much about the endings of thrillers. Here is the ending of all thrillers: The bad guy gets killed.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Rich Elias, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Delaware, Ohio")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Engine Equalization Law.")]), _vm._v(" Movie phenomenon which allows large, lumbering Cadillac stretch limousines filled with bad guys to keep up with heroes in exotic sports cars. Edward Savio, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("San Francisco")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Ennui Warned You.")]), _vm._v(" If a critic uses the word “ennui” positively in a review of any foreign film, the film will be a pretentious bore, i.e., the collected works of Michelangelo Antonioni.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Estrogen Trinity.")]), _vm._v(" The Holy Female Trinity in tear-jerking dramas, consisting of: (1) the heroine, who is shy and unsure of her own power as a human being; (2) the mentor, who is brash and outspoken and helps heroine acquire those same qualities; and (3) the corpse, the mother/daughter/sister/friend who announces during dinner that she’s been diagnosed with a terminal illness and has less than three reels to live, who helps each of the others achieve perspective and maybe cop an Oscar for the funeral scene. Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Ethnic Defaults.")]), _vm._v(" All Asian people know karate. All Latin people dance salsa. Any Russian character is related to some ex-KGB agent now working for the new Russian Mafia.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Alexis S. Mendez, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aguadilla, Puerto Rico")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("E.T. Ratio.")]), _vm._v(" The more coverage "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Entertainment Tonight ")]), _vm._v("gives to a big stunt (such as the explosions in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lethal Weapon, Blown Away, ")]), _vm._v("and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Specialist, ")]), _vm._v("the fall in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Terminal Velocity, ")]), _vm._v("or any chase scene), the greater the likelihood the stunt will be the only thing in the film worth seeing.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Eventually Suspicious Unsuspecting Suspect.")]), _vm._v(" He doesn’t know anything, but they think he does. He’ll probably never know anything, but they abduct and interrogate him at gunpoint, so they can find out what he knows. He somehow escapes, and motivated by his terrifying experience, he eventually finds out not only what they thought he knew, but everything else.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Ryan Whitney, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Washington, D.C.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Everybody’s a Critic.")]), _vm._v(" Any painting, sculpture, tapestry, or other piece of artwork that receives more than one compliment from a supporting character (the more ridiculously effusive the better), or gets more than five seconds of uninterrupted screen time, or both, will be burned, slashed, shattered, defaced, or otherwise destroyed by the end of the film.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Brannon Moore, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Seattle")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("“Everyone’s Talking” Rule.")]), _vm._v(" If a movie ad portrays happy theater patrons exiting the movie and extolling the film’s virtues, the movie itself will invariably be terrible.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Douglas M. Garrou, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Seattle")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Evil Corporation Rule.")]), _vm._v(" Whenever a crusading movie character of extreme moral virtue uncovers a plot by an evil corporation to endanger public health for the sake of greed, the security department of this corporation will always have its own team of staff assassins who will use a black sedan to chase the hero in an assassination attempt.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Tim Benton, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Huntsville, Ala.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Explosion ESP.")]), _vm._v(" The characters always know whether the crashed and smoldering vehicle they are in will explode. If they don’t get out and run, it won’t explode. If they do, it does.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Kyle L. Cain, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sugar Land, Tex.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Explosion Loop.")]), _vm._v(" Every explosion is shown at least three times, from three different angles, and the sound track has three “booms” on it, even though it’s only one explosion.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Don Howard, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("San Jose, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("EZ Open Gift Rule.")]), _vm._v(" Any time a gift-wrapped present is unwrapped in a movie, it’s always easily opened by lifting a separately wrapped lid.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Kyle L. Cain, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sugar Land, Tex.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "img ",
    attrs: {
      "alt": "",
      "src": "images/img_49.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Factory Confrontation (similar to the Far-Off Rattle Movie).")]), _vm._v(" The final battle between the hero and the villain must take place in a factory or stockyard, preferably one with lots of heavy machinery or fire or molten materials. Examples include the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("RoboCop, Lethal Weapon, ")]), _vm._v("and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Terminator ")]), _vm._v("pictures.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dave Kalin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("San Francisco")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Fallacy of Elaborate Death Techniques.")]), _vm._v(" Any method of attempting to kill someone in a movie that is more complicated than shooting, beating, strangling, etc., will inevitably fail. (Cf. James Bond’s many escapes.)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Steve Horne")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Fallacy of the Beeping Radar.")]), _vm._v(" In every movie wherein a radar scope is shown, when the sweep passes over the target of interest, the radar beeps. Radar screens don’t beep. Not now, not ever.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Grant Sigsworth, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("San Diego, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Fallacy of the Predictable Tree.")]), _vm._v(" The logical error committed every time the good guy is able to predict exactly what the bad guy is going to do. For example, in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("First Blood, ")]), _vm._v("law enforcement officials are searching the woods for John Rambo. A cop pauses under a tree. Rambo drops on him. Question: Out of all the trees in the forest, how did Rambo know which one the guy would pause under?")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Fallacy of the Talking Killer.")]), _vm._v(" The villain wants to kill the hero. He has him cornered at gunpoint. All he has to do is pull the trigger. But he always talks first. He explains the hero’s mistakes to him. Jeers. Laughs. And gives the hero time to think his way out of the situation, or be rescued by his buddy. (Cf. most James Bond movies.)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Gene Siskel")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Falling Chess Board Phenomenon.")]), _vm._v(" In any movie about a chess fanatic, the chess board that is perpetually set up in his office will always get knocked over by the end of the movie.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Doug Fletcher, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mesa, Ariz.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Falling Death Scream Rule.")]), _vm._v(" Any character falling to his or her death must scream on the way down, especially if he or she is a villain. If no scream is heard, chances are the character survives the fall.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Gerald Fitzgerald, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dallas")])]), _vm._v(" "), _c('img', {
    staticClass: "img ",
    staticStyle: {
      "page-break-before": "always"
    },
    attrs: {
      "alt": "",
      "src": "images/img_20.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Falling Villain, The.")]), _vm._v(" At the end of virtually every action-adventure movie, the villain must fall from a great height onto a hard surface. If possible, the villain should crash backward through a plate-glass window and land on an automobile.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Stephen D. Dargitz, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ann Arbor, Mich.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("False Relaxation Reflex.")]), _vm._v(" If the film’s top villain places his hand on a henchman’s shoulder (very important) and tells him not to worry about having screwed up, the henchman will be dead in less than a minute of screen time.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jason Moore")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Far-Off Rattle Movies.")]), _vm._v(" Movies in which the climactic scene is shot in a deserted warehouse, where far-off rattles punctuate the silence.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Fast Food Rule.")]), _vm._v(" Wanna know what the summer’s blockbuster is going to be? See who McDonald’s does the marketing tie-in with. Wanna know what blockbuster will do disappointing business? See who Burger King ties in with.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dawson E. Rambo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pelham Manor, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Fatal Basic Attraction Instinct Genre.")]), _vm._v(" Movies about sex between bad people who live in good houses.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Fat Man Formula.")]), _vm._v(" In all movies where groups of men live together, it is always the fat one who cannot be trusted. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("No Escape.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Feedback Rule.")]), _vm._v(" Every time anyone uses a microphone in a movie, it feeds back.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Arden J. Cooper, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Warren, Mich.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Feline Fright.")]), _vm._v(" When a movie hero/heroine is wandering down any dark and deserted alley, he/she will inevitably be frightened by a cat before encountering the villain.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dave Kalin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("San Francisco")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Female Shoot and Cry Rule.")]), _vm._v(" Except in movies where the lead is a tough female, any female character who shoots the bad guy for any reason will then drop the gun, bend at the knees, and start sobbing.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Greg Barnard")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Female Star in a Topless Bar Rule.")]), _vm._v(" If a movie has a scene in a topless bar, the film’s female star will never be seen nude in the movie, unless she is a topless dancer.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("David Stevens, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Irving, Tex.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Female Voice of Destruction.")]), _vm._v(" If the auto-destruction feature is activated at a secret base or spaceship, the countdown is always announced by a female voice. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aliens, Sphere, ")]), _vm._v("James Bond movies, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Alexis S. Mendez, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aguadilla, Puerto Rico")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Fifty-five-gallon Drum Rule.")]), _vm._v(" Fifty-five-gallon drums are a culturally rooted symbol of evil, because they usually contain a substance with a long name that we can’t identify. The more drums, the more evil.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Paul A. Lee, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Germantown, Wis.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Fireball Law of Physics.")]), _vm._v(" “The speed of an expanding fireball is in direct relation to the running speed of the slowest major star moving away from the fireball. If FS = Fireball Speed, and RS = Running Star, therefore (FS = [RS × 9]). Since fireballs have actually been slowing down recently to accommodate slower stars, even "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Grumpiest Old Men")]), _vm._v(" may be able to work in a fireball.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Ed Dobeas and Kristen Kirkham, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Seattle")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("First Law of Alien Contact.")]), _vm._v(" They send signals to our huge radio antennae only on cloudless nights. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Contact, Species.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Patrick Suarez, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Springfield, Ohio")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("First Law of Funny Names.")]), _vm._v(" No names are funny unless used by W. C. Fields or Groucho Marx. Funny names, in general, are a sign of desperation at the screenplay level. (E.g., “Dr. Hfuhruhurr” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Man With Two Brains")]), _vm._v(".)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("First Rule of Repetition of Names.")]), _vm._v(" When the same names are repeated in a movie more than four times a minute for more than three minutes in a row, the audience breaks out into sarcastic laughter, and some of the ruder members are likely to start shouting “Kirsty!” and “Tiffany!” at the screen. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hellbound: Hellraiser II")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("First Rule of Whodunits.")]), _vm._v(" In any murder mystery, the murderer is probably the person who offers the most assistance in finding the killer.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Gerald Fitzgerald, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dallas")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("First Time’s the Charm.")]), _vm._v(" Ninety-nine percent of sex scenes show couples coupling for the first time.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Nigel Searle, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Venice, Fla.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Five Minute Class, The.")]), _vm._v(" No scene showing a class in session ever lasts more than five minutes. Even the most stimulating session is invariably interrupted by the bell.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dennis Ward")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Flint Content in Metal.")]), _vm._v(" During sword fights, showers of sparks are produced whenever the weapons clang into each other.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Mark J. Wolmering, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("East Hartford, Conn.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Floating Luggage.")]), _vm._v(" In every scene where actors carry luggage, the luggage is obviously empty. They attempt, with pained expressions on their faces, to pretend the bags are heavy, and yet they can flick them around like feathers.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Tom Kirkpatrick, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Flying Felines of Fear.")]), _vm._v(" Inevitably appearing in every Dead Teenager Movie since the dawn of time, some hapless victim is scared witless by the sudden appearance of a cat which has apparently been flung at the actor by some off-camera stagehand.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Bret Hayden, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Los Angeles")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("“Food Fight!”")]), _vm._v(" Dialogue which replaced “Westward ho!” as American movies ended the long frontier trek and began to look inward for sources of inspiration.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Footlocker Scene.")]), _vm._v(" In many action movies, there’s a scene toward the end where the hero digs into a dusty footlocker. Inside are: (a) yellowing photographs of the hero and his buddies in the last “unpopular” war; (b) old camouflage uniforms; (c) medals awarded for valor, still in their presentation boxes; and (d) an exotic weapon that is illegal in most states, which the hero grimly begins to assemble.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dawson Rambo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tucson, Ariz.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Four Glass Movie.")]), _vm._v(" Any movie with a plot that can be summarized on four souvenir soft drink containers from McDonald’s. See also “Fast Food Rule.”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Four-Letter Rating Upgrade.")]), _vm._v(" Practice of inserting totally gratuitous obscenities into otherwise clean-cut family films in order to avoid the dreaded “G” rating. Classic example: “Penis breath” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("E.T.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Fourth Out, The.")]), _vm._v(" Anyone displaying an extremely rare baseball card will, within three minutes, see it lost, stolen, torn up, burned, or otherwise destroyed. Similarly, any valuable objet d’art made of flammable or breakable material is likewise doomed. (A resourceful filmmaker can drag this out into an entire feature, e.g., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bean")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Michael Schlesinger, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Culver City, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Four-to-Three Keyboard Rule.")]), _vm._v(" When the camera is focused on a computer screen, it takes four keyboard clicks to produce every three characters.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jim Collier, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dallas")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Fractured Festivities.")]), _vm._v(" The character called upon to save the nation from a terrorist threat will be summoned from his grade-schooler’s birthday party. And at least one other government official will be attending a formal social function when he’s called to the situation room, ensuring that he’ll be wearing evening clothes for the rest of the movie. Trisha Johnston, ")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Walnut Creek, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Friendly Fire Tabu.")]), _vm._v(" Inevitably, in an action film, a situation will arise where the protagonist almost shoots his partner or is nearly shot by him. Of course, the trigger is never pulled, and the target is recognized as “friendly” just milliseconds before firing, even though visibility is poor, the partner appears on the scene totally unexpected and possibly in disguise, and is pointing a loaded gun! Typically, the two parties have some personal beef with one another that won’t be resolved until a later scene.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Robert Bemben, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ann Arbor, Mich.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Friendly Neighborhood Skies Syndrome.")]), _vm._v(" In “test pilot” films, the fatal crash of the experimental aircraft that occurs in the last reel is always on the aircraft’s home field—and no more than 500 yards from the observation point where the pilot’s girlfriend is watching.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Richard Kunz, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Front Row Formula.")]), _vm._v(" The character playing the leading role in a movie always stands in front of a group of people, for example in an aerobics lesson.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Bob Lefevere")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Frozen Family Phenomenon.")]), _vm._v(" Applies to movies such as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Homeward Bound,")]), _vm._v(" in which the family has lost a minimum of three pets. Family stands looking toward the hill as they think they hear barking. One pet comes over the hill. No one moves. Instead of running toward the hilltop to see if the next pet will appear, the family remains motionless as the second pet arrives. Then family remains frozen until, after suspenseful delay, finally the third pet appears. Arrival of third pet gives permission for family to leap into motion.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Linda Tillman, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Atlanta")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("“Fruit Cart!”")]), _vm._v(" An expletive used by knowledgeable film buffs during any chase scene involving a foreign or ethnic locale, reflecting their certainty that a fruit cart will be overturned during the chase, and an angry peddler will run into the middle of the street to shake his fist at the hero’s departing vehicle.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("“Fruit Cart!” (James Bond Variation).")]), _vm._v(" In Bond movies, chase scenes not only upset applecarts, but Agent 007 also invariably plows whatever vehicle he is piloting through the buffet table at an outdoor wedding reception. This is a commentary of Bond’s attitude toward monogamy (at least until "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Licence to Kill, ")]), _vm._v("when a chase scene ends with Bond parachuting into a DEA agent’s wedding to serve as best man.)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Anthony Bruce Gilpin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Riverside, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Fudd Flag.")]), _vm._v(" In the background field of an animated cartoon, the one slightly differently painted object (floorboard, cupboard door, rock) among a dozen otherwise identical background objects. This is so Bugs Bunny will know which floorboard his rabbit hole is under, Tom will know which cupboard he’ll have to open in order to be bludgeoned by Jerry with a frying pan, and Wile E. Coyote can unerringly choose to cling to the most break-offable piece of rock on the cliff face.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Futile Hug Syndrome.")]), _vm._v(" If it’s “next morning” and there’s a close shot of a person in bed asleep, he or she will wake up, and turn with arm outstretched as if to hug the person lying there, but will always find an empty space, as his or her partner has been up hours fixing breakfast/taking the dog out/exercising/being murdered.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Michelle Mendoza, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chalfont St. Giles, Bucks, England")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "img ",
    attrs: {
      "alt": "",
      "src": "images/img_50.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Gandhi Movie.")]), _vm._v(" Any film which is undeniably good, perhaps great, but once you’ve seen it, there is absolutely no reason to ever want to see it again. Examples: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gandhi, The Last Emperor, A Passage to India, ")]), _vm._v("long documentaries about the Holocaust, most of the French New Wave, all underground art films of the 1960s, the lesser works of Bergman and Antonioni, and Woody Allen’s “serious” movies.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Geek Ego Effect.")]), _vm._v(" Exemplified by the Dennis Nedry character in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jurassic Park, ")]), _vm._v("this describes the maniacal behavior of the mandatory nerd with thick glasses, pocket protector, and an I’ll-get-even-with-the-rest-of-the-world-for-not-taking-me-seriously attitude.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Fred Decker")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Gender Offender Temporal Paradox. ")]), _vm._v("In films set in the present, male characters act like they’re from several eras in the past and get punched out by women afterward as a direct result. In films set several eras in the past, female characters act like they’re from the present but never get punched out afterward as a direct result.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('img', {
    staticClass: "img ",
    staticStyle: {
      "page-break-before": "always"
    },
    attrs: {
      "alt": "",
      "src": "images/img_21.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Generation Squeeze.")]), _vm._v(" Hollywood genre which tries to bridge the generation gap by creating movies which will appeal to teenagers at the box office and to adults at the video rental counter. Typical plot device: An adult becomes a teenager, or vice versa (cf. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Like Father, Like Son; Hiding Out; Peggy Sue Got Married; Vice Versa; 18 Again; Big")]), _vm._v("). Also sometimes masquerades as a movie apparently about adults, but with young actors in the “adult” roles (cf. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("No Man’s Land, The Big Town")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Generic Drinker Syndrome.")]), _vm._v(" Characters in movies always order “beer.” As a bartender, I have observed that people never just order “beer.” They always call their beer. Movie characters frequently take a small sip and then leave without finishing their drinks or paying for them (occasionally one character will throw some uncounted bills on the table). In real life, people suddenly called away from the bar take time to upend their glass and greedily suck down whatever is left.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Lauri Jackson-Sickler, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Edmonds, Wash.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Gentleman Villain.")]), _vm._v(" Any head of a large organization who speaks with perfect, condescending diction and wears elegant, custom-fitted suits is the villain.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("G. W. Roles, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Washington, D.C.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Ghost-Repellent Realtors.")]), _vm._v(" Even though ghosts desperately want to keep anyone from occupying the houses they haunt, they never bother to show up until the new owners have signed on the dotted line. Since rattling chains during the Open House would save them a lot of trouble, it is obvious that ghosts are repelled by real-estate agents.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Raphael Carter, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tempe, Ariz.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Gibson’s Inverse Coefficient of Gravity.")]), _vm._v(" Force of nature which affects firearms of good guys as they scale tall buildings. Force grows geometrically greater the higher up the good guy is, eventually causing firearm to fall irretrievably from his grasp when he needs it most. (Fun Fact: This force generates a powerful visual aura, causing good guy to waste precious time watching firearm fall all the way to the ground while he’s in immediate peril.)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Give Me Some Feedback.")]), _vm._v(" Whenever an inexperienced or reluctant public speaker steps up to the microphone, he is greeted with a shrill blast of feedback when he begins to speak.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Bobby Skafish, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Glowing Dashboard Phenomenon.")]), _vm._v(" Everyone in the movies who drives a car at night has a bright light somewhere on the dashboard that’s aimed at his or her face. No wonder people drive so wildly in films: They can’t see!")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Gordon Hammerle, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Adrian College, Adrian, Mich.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Go Ahead and Jump.")]), _vm._v(" That big fall will never kill the hero. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Butch Cassidy and the Sundance Kid, Lethal Weapon, Last of the Mohicans, The Fugitive, Ravenous.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Christopher M. Terry, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Atlanta, Ga.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Godot Movie.")]), _vm._v(" Movie in which the producers think that if they just put some big-name comic actors in an oddball situation, something funny is bound to happen eventually (e.g., Robin Williams, Whoopi Goldberg, and Bette Midler as space pirates!). The audience sits through the whole production waiting for laughs that never come.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Good Bad Guy.")]), _vm._v(" Crook you are allowed to root for only because this is his last job, after which he will either retire or establish the restaurant of his dreams.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Alexis S. Mendez, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aguadilla, Puerto Rico")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Gotham Sentence.")]), _vm._v(" When a character learns the hero’s secret identity, one of two standard movie punishments will result: (a) death or (b) sex with the hero.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Grace Under Fire Principle.")]), _vm._v(" Any female character who claims to abhor violence will, during the film’s conclusion, shoot the bad guy who has the drop on her boyfriend/"), _c('br'), _vm._v("husband. After firing, she must hold the gun up in her trembling hand for two seconds or until her man takes it from her without so much as a “thank you.” Named for Grace Kelly in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("High Noon.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Christopher M. Terry, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Atlanta, Ga.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Gradually Gathering Guffaw.")]), _vm._v(" The setup: A bad guy, surrounded by henchmen, is confronted by the hero, who insolently insults him. There is a pregnant pause, during which instant violence seems likely. Cut to: the villain, who pauses for two beats, and then laughs. Cut to: his top henchman, who glances at the boss, waits two more beats, and then laughs too. Cut to: all the other bad guys, joining in the laughter. (Alternate close: The villain cuts his laugh short and inflicts unexpected pain upon either the good guy or one of his own henchmen.)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Grafik Artz.")]), _vm._v(" Banner, sign, or any other handmade drawing which purportedly has been made by untrained hands but which obviously was the expensive work of professional artists. Use of Grafik Artz is usually betrayed by the perfect lines, circles, and randomly reversed letters in a child’s drawing, or a picket sign at an “impromptu” grassroots rally which is silkscreened in two-color Dom Casual.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Grave Talk.")]), _vm._v(" Handy screenwriter’s tool where a character can reveal his personality and motivation by explaining everything to a tombstone.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Phil Heink, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lexington, Ky.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Great Eggs-Pectations.")]), _vm._v(" In old movies, after suffering through an ordeal, the heroine invariably suggests breakfast. The subject of eggs will naturally arise. If the heroine offers the hero cold eggs (i.e., an egg salad sandwich), there will be no sex now, but maybe later. If she offers to just “cook” or “fix” a couple of eggs, romance is likely. Fried eggs (sizzling and sunny-side up) means casual sex. Scrambled eggs means “watch out!” If omelets are mentioned, marriage or a long-term relationship is in the offing. If he offers to prepare the eggs, a commitment has been made.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Grenades Choose Sides.")]), _vm._v(" When a hand grenade falls near a good guy, he is able to: (a) pick it up before it detonates and throw it back to the issuing bad guy, or (b) run and leap out of the path of exploding shrapnel, usually in slow motion. But when a bad guy is on the receiving end of a grenade, all he can muster is a shocked expression before being blown to bits.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Neil Martin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dartmouth, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Grim Reaping.")]), _vm._v(" Involuntary and unconscious act of counting up the cast members in old movies who are no longer alive. For instance, seeing "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gone With the Wind ")]), _vm._v("and reflecting that everybody in it is dead except for Butterfly McQueen. Particularly distracting if you think Butterfly McQueen might have died too.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Group Therapy Movie.")]), _vm._v(" Characters are trapped in close quarters to squeeze several years of intensive psychotherapy into a few hours of arguing, partying, or violence. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Big Chill, The Breakfast Club, The Men’s Club, The Women, Steaming, Streamers, The Boys in the Band, Who’s Afraid of Virginia Woolf?, Glengarry Glen Ross, Long Day’s Journey into Night, ")]), _vm._v("etc.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Gullible Entendre.")]), _vm._v(" Scene where the audience is expected to believe that two characters can carry on an entire conversation where one thinks they’re discussing something like mathematics or banking, but the other thinks they’re discussing sex. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Milk Money, Frozen Assets, ")]), _vm._v("reruns of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Three’s Company.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Christopher P. Nicholson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sterling, Va.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("GUNDAN Movie.")]), _vm._v(" Any movie that Goes Nowhere and Does Nothing. Named in honor of the many pipes and conduits in starships on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Star Trek, ")]), _vm._v("which have official-looking technical labels reading “GNDN.” This is an in-joke; when the set designer was asked where those conduits were supposed to lead and what their functions were, he responded that they Go Nowhere and Do Nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Gun Disposal Rule.")]), _vm._v(" The character pulls the trigger, but the gun only clicks, because it’s empty. So, the character throws it away. Obviously, it will never be needed again. "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Explained by")]), _vm._v(" Jim Jarmusch"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" in ")]), _c('span', {
    staticClass: "city-state"
  }, [_vm._v("Blue in the Face.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "img ",
    attrs: {
      "alt": "",
      "src": "images/img_51.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Haircut Hierarchy Rule.")]), _vm._v(" The main character in a movie centering around the military or prison never has the same severe crew cut that the other characters have, even though there is usually the obligatory haircut scene (e.g., Matthew Broderick in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Biloxi Blues, ")]), _vm._v("Tom Cruise in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Top Gun, ")]), _vm._v("Robert Redford in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Brubaker")]), _vm._v("). See also “Barber’s Itch Rule.”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jim Racheff")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Half Nude Rule.")]), _vm._v(" People in movies "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("always ")]), _vm._v("undress from the top down. Especially women.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Bill Becwar, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wauwatosa, Wis.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Hand-in-Hand Rule.")]), _vm._v(" In many Hollywood action pictures, the woman characters are incapable of fleeing from danger unless dragged by a strong man, who takes the woman’s hand and pulls her along meekly behind him. This convention is so strong it appears even in films where it makes no sense, such as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sheena, ")]), _vm._v("in which a jungle-woman who has ruled the savage beasts since infancy is pulled along by a TV anchorman fresh off the plane.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Hangman’s Eye View.")]), _vm._v(" When someone is going to be hung, the shot will start with a view of the crowd, then zoom back to show that the audience is looking through the noose hanging on the scaffold. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Robin Hood, Prince of Thieves.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Michael P. Faeth")]), _vm._v(" "), _c('img', {
    staticClass: "img ",
    staticStyle: {
      "page-break-before": "always"
    },
    attrs: {
      "alt": "",
      "src": "images/img_22.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Hans Zimmer Rides Again.")]), _vm._v(" An astonishingly high percentage of music in movie trailers feature Hans Zimmer’s scores from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Backdraft ")]), _vm._v("or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Crimson Tide.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Will Griffin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bristol, England")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Hardest Word in the English Language.")]), _vm._v(" No matter how well a foreigner speaks English, he will never be able to master “yes,” and will invariably be forced to rely on its equivalent in his native tongue.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Emo Phillips, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Harrison Door.")]), _vm._v(" Special automated door or barrier, ostensibly designed for high security but which nonetheless moves into place slowly and methodically instead of swiftly and efficiently, thus allowing the escape of celebrities. Harrison Doors are equipped with special sensors triggered by personal charisma, which explains how the hero of a picture set on a crippled undersea vessel manages to squeak past the automatically closing emergency watertight hatch while his comrades drown just behind him. (Named for Harrison Ford, who, whether in danger of being trapped by a thousand-year-old stone door fifty years ago in South America or by a set of bulletproof doors today in Chicago, has always been its single biggest beneficiary.)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Harrison Ford Situational Reassessment Doubletake.")]), _vm._v(" Scene where Harrison Ford chases a small number of bad guys. He then stops suddenly, his expression changes to one of shock, and he runs back the way he came, as we see that the bad guys have been joined by a large number of reinforcements. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Star Wars, Indiana Jones and the Temple of Doom.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jeff Cross, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Marblehead, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("“Hay Wagon!” Rural Version of “Fruit Cart!” (q.v.).")]), _vm._v(" At the beginning of chase scenes through colorful ethnic locales, knowledgeable film buffs anticipate the inevitable scene in which the speeding sports car will get stuck on a narrow country lane behind a wagon overloaded with hay.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Head Butt Rule.")]), _vm._v(" Whenever a head butt is delivered in a movie, the receiver of the butt is sent reeling into a semiconscious stagger with all manner of hideous facial contusions, while the deliverer of the butt doesn’t even wince, even though his own head has just received an identical impact.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Tim Benton, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Huntsville, Ala.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Heads Up Rule.")]), _vm._v(" Whenever a long-lost or secret grave site is discovered and exposed (the final scoops done by hand), the skull is always the first thing uncovered. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Twilight.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Robert Haynes-Peterson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Helmet Hair.")]), _vm._v(" No woman in the movies ever puts up her hair before donning a motorcycle helmet, and yet when she removes the helmet, her inevitably long hair is not sweaty or tangled, but always perfectly styled.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Alessandra Kelley, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Hero Cop Identification Rule.")]), _vm._v(" In low-budget direct-to-video and cable movies, if you don’t recognize any of the names of the actors in the opening credits, here’s how to find the hero of the movie in the first few scenes. If there’s an establishing shot of the bullpen or squad room, the hero is the one dressed in jeans, cowboy boots, and a leather bomber jacket, while all the other cops are in suits and ties. An even quicker way to identify the hero: He hasn’t shaved in three days.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dawson Rambo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pelham Manor, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Hey! Cody! Rule.")]), _vm._v(" Bad guy has drop on good guy. Can pull trigger and kill him. Inevitably shouts, “Hey! Cody!” (fill in name of good guy), after which good guy whirls, sees him, and shoots him first.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Hollywood Car.")]), _vm._v(" Looks like a normal automobile, but backfires after being purchased from used car lot by movie heroine who is starting out again in life and is on her own this time.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Hollywood Cigarette.")]), _vm._v(" In action thrillers where the hero smokes, he only lights one up to snap it angrily away after one or two puffs. Examples: Bruce Willis in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Last Boy Scout ")]), _vm._v("and Nick Nolte in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("48 HRS ")]), _vm._v("and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Another 48 HRS, ")]), _vm._v("among countless others.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dawson E. Rambo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pelham Manor, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Hollywood Cop Car.")]), _vm._v(" Driven by the slovenly member of the team in all police versions of the Opposites in Collision plot. Always unspeakably filthy, dented, rusty, and containing all of the cop’s possessions in the back seat, as well as several weeks’ worth of fast-food wrappers. Usually, but not necessarily, some kind of distinctive make or model (Gremlin, old Ford woody wagon, beat-up Caddy convertible, 4 × 4 van, etc.).")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Hollywood Flavor of the Month.")]), _vm._v(" Compulsion by studios to cast the hottest actor of the moment in a coveted role, regardless of whether the actor conforms to the look or style the original author had in mind for the character. (Example: In Avery Corman’s novel "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oh God! ")]), _vm._v("the hero is a paunchy, balding, middle-aged Jewish freelance reporter from New York City. In the movie, this character is turned into a WASP supermarket employee from Long Beach, Calif., played by John Denver.)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Anthony Bruce Gilpin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Riverside, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Hollywood Grocery Bags.")]), _vm._v(" Whenever a scared, cynical woman who never wants to fall in love again is pursued by an ardent suitor who wants to breach her wall of loneliness, she will go grocery shopping. Her bags will always break to (1) symbolize the mess her life is in, or (2) so that the suitor can help her pick up the pieces of her life and her oranges.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Cindy L. Cup Choy, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Honolulu, Hawaii")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Hollywood Hospital.")]), _vm._v(" Where people go to die. Victim checks in, doesn’t check out, because screen time is too valuable for characters to go into the hospital only to recover a few scenes later. Dialogue clue: When any seemingly able-bodied character uses the word “doctor,” especially in a telephone conversation not intended to be overheard, he or she will be dead before the end of the film.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Gene Siskel")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Hollywood Strip Club.")]), _vm._v(" Strip clubs in the movies always feature women who have recently appeared in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Playboy. ")]), _vm._v("They also always feature cages, and the dancers perform elaborate dances complete with costumes, props, and associated thematic music. In reality, most strippers are not ex-"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Playboy ")]), _vm._v("models, wear cheap lingerie, and dance listlessly to the same twenty heavy-metal songs while sneering at the patrons for loose dollars.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dawson Rambo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pelham Manor, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Hollywood Television.")]), _vm._v(" When a TV is part of the set dressing, but is not integral to the plot, the chances are good that it will be playing a Western in black and white, just before or during the cavalry charge, complete with Indian war cries and bugles. The chances of this being true approach 100 percent if (a) the character watching the TV is a cop, and (b) he or she is waking up at three in the morning, following a drunken binge after losing his or her partner, badge, wife/husband, or all of the above.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dawson E. Rambo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pelham Manor, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Honor Code Rule.")]), _vm._v(" In any movie set in either a military academy or a prep school, if the school’s “Honor Code” is mentioned within five minutes of the opening credits, it is required that the hero will have to violate the code, motivated by a higher morality, and then: (a) The school officials will begin proceedings to expel the hero; (b) his friends will all look guiltily the other way; (c) the school will come to see the hero’s point of view; or (d) his friends will come to his support. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Lords of Discipline, School Ties, Taps, Scent of a Woman, ")]), _vm._v("etc. ")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Dawson E. Rambo, Pelham Manor, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Horny Teenager Movie.")]), _vm._v(" Any film primarily concerned with teenage sexual hungers, usually male. Replaced, to a degree, by Dead Teenager Movies (q.v.), but always popular with middle-aged movie executives, who like to explain to their seventeen-year-old starlets why the logic of the dramatic situation and the teachings of Strasberg require them to remove their brassieres. (Cf. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blame It on Rio, She’s Out of Control.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Hot Dog Rule.")]), _vm._v(" Whenever one or more police officers stop for a bite to eat, usually at a hot dog stand or greasy spoon diner, a crime is about to be committed. The officer never gets to take more than one bite of his sandwich before dropping it to pursue the suspect.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("John Angelo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Hot Justice Syndrome.")]), _vm._v(" All trials that are held south of the Mason-Dixon Line take place during the summer in a non–air-conditioned courtroom filled with people airing themselves with fans from a funeral home. Heroic lawyer always mops neck with big white handkerchief. Slimy defense attorney never sweats.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Buck, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Farmington, Conn.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Hot Tub Rules.")]), _vm._v(" If a hot tub is seen in a movie, people will take their clothes off and get in it. If the women have large breasts, it’s a T&A movie. If the women have small breasts, it’s a drama or a foreign film. If the women keep their underwear on, it’s a coming-of-age movie. If it’s a slasher movie or a thriller, there will be an electrical appliance located nearby.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("David Stevens, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Irving, Tex.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Huh? What? Ending.")]), _vm._v(" A film climax that should wrap up everything, but only perplexes because of a plot development that is clumsy, lame, illogical, or pretentious. Example: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Unforgiven, ")]), _vm._v("which ends a two-hour sermon against vigilante violence with a twenty-minute celebration of vigilante violence. Other examples: The “who is the real killer”"), _c('em', {
    staticClass: "italic"
  }), _vm._v("endings of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cruising, Jagged Edge, ")]), _vm._v("and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Basic Instinct.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Human Antennae.")]), _vm._v(" Movie characters who have an amazing ability to turn on the TV precisely at the moment when a newscaster begins a report on something directly relating to them.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jeffrey Graebner")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Hungry Harry Rule. ")]), _vm._v("A cop shows he is tough, unaffected, or just plain ambivalent by grabbing a quick bite to eat and munching while examining the scene of a grisly murder.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Scot Murphy, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Highland Park, Ill.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Hunter’s Walk.")]), _vm._v(" Whenever the hero enters an unknown dangerous place, he spends so much time looking behind him, lest he get jumped from the rear, that he ends up walking backward, and backs into the thing he’s looking for. See Kirk’s search of Regula One in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Star Trek II ")]), _vm._v("or any Dead Teenager Movie.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("James M. Curran, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bloomfield, N.J.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Hypo Display Principle.")]), _vm._v(" Any character planning to administer a hypodermic needle must first shoot some of the antidote/poison/drug up into the air before sticking patient with it, no matter how carefully measured the dosage is.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Kristina Gaje, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Toms River, N.J.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "img ",
    attrs: {
      "alt": "",
      "src": "images/img_52.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Idiot Plot.")]), _vm._v(" Any plot containing problems which would be solved instantly if all of the characters were not idiots.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Originally defined by ")]), _vm._v("James Blish")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("If Anything Happens to Them, We Can Hold a Benefit.")]), _vm._v(" In any film where a monster, villain, or natural disaster threatens the lives of the rich guests as a charity benefit, the mayor or other official will insist the benefit must not be canceled. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mighty Joe Young, The Relic, ")]), _vm._v("many Batman movies, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Ihnatko’s First Law of Egress.")]), _vm._v(" When you begin to notice and anticipate the little circles in the upper right corner of the frame signaling time for a reel change, it’s time to see if you can sneak into another theater at the multiplex.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Ihnatko’s Law of Voice Recognition.")]), _vm._v(" A movie computer sufficiently advanced to allow real-time voice communication between itself and a human will nevertheless speak like a drunk who has just received a serious blow to the head.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Illuminated Hello Rule.")]), _vm._v(" Whenever a character in a movie gets a telephone call in the middle of the night, he or she inevitably always turns on the light next to the bed before answering the phone. In real life, most people pick up the phone in the dark, but in the movies that would mean the camera couldn’t photograph them.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("George M. Iacono, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Impalement Principle.")]), _vm._v(" Whenever a sharp object is even remotely hinted at on the screen, someone will be impaled on it. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ricochet, Red Rock West, ")]), _vm._v("and"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Dead Again.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dave Kalin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("San Francisco")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Impatient Groom Syndrome.")]), _vm._v(" Undesirable movie weddings are always hurried along by an impatient groom, especially if the groom is the villain and the bride is the protagonist’s true love.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Rhys Southan, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Richardson, Tex.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Imperial Storm Trooper Marksmanship Academy.")]), _vm._v(" Institution where movie thugs get their weapons training. Teaches them how to stand five abreast, firing automatic weapons into a small room, without hitting anyone inside. Also applies to bad-guy fighter pilots, bad-guy archers, even bad-guy martial artists. Role models are the menacing but incompetent plastic-suited thugs from the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Star Wars ")]), _vm._v("films. Originally defined in role-playing game named “GURPS,” by Steve Jackson Games.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Lon Miller, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bloomington, Minn.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Impregnable Fortress Impregnated.")]), _vm._v(" Indispensable scene in all James Bond movies and many other action pictures, especially war films. The IFI sequence begins early in the picture, with long shots of a faraway fortress and Wagnerian music on the sound track. Eventually the hero gains entry to the fortress, which is inevitably manned by technological clones in designer uniforms. Sequence ends with destruction of fortress, as clones futilely attempt to save their marvelous machines. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Guns of Navarone, ")]), _vm._v("etc.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Inanity Profanity.")]), _vm._v(" Nonsense words are dubbed over profanity (i.e., “god-damned son-of-a-bitch” turns into “green-toed son of a fish”). In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Last Action Hero, ")]), _vm._v("virtually all of Frank MacRae’s dialogue is cleverly scripted Inanity Profanity; and films like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Semi-Tough ")]), _vm._v("are actually much funnier on television because of profanity that is totally inane. But hearing Peter Finch say “bullsoup” in the TV version of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Network ")]), _vm._v("is inexcusable. See also “Beep Bleep” and “Crap Gap.”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Indecisive Disappointment Rule.")]), _vm._v(" Screenwriter filled with feelings but short on words has character say, “Yes, No. I don’t know.” Alternate: “I don’t know what to think any more.”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Will Griffin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bristol, England")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Indoor Free Fall Phenomenon.")]), _vm._v(" When a character falls through the floor in a comedy, he keeps right on falling, through one floor after another, right down to the basement. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kazaam, The Frighteners, Assassins, ")]), _vm._v("etc. It’s amazing such shaky buildings can stand up well enough for the characters to walk upstairs in the first place. (Note: These scenes, which are incredibly expensive, are never funny.)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Inevitable Girl Next Door.")]), _vm._v(" In any movie where the hero is caught in a love triangle with two women, he will always choose the sweet, ordinary, caring one he grew up with—instead of the fabulously wealthy and gorgeous one with no morals."), _c('em', {
    staticClass: "italic"
  }), _vm._v("See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cocktail, Teen Wolf.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jeff Cross, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Marblehead, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Inevitable Microfiche Library Scene.")]), _vm._v(" A tired visual cliché frequent in mystery thrillers, typically rendered in shot/reverse shot fashion: first shot: an intense close-up of the whirring blur of the microfiche view screen that suddenly locks onto a crystal-clear picture or article; second shot: the face of the shocked protagonist—suspicions confirmed! See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sliver")]), _vm._v(", with Sharon Stone watching the whirring microfiche, until it locks onto the photo of the sliver building used throughout. Cut to: her stunned reaction.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("David H. Coleman, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tarzana, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Inevitable Sister.")]), _vm._v(" In any movie where the heroine catches her boyfriend dancing in public with another woman, and makes a big scene, the other woman invariably turns out to be the boyfriend’s sister. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mystic Pizza, ")]), _vm._v("etc.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Stuart Cleland, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Info-on-Demand.")]), _vm._v(" Whatever event the character is concerned or worried about (the killer on the loose, the police manhunt, the unusual disk-shaped lights in the sky, etc.), when the character turns on the radio or TV, there is an immediate news bulletin that provides full details of the event in question.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Mike Bachert, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Columbus, Ohio")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Ingenue Nudity Rule.")]), _vm._v(" In a movie with several young, pretty females, the prettiest among them, with the best body, will be the only one not seen nude.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("David Stevens, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Irving, Tex.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("In-House Programming Syndrome.")]), _vm._v(" Movie characters only see movies in old-fashioned, single-auditorium movie houses and usually attend only revivals of old classics, or movies by the director of the one you’re watching.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Injection Wince Reflex.")]), _vm._v(" Collective audience response whenever a large hypodermic syringe is used on a character in a movie. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pulp Fiction, Drugstore Cowboy, Rush, Alien 3, ")]), _vm._v("etc.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("William Brantley, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paris, France")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Injured Reserve.")]), _vm._v(" Film athletes are never significantly injured during the course of the movie, unless the injury is the point of the story.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Brannon Moore, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Seattle")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("In Space, No One Can Hear You Fall.")]), _vm._v(" Going through an airlock also causes one to become weightless.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Neil Milsted, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("In Space, No One Can See You Scream.")]), _vm._v(" All space characters have bright lights installed in their helmets, pointing inward, so that we can better see their little faces. The fact that this would make them completely blind in the darkness of space is of no consequence.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Fred Decker, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cary, N.C.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Instant Dye Job.")]), _vm._v(" Anybody in an action film entering a scene dressed entirely or mostly in white will by scene’s end be splattered with bright red blood.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Michael Schlesinger, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Culver City, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Instant Ignition Rule.")]), _vm._v(" In an action movie, any car driven by bad guys that crashes will inevitably explode, with flames instantly filling the passenger compartment, just as though they were carrying open cans of gasoline in their laps. This also happens whenever a car occupied by bad guys begins to fall over a cliff, even before the car has hit anything.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Sam Waas, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Houston")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Instant Ignition Syndrome.")]), _vm._v(" Whenever a character in a movie steps into a car, the keys are obviously in the ignition, judging by the lack of time required from when the door slams to when the car pulls into traffic. In some movies, one might assume that the car was left running. No one ever fumbles for keys, no one ever has to do the “pump twice and pray” thing, no matter how old or battered the car is. (Exception: “Hollywood Car Rule.”)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dawson Rambo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tucson, Ariz.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Instant Wardrobe Rule.")]), _vm._v(" Anyone arriving in town without luggage—for example, a western hero riding into town with only his saddlebags—reappears immediately with a full change of clothes.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Patrick Hall, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("East Kilbride, Scotland")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Intelligence.")]), _vm._v(" In most movies, “all that separates us from the apes.” In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sheena, Queen of the Jungle, ")]), _vm._v("what we have in common with them.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Intelligent Universal Operating Systems.")]), _vm._v(" All computers in the movies use the same amazingly powerful operating system that accepts plain English commands. A character simply types open primary file or access security system. The computer immediately responds. Such computers are always connected to a massive global network, and can access any private file anywhere in the world. In addition, this operating system uses a gigantic, blocky font that is usually bright green on a black background, apparently for the benefit of visually impaired users.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jim Collier, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dallas")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Intense Directional Singing Voice.")]), _vm._v(" When there’s a panning shot of a crowd singing, you hear a mushy blend of voices until the camera spots a lead actor; then you hear the lead’s voice loud and clear.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Chris Jones, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Snellville, Ga.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("In the Nick of Heroism.")]), _vm._v(" Bad guy corners victim and points his gun. A shot rings out. Bad guy smiles ironically, then slumps to the ground, dead. Audience and victim realize at same time that victim is still alive. Someone else shot the bad guy in the back. Who? Camera cuts to the unlikely shooter/hero, a nonviolent type who was not supposed to be at the scene and has never fired a gun before. He or she is still aiming the gun, in trembling outstretched hand.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Amy Novit, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Melrose, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Inverse Law of Combat Intensity.")]), _vm._v(" The intensity of combat in battle scenes is in inverse proportion to distance from the camera. The guys in the foreground usually at least "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("try ")]), _vm._v("to look like they "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("may ")]), _vm._v("want to hurt each other, but if you look in the far background you’ll see “combatants” just kind of fanning each other with their swords. Extremely popular in, but not limited to, all Italian “sword and sandal” movies.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Charlie Ambrosi")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Invisible Ceiling.")]), _vm._v(" Anyone can climb to the ceiling of a warehouse or practically anything else and not be seen by anyone walking beneath. In a subset of the “Fallacy of the Predictable Tree,” if the good guy is hiding on or in the ceiling, the bad guy will pause directly underneath so "), _c('br'), _vm._v("the good guy can fall on him and overpower him. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sneakers.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dona Kight, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Invisible Protective Shield.")]), _vm._v(" Protects characters during fight scenes. They get hit by fists, chairs, bottles, etc., and thrown through walls, doors, glass, but wear only a small bandage in next scene, and later have no marks, although they should be black and blue for the rest of the movie.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Catherine Went")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("It Just Might Work Rule.")]), _vm._v(" It always does, however—although not necessarily in the intended manner.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Brannon Moore, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Seattle")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("It’s a Black Thing Maneuver.")]), _vm._v(" Used when hero needs help or information, and has been refused by rigid bureaucracy. Just as he’s leaving in defeat, he is called aside by an employee of the place who is of the same race/nationality/"), _c('br'), _vm._v("age/ethnicity as the hero, and who breaks the rules by quietly telling him what he needs to know.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Michael E. Isbell")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("“It’s Over.”")]), _vm._v(" Whenever a man and woman have narrowly escaped a series of deadly events, the man inevitably says to the woman, “It’s over.” She then nods gratefully. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Seeing-Eye Man.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Michael J. Pilling, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maple Ridge, B.C., Canada")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("“I’ve got it on tape!”")]), _vm._v(" This line is always followed by the chipmunklike sound of a Stone Age tape recorder rewinding. The tape inevitably rewinds to the exact spot required to give only the pertinent portion of the incriminating statement, no matter how long the villain talked.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Don Howard, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("San Jose, Calif.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "img ",
    attrs: {
      "alt": "",
      "src": "images/img_68.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("James T. Kirk Loophole. ")]), _vm._v("Any contrived plot twist that undoes the un-undoable. The JTK Loophole is named in the spirit of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Star Trek ")]), _vm._v("character who says, “I don’t believe in a no-win situation”; thus, when Spock dies at the end of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Star Trek II, ")]), _vm._v("he is resurrected in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Star Trek III. ")]), _vm._v("Also, when Superman is told he can never turn back time, he does it anyway, and in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Superman II, ")]), _vm._v("when he gives up his powers forever, he gets them back by the end of the movie. In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("All Dogs Go to Heaven, ")]), _vm._v("when the canine lead is told that if he leaves heaven he can never return, he does so with no questions asked. In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("What Dreams May Come, ")]), _vm._v("Robin Williams is told he can never get his wife out of hell, but does.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Jarring Door Ajar Scene.")]), _vm._v(" In an action thriller, whenever the hero knocks on a door and it swings gently inward at the first tap, there is inevitably a dead body inside, often that of a close friend or an old law enforcement partner.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Mark and Sonya Warner, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Le Creusot, France")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Joel Silver Rule.")]), _vm._v(" All women in action-adventure flicks are extraneous to the plot unless naked or dead.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jim O’Brien")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Joel’s Observation.")]), _vm._v(" Directors always make sure that air ducts are big enough to crawl around in.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("First noted by")]), _vm._v(" Joel Robinson "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("of "), _c('br'), _vm._v(" “Mystery Science Theater 3000”")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Joint Forces Law.")]), _vm._v(" If two groups are fighting one another, and a third group comes in against the good guy’s group, the original enemies of the good guy will join forces with him to combat against the third and most evil group. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rumble in the Bronx.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Rhys Southan, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Richardson, Tex.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Jolly Bornday.")]), _vm._v(" Any obviously concocted song sung during a birthday party scene, chosen so the producers can avoid paying the royalty fees for “Happy Birthday.”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Joy of Ex.")]), _vm._v(" If a cop’s daughter or wife is seen in the first twenty minutes of a film, she will be either dead or kidnapped within the next hour. Corollary: If the wife is estranged, her safety is assured; by Hollywood law, the movie cannot end until the cop rescues her and they realize that Maybe They Belong Together After All.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Jukebox Jerrybuilding.")]), _vm._v(" Movie based on a song solely to cash in on the popularity of the song. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("White Christmas, Chattanooga Choo-choo, Ode to Billy Joe, Harper Valley PTA, Girls Just Want to Have Fun, Sgt. Pepper’s Lonely Hearts Club Band, ")]), _vm._v("etc.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Jukebox Saturday Night Fights.")]), _vm._v(" Every time a fight breaks out in a bar, the jukebox volume goes way up. At the end of the fight, it goes right back down! Wow. What a trick! And the jukebox never plays a slow song during a brawl.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Joshua Rasiel, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("West Nyack, N.Y.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "img ",
    attrs: {
      "alt": "",
      "src": "images/img_69.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Ka-Ching! Moment.")]), _vm._v(" Instant when you realize the product on screen is a product placement and not just a prop; i.e., when the product stops being used by the film and the film starts being used by the product. When characters eat at McDonald’s in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ordinary People, ")]), _vm._v("that’s a movie; when they go to McDonald’s in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("MAC and Me ")]), _vm._v("to party with Ronald McDonald, that’s a commercial. When Michael J. Fox orders a Pepsi Free in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Back to the Future, ")]), _vm._v("the soft drink is a prop. But when Bill Cosby spends an entire scene in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Leonard Part 6 ")]), _vm._v("holding a bottle of Coca-Cola so that the label is dead-center on camera, that is a product placement. (Tip off: When the product is more carefully lit than the actors are, like the Wheaties box on Superman’s breakfast table.)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Keep Refrigerated until Ready to Barf.")]), _vm._v(" Coroners and morgue attendants always keep their lunch in the same refrigerator as the pickled body parts.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Robert Hutton, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bedminster, N.J.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Kevin Kline Mustache Principle.")]), _vm._v(" When Kevin Kline is sporting facial hair he must play an eccentric, offbeat goofball "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(A Fish Called Wanda, I Love You to Death, Soapdish). ")]), _vm._v("To play a serious role he must be clean-shaven "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Dave, Sophie’s Choice, Grand Canyon, Cry Freedom).")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Eric Skovan, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Poughkeepsie, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Keyless Vehicle Exception.")]), _vm._v(" Just as the warehouse, oil refinery, or ammunition dump starts to explode, the hero dashes through a hail of burning debris, finds a truck, car, or motorcycle parked outside, throws it into gear, and roars away to safety.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Ed Cohen, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Kidding Battery.")]), _vm._v(" In horror films, when the hero/heroine jumps in a car while being pursued by the killer, the car never starts at the first crank. The following generic montage is used: Close-up shot of hero/heroine’s face sweating. Face goes out of focus as background focuses to reveal killer approaching car. Close-up of ignition failing again to start engine. Repeat sequence as many times as necessary to match generic crescendo music. Finally, battery gives enough juice to start engine just a second before killer gets the would-be victim. Obviously, the battery was just kidding.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Raymond Salfiti")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Killer Imperative.")]), _vm._v(" Any character who voices a moral objection to killing, or who claims to have never before killed anyone, will be invariably called upon to do so (usually during the final third of the movie). The character either liquidates an imposing villain at very close range in self-defense, kills a bad guy a split second before he would have murdered the hero, or just “gets mad.”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("G. W. Roles, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Washington, D.C.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Kinetic Energy Amplification Phenomenon.")]), _vm._v(" In scenes involving gunplay, the kinetic energy of the bullets will be enormously amplified as they strike the victim, enabling him to be hurled great distances and through objects. This phenomenon is particularly common around windows and balconies, especially in high-rise buildings.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dennis Ward")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Kinetic Energy Distortion Phenomenon.")]), _vm._v(" When someone is shot while standing near a window, balcony, or ledge, the kinetic energy will always be distorted so as to throw him "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("outward, ")]), _vm._v("regardless of the direction the bullets came from. This enables victims to be hurled out a window and into a spectacular plunge even if the shots came from outside to begin with.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dennis Ward")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Kirk Method of Time Management.")]), _vm._v(" Regardless of the time a subordinate says will be needed to fix a problem, the supervisor will cut the time by half, at least. Example: Scotty: “I’ll need at least twenty minutes to repair the warp drive, Captain!” Captain Kirk: “You’ve got exactly ten minutes before the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Enterprise")]), _vm._v(" is pulled into the Sun, Mr. Scott!”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v(" Robert Jones, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tigard, Oreg.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Kojak Moment.")]), _vm._v(" In thrillers where the hero is befuddled by an assortment of completely unrelated suspects and victims, the scene in which he suddenly discovers a vacation photo of all of them in a big, grinning group pose.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Kookalouris.")]), _vm._v(" Name for a large sheet of cardboard or plywood with holes in it, which is moved back and forth in front of a light to illuminate a character’s face with moving light patterns. Popular in the 1930s; back in style again with the movies of Steven Spielberg, who uses a kookalouris with underlighting to show faces that seem to be illuminated by reflections from pots of gold, buckets of diamonds, pools of fire, pirate maps, and radioactive kidneys.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "img ",
    attrs: {
      "alt": "",
      "src": "images/img_53.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Lambada Factor.")]), _vm._v(" No matter how quickly it gets made, any film produced to cash in on the latest fashion, fad, trend, or gimmick will be out of date by the time it is released because the fashion, fad, trend, or gimmick will have become passé. See break dancing, disco, macarena, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Land Boom Rule.")]), _vm._v(" In any movie where there is a cocktail party featuring a chart, map, or model of a new real-estate development, a wealthy property developer will be found dead inside an expensive automobile.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Last Cell Syndrome.")]), _vm._v(" Whenever a character must visit someone in jail, the jailed character’s cell is always the last one on the cell block, so the visitor must slowly pass by every other cell in terror.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Neil Gabriele, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nashville, Tenn.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Last Grab Rule.")]), _vm._v(" People pushed off balconies always hang on to the balcony or the person who pushed them for a few seconds before inevitably plunging to their death. Their clutching hand is always pictured in a close-up. (Used twice in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Poison Ivy.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Scott Dalziel")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Last Match Theory.")]), _vm._v(" An almost-empty box of matches is never shown in a movie unless a shortage of matches will prove integral to the plot at some point. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Fifth Element")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Robert Underwood, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Denver")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Last Try Law.")]), _vm._v(" After a character gives up on something, especially starting a car in an urgent situation, it will work on the last try, just in time. See"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Ace Ventura, Back to the Future.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Rhys Southan, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Richardson, Tex.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Latino Laughers.")]), _vm._v(" In all action movies set in Mexico, sooner or later a gang of tough guys will corner the hero and laugh at him in unison while using the word “gringo.”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v(" R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Laugh or Be Laughed Rule.")]), _vm._v(" When a villain who is the head of a band of wrongdoers laughs, everyone else laughs with him, or he gets angry and kills the nonlaugher. The exception is when the villain laughs but does not want his followers to laugh; in this case, he kills the person who does laugh. Wise gang members think before responding. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("No Escape, Batman.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Rhys Southan, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Richardson, Tex.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Lawn Dwarf Rule.")]), _vm._v(" Garden gnomes in movies exist solely for the purpose of being stolen by wacky protagonists. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Box of Moonlight, The Full Monty, SubUrbia.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Ed Slota, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Warwick, R.I.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Law of Canine/Feline Superperception.")]), _vm._v(" Household pets can unerringly detect and react to the presence of ghosts, aliens, or other nonhuman entities. Their warnings are invariably ignored.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Derek Wood, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Palo Alto, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Law of Colorful Chemicals.")]), _vm._v(" In scenes set in any kind of laboratory, there are always lots of flasks filled with lots of bright, colorful chemicals—red, blue, green—when in reality virtually everything in most research labs is either clear or some shade of yellow. I can count on one hand the number of organic chemicals that are bright blue or green. The chemicals are invariably in glassware jammed together backward and sideways, in what the set designer thought was a neat-looking combination. See the Nicholson-Karloff quickie "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Terror, ")]), _vm._v("where in the witch’s room we see a modern ground-glass three-neck flask, with the logo of the glass company clearly visible on its side. This during the Napoleonic wars.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Derek Lowe, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Scotch Plains, N.J.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Law of Economy of Characters.")]), _vm._v(" Movie budgets make it impossible for any film to contain unnecessary characters. Therefore, all characters in a movie are necessary to the story—even those who do not seem to be. Sophisticated viewers can use this law to deduce the identity of a person being kept secret by the movie’s plot: This “mystery” person is always the only character in the movie who seems otherwise extraneous. (Cf. the friendly neighbor in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Lady in White; ")]), _vm._v("see also “Unmotivated Close-up.”)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('img', {
    staticClass: "img ",
    staticStyle: {
      "page-break-before": "always"
    },
    attrs: {
      "alt": "",
      "src": "images/img_23.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Law of Economy of Instruction.")]), _vm._v(" Nobody is ever taught anything in a movie that he or she is not later called upon "), _c('br'), _vm._v("to use.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Law of Fate Law.")]), _vm._v(" If a man and a woman meet, and the woman’s husband has disappeared, the man and the woman will fall in love, and then the husband will suddenly reappear. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wife of Martin Guerre, Lord of Illusions.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Rhys Southan, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Richardson, Tex.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Law of Inevitable Immersion.")]), _vm._v(" Whenever characters are near a body of water, the chances are great that one of them will jump, fall, or be pushed into it. If this does occur, it is inevitable that the other character(s) will also jump, fall, or be pushed in. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sullivan’s Travels ")]), _vm._v("(swimming pool), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("La Dolce Vita ")]), _vm._v("(Roman fountain), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tom Jones ")]), _vm._v("(pond), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Room with a View ")]), _vm._v("(rural stream), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Summertime ")]), _vm._v("(Grand Canal), etc.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v(" Stuart Cleland, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Law of Inverse Wariness.")]), _vm._v(" The more dangerous the prisoner, the more lax the security precautions.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jeff Levin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rochester, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Law of Movie Brand Loyalty.")]), _vm._v(" Thanks to product placement, all characters in a movie, no matter how heterogeneous or geographically dispersed, drink one brand of beer, use one brand of sporting equipment, drive cars produced by one company, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Paul A. Lee, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Germantown, Wis.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Law of Poignant Remnants.")]), _vm._v(" Whenever the wreckage of a plane crash is shown, there is always a teddy bear or doll in the midst of the wreckage.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Naoki Sato, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("University of Toronto")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Law of Relative Walking Speeds.")]), _vm._v(" No matter how fast the would-be victim runs, the slasher can always keep up just by walking steadily.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Law of Take-out Chinese Food.")]), _vm._v(" Take-out Chinese food is eaten in one of only two situations: Communally by a large, multiethnic group enthusiastically working on a common project "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Reversal of Fortune), ")]), _vm._v("or in bed by two post-coital lovers "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Annie Hall). ")]), _vm._v("In the former case, the meal predicts success; in the latter, that the couple will break up.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Phillip L. Gianos, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fullerton, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Law of Video Box Caricature, The.")]), _vm._v(" If you’re trying to pick out a video and the actors on the box are cartooned caricatures which are not recognizable, pick another movie. Mark Brewer,")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Lake Zurich, Ill.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Law of Vinyl Vulnerability.")]), _vm._v(" Unwritten rule in older Hollywood movies which decrees that any LP “vinyl” record album shown playing on a turntable must either be roughly grabbed and smashed to bits by a sad, depressed, or angry character who hates the song, or the tone arm needle must be violently dragged across its surface, thus ruining the record, in order to instantly hush a loud, annoying, and insensitive party crowd—whereupon the sad, depressed, or angry character demands in a loud voice that everybody must leave now.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Robert E. Hunt Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Lawyer with One Case Scenario.")]), _vm._v(" In nearly all legal dramas, the lawyers involved have only one case—the case that the movie is about. They are never distracted by other cases, clients, or causes.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Martin J. Keenan, Esq., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Great Bend, Kans.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Lazenby Factor.")]), _vm._v(" Tendency of actors plucked from obscurity for a once-in-a-lifetime role to be just as quickly drop-kicked back into obscurity. Victims include George Lazenby of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("On Her Majesty’s Secret Service, ")]), _vm._v("Klinton Spilsbury of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Legend of the Lone Ranger, ")]), _vm._v("Mark Lester of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oliver!, ")]), _vm._v("Kim Darby of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("True Grit, ")]), _vm._v("Bo Derek of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("10, ")]), _vm._v("Harold Russell of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Best Years of Our Lives, ")]), _vm._v("Haing S. Ngor of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Killing Fields, ")]), _vm._v("Maria Schneider of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Last Tango in Paris, ")]), _vm._v("George Chakiris of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("West Side Story, ")]), _vm._v("Loren Dean of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Billy Bathgate, ")]), _vm._v("Jaye Davidson of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Crying Game.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Leaky Specimen Tank Phenomenon.")]), _vm._v(" In all films dealing with science, whenever a big glass tube is displayed, there is a small column of bubbles rising to the surface. These bubbles, which might indicate to a scientist that there was a small hole in the bottom of the tube, are employed to prove to the audience that the container holds fluid, and to add atmosphere.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Tom Elberfeld, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Leap in Timers.")]), _vm._v(" Stuntmen posing as pedestrians, who jump out of the way of speeding carts at the last moment, by leaping to fire escape ladders or off the sides of bridges.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Left Behind Rule.")]), _vm._v(" All Italian-American cops have a childhood friend who’s in the Mafia.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Ian Mantgani, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Liverpool, England")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Lenny Rule.")]), _vm._v(" Named for the gentle giant in Steinbeck’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Of Mice and Men, ")]), _vm._v("this rule dictates that if a film character is of less than normal intelligence or ability, he or she will inadvertently get into serious trouble during the film.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Stuart Cleland, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Leno Device.")]), _vm._v(" Assures us the events in a movie received national attention by the appearance of Jay Leno on television, who makes a joke about it. Required particularly in political comedies. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wag the Dog, Dave, The Birdcage, Contact, Mad City.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jason Bailey, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wichita, Kans.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Less-Is-More Rule.")]), _vm._v(" The less a preview shows, the more confidence the filmmakers have in their film and the more eager they are to let the audience be surprised. (If the trailer seems to tell the entire story of a film, it probably does; there is likely no reason to see the film.)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Letter Imperfect Law.")]), _vm._v(" If the opening credits are spelled out in a mismatched mixture of fonts and sizes designed to say “wacky,” the movie is already in serious trouble.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Let Your Fingers Do the Crawling.")]), _vm._v(" Governors always wait until the last possible moment to put through a call with a stay of execution. No matter how long they have had to ponder the merits of the case, they never pick up the phone until the intended victim is strapped in the chair and the warden’s fingers are tapping on the power switch.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Let Your Fingers Do the Driving.")]), _vm._v(" In any movie where the hero knows that other characters are in trouble, say because a time bomb is about to go off, he must jump into a car and drive like a lunatic across town to save them. No hero ever has a quarter for the pay phone.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Bill Becwar, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wauwatosa, Wis.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Libertyvalance.")]), _vm._v(" Verb, meaning to rewrite the facts of a story to match the storyteller’s personal hero-worshiping impulses or make the tale more commercial. Drawn from John Ford’s 1962 classic Western "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Man Who Shot Liberty Valance, ")]), _vm._v("which had the moral “When the legend becomes fact, print the legend!” Examples of conversational usage: “D. W. Griffith really libertyvalanced the Ku Klux Klan in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Birth of a Nation, ")]), _vm._v("in order to make the story more compelling.” Or “Oliver Stone’s libertyvalancing in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("JFK ")]), _vm._v("reached epic proportions.” Or “The libertyvalancization of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gandhi ")]), _vm._v("won Attenborough an Oscar!” Or “Disney found Pocahontas quite libertyvalanceable.” Generally speaking, the more a filmmaker defends the honesty of his work, the more likely he is a libertyvalancer.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Light Fantasic, The.")]), _vm._v(" Curious set design principle that requires malfunctioning computer equipment to be accompanied by purposeless, flashing light displays.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Paul A. Lee, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Germantown, Wis.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Lightning-Thunder-Downpour.")]), _vm._v(" In most suburban and rural thrillers involving a vulnerable heroine, a bolt of lightning, then thunder, and then an instantaneous downpour of hard rainfall occurs in rapid sequence, with no rumblings or darkened skies as forewarning. (The “Wet Road Rule” inevitably applies here.)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Steve W. Zack")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Limited Partnership.")]), _vm._v(" If a young up-and-coming actor is playing the hero’s partner, said partner will be killed "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(In the Line of Fire, Copycat).")]), _vm._v(" If the hero is the up-and-comer, then his mentor, played by a veteran actor, will buy it "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Star Wars, The Untouchables, ")]), _vm._v("and"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" The Mask of Zorro). ")]), _vm._v("Full stardom is when an actor plays only roles that fall between these two career stages.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Christopher M. Terry, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Atlanta, Ga.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Limo Exclusion Law.")]), _vm._v(" In any scene involving a limousine, where one actor is in the back seat talking to another actor outside the car, the scene will end with the actor in the car raising the window, reflecting back onto the outside actor the world he’s stuck in.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Mark Oristano")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Little Man Big Man Rule.")]), _vm._v(" Whenever one character is tall and the other is short and plump, the short one is always the brains and the tall one is the dummy. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Home Alone,")]), _vm._v(" etc.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("David Ormesher, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lakeland, Fla.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Locked in Low.")]), _vm._v(" A good sprinter can run the 100-yard dash in ten seconds. That’s twenty miles an hour. Yet overweight, out-of-shape heroes can run down the center of the road when fleeing bad guys’ cars, and the cars never catch them. That’s because the cars are Locked in Low and can’t do more than ten miles an hour.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Don Howard, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("San Jose, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Long-Haired Woman Seen from Behind.")]), _vm._v(" When approached by hero, inevitably turns out to be a man.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "img ",
    attrs: {
      "alt": "",
      "src": "images/img_24.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Looney In-Tunes.")]), _vm._v(" Any movie with a plot about a successful musician returning to his hometown for any reason will feature a scene where he or she picks up his “first” instrument or sits in front of his grandmother’s piano. Of course this instrument is in tune.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Patty Sundberg, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tucson, Ariz.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Love Boat Rule.")]), _vm._v(" Any character who coughs at any time has a terminal illness. Happens all the time on “The Love Boat,” oddly enough. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Camille.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("James R. Jokerst, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maryland")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Love-Hate Principle.")]), _vm._v(" Any attractive man and woman who hate each other at the beginning of a movie will be in love at the end.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Charles D. Story, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Elmhurst, Ill.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Lucky Pedestrians.")]), _vm._v(" No matter how many trash cans, water hydrants, fruit carts, or other cars get hit during a car chase or by a runaway auto, pedestrians are safe from harm. The rationale is simple. Hit a pedestrian, and that would distract from the mindless action.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "img ",
    attrs: {
      "alt": "",
      "src": "images/img_54.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Mabel, the AT&T Phone.")]), _vm._v(" The AT&T telephones used in the movies are like standard models, except that the AT&T logo (known to company insiders as the Death Star) is printed on the heel of the handset, so that when an actor is speaking on the phone, it is clearly visible. AT&T makes no phones like this in real life. For numerous Mabel sightings, see "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Fugitive. ")]), _vm._v("Mabel is never used in scenes calling for someone to be bashed to death with a telephone.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Rich Elias, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Delaware, Ohio")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Ma Bell Rule.")]), _vm._v(" Whenever a telephone is seen in a movie, the telephone will eventually ring.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Ken Cox, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Florence, S.C.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("MacGuffin.")]), _vm._v(" Alfred Hitchcock’s term for a plot element that “must seem to be of vital importance to the characters,” even though its specific identify is immaterial. “It’s the device, the gimmick, if you will, or the papers the spies are after,” Hitchcock explained to François Truffaut in their book-length interview. Hitchcock illustrated with the story of two hunters in the Scottish Highlands. One asks the other what is in his package. “A MacGuffin,” the other responds. “What’s a MacGuffin?” “It’s an apparatus for trapping lions.” “But there are no lions in the Highlands.” “Then that’s not a MacGuffin!” See also “O’Guffin.”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("  R. E.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "img ",
    attrs: {
      "alt": "",
      "src": "images/img_25.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("MacLaine’s Law of Female Fatality.")]), _vm._v(" If a movie features three female leads, one of them will die during childbirth. If there are five or more female leads, an additional female character will contract a terminal disease.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('img', {
    staticClass: "img ",
    staticStyle: {
      "page-break-before": "always"
    },
    attrs: {
      "alt": "",
      "src": "images/img_26.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Mad Dash into Traffic Rule.")]), _vm._v(" A car will always brake close enough for the running hero to touch it, and then dash into the next lane where the same thing happens with a car traveling in the opposite direction.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Barak and Elizabeth Moore, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jerusalem, Israel")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Mad Slasher Movies.")]), _vm._v(" Movies starring a mad-dog killer who runs amok, slashing all of the other characters. The killer is frequently masked (as in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Halloween ")]), _vm._v("and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Friday the 13th")]), _vm._v("), not because a serious actor would be ashamed to be seen in the role, but because then no actor at all is required; the only skills necessary are the ability to wear a mask and wield a machete. For additional reading, see "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Splatter Movies, ")]), _vm._v("by John (“Mutilation is the Message”) McCarty.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Magical Death Hand Wave.")]), _vm._v(" When a relative or partner of the hero is murdered, and the hero must view the body, always still at the scene of the crime, the hero will pass his hand over the eyes of the victim, and (voilà!) magically, the eyes will remain closed.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dawson Rambo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tucson, Ariz.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Magical Makeup Syndrome.")]), _vm._v(" Women in old romantic films never take off their makeup, even in the bath, and certainly not in bed. Their elaborate hairdos are as rigid as corrugated iron. When they cry, their eyes run, but never their noses, and definitely never their mascara. Their fingernails and toenails never have chipped nail polish, and they look immaculate even if they have just been dragged through a coal chute by the hair.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Hilary Potts, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("West Ealing, London")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Magic Bullets.")]), _vm._v(" If someone is firing a machine gun at someone’s upper body, any bullets that do not hit them will make a 90-degree turn in the plane of their body and kick up dust at their feet.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Brannon Moore, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Seattle")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Magic Bus.")]), _vm._v(" During a chase on foot, if a bus or any other vehicle longer than a van comes between the chaser and the chasee, the person being chased will magically disappear, thus leaving the chaser dumbfounded.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Christopher I. Henry, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ann Arbor, Mich.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Magic Shave.")]), _vm._v(" When a shaving actor is interrupted after just a few strokes, he wipes the lather off with a towel to reveal a close-shaved face.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Patrick Hall, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("East Kilbride, Scotland")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Magnetic Beach Effect.")]), _vm._v(" Whenever a storm at sea capsizes boats and leaves the shipwreck survivors adrift and helpless, the next dawn finds them sprawled on a beach. It is always a nice, clear day.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Maid to Die Dictum.")]), _vm._v(" In a thriller, if a housemaid or baby-sitter is seen early in the film as part of the family unit, and is given an identity but virtually no dialogue, she will be killed when the villain shows up. The movie will never mention her death again.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Ma Jarrett Rule.")]), _vm._v(" Behind every good villain who wears a balaclava for heists, there is a caring mom who sews up the frayed edges once the holes have been cut for his eyes and mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Sue Feehan, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beckenham, Kent, England")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Make/Up Rule.")]), _vm._v(" A movie baby will inevitable “make” on anyone who picks it up. (“What a cute baby! What th . . . ? Ugh!”)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Philip Lew, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Brooklyn, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Making that Last Sale.")]), _vm._v(" In the case of any impending disaster, natural or man-made, politicians will always arrive at the same conclusion: It is less important to issue a warning than to “avoid panicking the population.” The reasoning is always the same: A warning will be bad for business.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Eugene Accardo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Brooklyn")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Mamet Dammit.")]), _vm._v(" Variations of the “f-word” packaged in multiples "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and ")]), _vm._v("shoehorned into banal dialogue to establish gritty reality. Prolific users of the Mamet Dammit include Martin Scorsese, Brian DePalma, Paul Schrader, John Milius, Quentin Tarantino, and David Mamet. If you are aware of the profanity (like in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Scarface, Glengarry Glen Ross, ")]), _vm._v("or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reservoir Dogs")]), _vm._v(") it is the Mamet Dammit; if at the end of the movie you don’t remember there being any profanity "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Rain Man), ")]), _vm._v("it isn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Mandatory Latrine Scene.")]), _vm._v(" In movies since 1980 with office settings, all major decisions are made by men of power while standing next to urinals and washbasins in the men’s restroom.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Donna Martin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kansas City, Mo.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Mano y Ammo.")]), _vm._v(" Scene in action movie where hero outfits himself with every form of weaponry he can possibly carry. The scene is usually choreographed with crisp movements and involves more zippers and Velcro than a Michael Jackson concert.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("John Willard, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cortez, Colo.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Marathon Hero, The.")]), _vm._v(" A hero in pursuit of a purse-snatcher or getaway car can run for many blocks, even up the hills of San Francisco, without getting winded.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Martini Shot.")]), _vm._v(" In a production schedule, the last shot of principal photography at the end of the day is called the “Martini Shot,” after which the crew can retire for the day and, in theory, enjoy a martini.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Sam Humphries")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "page-break-before": "always"
    }
  }, [_c('img', {
    staticClass: "img ",
    attrs: {
      "alt": "",
      "src": "images/img_27.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Meet Cute.")]), _vm._v(" Time-honored Hollywood method of having two important characters meet each other. In the Golden Age, it often involved the heroine exiting from a department store and dropping her packages after being jostled by the hero. As they stoop to pick them up, their heads bump, leading to conversation, etc. In modern movies, Meet Cutes can be more ingenious. In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("With Honors,")]), _vm._v(" for example, a Harvard student meets a homeless man after a thesis falls through a sidewalk grating.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Method Nose Acting.")]), _vm._v(" As a continual visual reminder that a character is self-destructive and has lost his dignity, the story will call for him to injure his nose, requiring him to walk around wearing a nose bandage. Examples: Jack Nicholson in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chinatown, ")]), _vm._v("Patrick Stewart in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Conspiracy Theory, ")]), _vm._v("Sylvester Stallone in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cop Land, ")]), _vm._v("etc.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Mark Dayton, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cosa Mesa, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Mid-Wife Crisis.")]), _vm._v(" Any character whose wife and/or kids are introduced more than an hour into the movie and who hugs and kisses any or all of them will be dead within the next twenty minutes (e.g., “Goose” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Top Gun")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Edward Savio, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("San Francisco")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Milli-Vanilli Props.")]), _vm._v(" Novelty gadgets available today, but used in sci-fi/fantasy movies as futuristic devices. For example, in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Star Trek III: The Search For Spock, ")]), _vm._v("McCoy is in a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Star Wars")]), _vm._v("–type bar with lava lamps.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Terry Fox")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Miracle of Available Parking Space.")]), _vm._v(" When a character needs a parking space, even on the busiest streets in the busiest cities, one is quickly found. For example, in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lost in America, ")]), _vm._v("Albert Brooks finds space for a Winnebago directly in front of an office building at midday in New York City. Corollary: When a character needs to pull into traffic, there is always a break.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Phillip L. Gianos, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fullerton, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Miracle Twenty-five-pound Newborn Syndrome.")]), _vm._v(" Newborn babies in movies instantly look about seven months old, and weigh about twenty-five pounds. Their postpartum mother seems perfectly refreshed, made-up, and comfortable despite the gargantuan child she’s just given birth to.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Barak and Elizabeth Moore, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jerusalem, Israel")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Miraculous Projection Phenomenon.")]), _vm._v(" Ability of apparently normal computer, TV, and movie screens to project their images onto the face of an actor. In extreme cases, the audience is able the read the crisply focused words from a computer screen directly off an actor’s face.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Richard Rohrdanz, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("West Kennebunk, Maine")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Mirror Gimmick.")]), _vm._v(" Tired old cinemagraphic trick in which we think we are seeing a character, but then the camera pans and we realize we were only looking in a mirror.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Arden J. Cooper, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Warren, Mich.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Mirror Gimmick II.")]), _vm._v(" We see the hero in serious conversation (trying to propose marriage, for example). After a few lines the camera pans back and we realize he was only rehearsing his speech. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Forever Young.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Laurel Van Dyke, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kokomo, Ind.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("“Miss Blanche?” Character.")]), _vm._v(" Any character in a film who is a false hero and exists only to get killed for shock value—usually seconds after they’ve found out the villain. Examples: Detective Arbogast in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Psycho, ")]), _vm._v("the cop in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Misery, ")]), _vm._v("the brother in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Stepfather, ")]), _vm._v("the football player in the remake of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Blob, ")]), _vm._v("and, of course, the maid in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Whatever Happened to Baby Jane? ")]), _vm._v("(The name comes from her last words.)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Rob Matsushita, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Madison, Wis.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Mission Control Syndrome.")]), _vm._v(" Tired but insidious device in which filmmaker prompts the audience to react after failing to explain why anyone should care. The action is intercut with footage of a contrived surrogate audience, reacting with mounting tension—and then ecstatic, arm-waving, paper-hurling jubilation. Easy in sports movies; overlabored in films like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("WarGames ")]), _vm._v("(spurious Pentagon war room), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Right Stuff ")]), _vm._v("(mission control), all the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Airport ")]), _vm._v("movies (control tower), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Hunt for Red October ")]), _vm._v("(Pentagon again). Most end-of-the-world movies have an obligatory roomful of scientists to monitor approaching doom.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Angus McCallum, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York City")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Modesty Maneuver.")]), _vm._v(" Movie characters are so self-effacing that whenever they perform extravagantly dangerous acts, they keep their backs to the cameras. This is followed by a close-up of the character, signifying that the stuntman has done his job and the actor is back at work.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Moe Rule of Bomb Disposal.")]), _vm._v(" Used by bomb squad experts in movies. When they know that cutting one wire will deactivate the bomb and cutting the other will make it explode, the correct wire to cut is always “Moe.” All movie bomb experts clamp their cutters around one wire but end up cutting the other at the last moment. (“Eenie, meenie, minie . . . snip!”)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Monk’s Reward.")]), _vm._v(" A surprising final line or image, tagged on after the credits have finished rolling (e.g., in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Airplane!, ")]), _vm._v("the fellow in the taxicab at the airport, still yakking). So named because it usually takes monklike devotion to sit through the credits to get to it. (Also known as Credit Cookies.)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Serdor Yegulalp")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Monokini Law.")]), _vm._v(" All bikini-oriented movies, including swimsuit videos, are required by California law to have at least one scene where the top is removed for comic effect. Bonus points if done by a dog.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("David Stevens, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Irving, Tex.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Most Dangerous Road Syndrome.")]), _vm._v(" Any group of refugees walking along any road in France between 1940 and 1944 will be strafed by the Luftwaffe.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Matthew Cope, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Montreal")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Movie-Bismol.")]), _vm._v(" When characters in movies have indigestion, they never just take Rolaids. They always mix up some gross concoction of Alka-Seltzer or Pepto-Bismol with beer, booze, milk, and/or coffee. No one outside of a movie has ever done this. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Courage Under Fire, Cape Fear, ")]), _vm._v("etc.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jon Pietrowski, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Genoa, Ohio")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Movie Businesswoman Look.")]), _vm._v(" Whenever a high-powered businesswoman appears in a movie, her suit always includes a mini-length skirt and a low-cut blouse (and she always has great legs). If ordinary businesswomen dressed that way, they’d never be taken seriously, and in some companies they’d even be violating a dress policy (e.g., Demi Moore in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Disclosure")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Kay Robart, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Austin, Tex.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Movie Dumb.")]), _vm._v(" Outrageously inaccurate information about filmmaking, in films about making films. Examples: In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mrs. Doubtfire, ")]), _vm._v("Robin Williams postdubs the voices to cartoons when it is common practice to record the voices first and match the animation to fit. In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hooper, ")]), _vm._v("a complicated stunt sequence is filmed in one continuous take. In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Stuntman, ")]), _vm._v("a man is recruited as a stuntman and placed in dangerous situations without getting training or even knowing exactly what the stunt involves. In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("S.O.B., ")]), _vm._v("sets used in the movie-within-the-movie are still set up on a studio soundstage months later, after the finished film has already premiered and flopped. The plot of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Broadcast News ")]), _vm._v("hinges on an experienced producer not realizing that a character has faked a reaction shot.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Movie Giftwrap Rule.")]), _vm._v(" When characters in movies receive wrapped presents, the lid is usually wrapped separately from the box—presumably so that if the scene has to be reshot, the gift can be “re-wrapped” quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("George M. Iacono, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Movieland, CA, and Filmtown, N.Y.")]), _vm._v(" The two towns which are the setting for all movies in which characters dial the phony numbers (408) 555–XXXX and (212) 555–XXXX. Any phone call made to these exchanges will connect you to a fabulous movie celebrity or extra!")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Movie Medicine Men.")]), _vm._v(" No disease is incurable for the elderly doctors or medicine men of third-world cultures, who always produce a secret powder or herb. The medicine’s action is triggered by the simple poetic philosophy which accompanies the treatment.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("“Mr. Electricity Is Our Friend” Principle. ")]), _vm._v("The safety fence around a transformer or similar high-voltage equipment magically becomes charged when a bad guy is thrown against it, invariably with spectacular results. When the good guy hits the same fence earlier in the fight, nothing happens.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Eric Amick, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Columbia, Md.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Mr. Magooser Interface.")]), _vm._v(" Computers in movies are often unable to display anything more than three lines of very large letters during normal operations. All the computers in the Star Trek films, for instance, sport the classic Magooser Interface; during a crisis, all screens clear themselves of useful information and display red alert in jumbo letters, instead of informing the crew what exactly the problem is and how they might solve it.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Multiple Death Requirement.")]), _vm._v(" In virtually all action films, the primary villain or antagonist in a film must be dispatched in more than one fashion. It is sufficient for minor characters to be killed by a solitary method (shot, stabbed, neck broken, dropped from a great height, maimed, burned, crushed, mauled, etc.), but the villain must be killed in several ways at once. There are dozens of examples of death by two means. The most common is for the villain to be fatally shot and then finished off by a more creative method, as in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Die Hard ")]), _vm._v("(shot and dropped from a great height), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fatal Attraction ")]), _vm._v("(drowned and shot), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Indiana Jones and the Temple of Doom ")]), _vm._v("(dropped from a great height and eaten by alligators), and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Goldeneye ")]), _vm._v("(dropped from a great height and crushed). Death by three simultaneous means is rare but not unheard of, as in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rambo III ")]), _vm._v("(dropped from a great height, neck broken, and blown up) and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Last Boy Scout ")]), _vm._v("(shot, dropped from a great height, and chopped to pieces by a helicopter’s blades).")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Mark Killefer, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Knoxville, Tenn.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Murphy’s Law.")]), _vm._v(" In movies made before 1985, any character named “Murphy” was a cop, a priest, a drunk, a tough guy, or all of the above. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Murphy’s Romance ")]), _vm._v("was the first to break with this rule. Prior to TV’s Murphy Brown, all Murphys were male. Any character named Murphy will sooner or later be shown in a saloon, or drinking heavily.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Robert F. Murphy, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Providence, R.I.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Musician’s Close-Up Rule.")]), _vm._v(" All quick cuts to nightclubs begin with a close-up of the drum being whacked. The camera then backs off the close-up of the whacking hands to reveal the full musician, the rest of the band, and finally the audience. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ed Wood, Batman Forever, ")]), _vm._v("etc.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Steven Souza, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Honolulu, Hawaii")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Myopia Rule.")]), _vm._v(" Little girls who wear glasses in the movies always tell the truth. Little boys who wear glasses in the movies always lie.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Gene Siskel")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Myopic Visionary.")]), _vm._v(" In movies in which time travel or nostalgia takes us back to the 1940s or 1950s, the obligatory character who is loudly skeptical of the viability of television or Japanese industry announces he’s about to go out and buy an Edsel.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Mysterious Object Antecedents Myth.")]), _vm._v(" Whenever a movie involves time travel, there will always be an object that travels between the past and future without ever having actually come from anywhere. Example: In the beginning of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Somewhere in Time, ")]), _vm._v("an old Jane Seymour gives the young Christopher Reeve a pocket watch. He travels back in time to find her, taking the watch with him, and accidentally leaves it there. She keeps it, grows old, and—voilà—the cycle repeats itself. But where did the pocket watch come from in the first place?")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Barbara Kelsey")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Mystery Guest.")]), _vm._v(" At a crowded table, the sole empty chair and place setting, positioned right between the camera and the actors. Traditionally placed there in memory of L. B. Mayer, whose second coming was foretold by the prophet Winchell.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Mystery of the Levitating Ghost.")]), _vm._v(" If the hero can jump through the wall of the moving subway train, why doesn’t he fall through the floor?")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Bill Becwar, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wauwatosa, Wis.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Myth of the Seemingly Ordinary Day.")]), _vm._v(" The day begins like any other, with a man getting up, having breakfast, reading the paper, leaving the house, etc. His activities are so uneventful they are boring. That is the tip-off. No genuine ordinary day can be allowed to be boring in a movie. Only seemingly ordinary days—which inevitably lead up to a shocking scene of violence, which punctuates the seeming ordinariness.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "img ",
    attrs: {
      "alt": "",
      "src": "images/img_70.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Nah Reflex.")]), _vm._v(" Character sees someone but can’t believe his eyes,so shakes his head and says, “Nah.” Inevitably it is the person it couldn’t be.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("John Weckmueller, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Menomonie, Wis.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Naked Truth.")]), _vm._v(" The more notorious the nude scene, the harder it will be to take the actor/actress doing it seriously as a performer. The more credible the actor/actress already is, the less notorious the nude scene will be.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("National Geographic Rule.")]), _vm._v(" Full frontal nudity in foreign films is called art. In American movies, it’s called pornography.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("David Stevens, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Irving, Tex.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Nazi Sentry Syndrome.")]), _vm._v(" Nazi soldiers on sentry duty invariably suffer from acute drowsiness. Their peripheral vision shrinks to the area directly in front of them, and they become hard of hearing. When attacked, their vocal chords can produce only muffled Teutonic grunts.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("David Nevard, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Waltham, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Near Miss Kiss.")]), _vm._v(" The hero and heroine are about to kiss. Their lips are a quarter of an inch apart—but then they’re interrupted.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Douglas W. Topham, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Woodland Hills, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Necessity of the Elaborate Weapon.")]), _vm._v(" Any film containing a character who used to be an elite soldier of any kind will have him elect to use a weapon that looks like a reject from the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Star Wars ")]), _vm._v("effects shop. There will be a scene where the hero assembles this weapon from a foam-lined aircraft-aluminum suitcase.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dawson Rambo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tucson, Ariz.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Neckage Ploy.")]), _vm._v(" The marketing theory that large expanses of a woman’s bare neck on a video box will give the impression that the movie contains eroticism, thereby causing it to be rented.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("David Stevens, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Irving, Tex.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Neon Sign Rule.")]), _vm._v(" Whenever the leading male is hiding out or thrown out of his house by his wife and has to spend the night in a sleazy hotel, he always gets the room with the hotel’s blinking neon sign right outside his window.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Eugene Accardo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Brooklyn, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Nerd Rule.")]), _vm._v(" In any teenager movie the nerd character will, by the end of the film, be dating the prettiest girl in the school, proving that nerds are people too.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Lisa Martin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Toronto")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("New Tenant Rule.")]), _vm._v(" Large corporations are always situated in the flashiest, shiniest, tallest, most imposing, and architecturally dazzling buildings in town. Their names, however, always look like they were painted with poster paint on cardboard by an apprentice in the studio sign shop.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("John Mayer, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("North Hollywood, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Newton’s Fourth Law.")]), _vm._v(" Heroes in movies who fall from great heights will land on shrubs, cardboard boxes, awnings, or something else that cushions their fall. Villains land on steel fence posts, or in the path of a speeding bus.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jeffrey R. Field, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kansas City, Mo.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Newton’s Laws Repealed.")]), _vm._v(" In which action becomes mysteriously decoupled from reaction, usually in connection with a firearm. Typically, a bullet from the hero’s handgun lifts the villain off his feet and hurls him backward (often through one of those ubiquitous plate-glass windows that cars like to drive through) while the hero doesn’t budge "), _c('br'), _vm._v("a millimeter. (Action equals reaction, right? The hero should be hurled backward with equal force.)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Robert J. Lang, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Altadena, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Nicolas Cage Wig-Out Scene.")]), _vm._v(" No Nicolas Cage movie is complete without the scene in which Cage’s character finally loses his temper and screams at the top of his lungs. The finest example is in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Red Rock West, ")]), _vm._v("where he shouts “%*&! Mexico!” at Lara Flynn Boyle.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Tom Cammalleri, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Newbury Park, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Nightmare Reflex.")]), _vm._v(" Character wakes from a nightmare by sitting bolt upright in a bed with bulging eyes and sweat all over his face.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Fraser Smith, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tampa, Fla.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Niner Rule.")]), _vm._v(" Whenever a movie requires the use of military-style radio transmission (i.e., “Romeo Oscar Golf Echo Romeo” for “Roger”), if any numbers are being transmitted, one of them will always be “Niner,” because it sounds so cool.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dawson Rambo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tucson, Ariz.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Nineteen RMS W/VU.")]), _vm._v(" Unless the point is to establish poverty, the apartments occupied by movie characters always look much larger and more expensive than anyone on their salary could afford. If the point is to establish “colorful” poverty, the occupants are so poor they can only afford to furnish with antiques.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Noble Savage Syndrome.")]), _vm._v(" Thrown into the company of a native tribe of any description, the protagonist discovers the true meaning of life and sees through the sham of modern civilization. Wisdom and sensitivity are inevitably possessed by any race, class, age group, or ethnic or religious minority that has been misunderstood. Such movies seem well intentioned at first glance, but replace one stereotype for another; the natives seem noble, but never real. They may be starving, but if they’re noble and have a few good songs, why worry?")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Robert F. Murphy")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("No Cigar Rule.")]), _vm._v(" No film with fewer than five nominated Academy Awards can win for Best Picture.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Gerald Fitzgerald, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dallas")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("No Corpus Delicti.")]), _vm._v(" If a movie begins with a murder and the body is never found, the supposed victim is not really dead and will pop up at the end, revealed as the perpetrator of all subsequent killings.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Michael Schlesinger, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Culver City, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("No-Fail Pregnancy Predictor.")]), _vm._v(" Any woman of childbearing age in any movie who is ever nauseous.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Barak and Elizabeth Moore, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jerusalem, Israel")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Non-Answering Pet.")]), _vm._v(" In any horror or suspense movie, if the family pet does not come after being called at least twice by the protagonist or a member of his family, he is dead. This sometimes happens after he has served as an example of the Law of Canine/Feline Superperception (q.v.).")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("John Shannon")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Nothing? Nothing Will Come of Nothing!")]), _vm._v(" If a character has something he finds hard to say, the dialogue will go like this: “John?” “Yeah?” (Brief pause.) “Nothing.”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Will Griffin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bristol, England")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Nothing Says Loving Like a Dial Tone. ")]), _vm._v("Standard scene in romance: Romeo rushes out into dark and stormy night to a pay phone to call Juliet. He puts in quarter and dials. Juliet answers: “Hello? HELLO?” Romeo says nothing, and hangs up. Juliet hears the dial tone and stares at the receiver, wondering who it possibly could have been.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("David Nemetz, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Not-So-Bad Bad Guy.")]), _vm._v(" He kills people, therefore, he is worse than the Good Bad Guy (q.v.). However, he is not a villain if he never kills women or children. He only kills their husbands, sons, brothers, or fathers, but nobody’s perfect.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Alexis S. Mendez, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aguadilla, Puerto Rico")])]), _vm._v(" "), _c('img', {
    staticClass: "img ",
    staticStyle: {
      "page-break-before": "always"
    },
    attrs: {
      "alt": "",
      "src": "images/img_28.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Nuns and Sailors Rule.")]), _vm._v(" Every single airport and train station waiting room in the movies contains both nuns and sailors.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Teresa Gregory, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Indianapolis, Ind.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "img ",
    attrs: {
      "alt": "",
      "src": "images/img_55.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Obligatory M & M Shot.")]), _vm._v(" Every movie that features a scene in an Arab or Islamic country will begin the scene with a shot of a mosque tower (minaret), or the sound of the muezzin, or both.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Osamah Abdullatif, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Muscat, Oman")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Obligatory Nightgown Rule.")]), _vm._v(" Every adult woman getting out of bed in every movie will pick up a nightgown from the foot of the bed and put it on. Virtually no one can identify an instance of this happening in real life.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("David Stevens, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Irving, Tex.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Obligatory Transformational Entrance Scene.")]), _vm._v(" After being an ugly duckling for three-quarters of the movie, the heroine inevitably turns up at the top of a monumental staircase, looking breathtakingly beautiful and regal, and descends the stairs trying her best to keep one of those “are they looking at poor little me?” looks on her face.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Obligatory Unrelated Opening Crisis.")]), _vm._v(" In any big-budget action movie, the spectacular title sequence never has anything to do with the rest of the story.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Odd Couple Formula.")]), _vm._v(" Seemingly incompatible characters are linked to each other in a plot which depends on their differences for its comic and dramatic interest (c.f. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tango and Cash, Homer and Eddie, Lethal Weapon, Loose Cannons")]), _vm._v("). Essential that one member of each team be a slob, as revealed by presence of fast-food wrappers in backseat of his Hollywood Cop Car (q.v.).")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Odd Information Clue.")]), _vm._v(" Bad exposition is often a giveaway to plot points, since there must be a reason why we’re getting all this otherwise inexplicable information. The most trivial fact delivered in the most offhand manner in Act I will prove monumentally significant, come denouement time.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jeff Levin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rochester, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Odds on Edge Rule.")]), _vm._v(" The odds that a car in real life will be able to travel any appreciable distance balanced on two wheels: 1 in 7 million. The odds that this will happen during a chase scene in a movie: 1 in 43.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("O’Guffin.")]), _vm._v(" Inspired by Hitchcock’s MacGuffin (q.v.). A scene or sequence that has nothing to do with the plot of the film. Usually found lurking in B-movies, as an entertainment filler device, to mask the fact that the film has little or no actual story. See the Compulsory Topless Bar Scene in most R-rated cop action movies.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jim and Rose Pfeifer, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Southfield, Mich.")])]), _vm._v(" "), _c('img', {
    staticClass: "img ",
    staticStyle: {
      "page-break-before": "always"
    },
    attrs: {
      "alt": "",
      "src": "images/img_29.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Old Car Omen of Doom.")]), _vm._v(" Any best friend, suspect, informer, or witness who drives a car more than five years older than the cars owned by the rest of the characters in the film will be destroyed along with the car (via cliffs, explosions, etc.) before the film is over.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Omar the Folding Tentmaker.")]), _vm._v(" Whenever a movie hero is suddenly interrupted in the midst of a passionate sexual performance and is required to stand up (in undies or with a towel), he never reveals any physical evidence of his recent arousal.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("John Starr, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Glendale, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Omens of War.")]), _vm._v(" (1) One man shows another a photo of his wife, kids, sweetheart, etc. This photo always reappears when the man is killed, to remind us of his warmth. (2) Man on guard duty says to comrade, “It’s quiet.” The laconic reply is always, “Yeah . . . too damn quiet!” (3) When seated around a fire on the eve of battle, a harmonica is often played by a young boy who later dies a hero’s death. His body is later shown in close-up, harmonica still in hand.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Max Thompson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kent, England")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Omnipresent Hydrant Rule.")]), _vm._v(" No car in a movie ever jumps over a curb without hitting a fire hydrant, which immediately splits open and sprays high into the air.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("One-at-a-Time Attack Rule.")]), _vm._v(" In any situation where the hero is alone, surrounded by dozens of bad guys, they will always obligingly attack one at a time. See any Schwarzenegger movie.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Barbara Kelsey")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("One-Hour Hollywoodizing.")]), _vm._v(" No matter how wet or dirty they get, actors look good only one scene later. This is because movie stars have the Full-Body Scotchguard treatment done as soon as they hit it big. This works for casual water, sweat, drinks, blood, and all sorts of other fluids.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Christopher G. Johnson")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("One Punch Fallacy.")]), _vm._v(" The myth that any movie hero can knock out any villain with a solid right to the jaw. (In any collision between a human skull and an unprotected human hand, the hand will be the worse for the experience.)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v(" Anthony Bruce Gilpin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Riverside, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("One Sex at a Time.")]), _vm._v(" In any movie in which a man and a woman are both struggling with addiction, the protagonist man will find the strength to survive, but the woman will be destroyed. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Clean and Sober, The Boost, Days of Wine and Roses, ")]), _vm._v("etc.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Fran Pelzman Liscio, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Upper Montclair, N.J.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("One Size Fits All (1).")]), _vm._v(" Any stolen clothing or shoes will perfectly fit any male character whether they were stolen from a clothesline or removed from a Nazi guard, police officer, lookout, etc., who was overpowered and whose identity the clothing thief has now assumed.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dona Kight, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("One Size Fits All (2).")]), _vm._v(" If a woman character steals clothing to disguise herself, the clothing, if male, will be too big. If female, it will be much too skimpy and revealing.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("One-Trick Pony Rule.")]), _vm._v(" Whenever a character displays an unusual talent or trick early in a thriller, it will later be used to save his or her life (e.g., Tom Cruise’s gymnastics in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Firm")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Martina O’Boyle, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dallas")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Only One Man Can Rule.")]), _vm._v(" When it is stated that “only one man can (solve this crime, save the world, bring this man to justice, etc.),” you can be sure that that one man is now retired or was kicked off the force and must now be lured into action.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Oops, Sorry! Rule.")]), _vm._v(" Character sees person from behind on street, thinks it is someone he knows, runs up and confronts person, inevitably to discover it is someone else.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dan Saunders, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oakland, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Open Motel Bathroom Rule.")]), _vm._v(" In a low-budget action movie, when the hero is lying on the bed in a motel, watching TV, the door to the bathroom will be open, and the young female star will walk from the shower to the mirror in the bathroom, exposing her bare back, then turn to ask the hero a question.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("David Stevens, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Irving, Tex.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Orwell that Ends Wells.")]), _vm._v(" The inability of filmmakers to look into the future and see anything except cataclysmic wars, mass nuclear destruction, oppressive automation, uncontrollable crime, emotionally sterile environments, and ruthless police states in films like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("1984, Sleeper, Back to the Future II, The Terminator, RoboCop, Brazil, Strange Days, ")]), _vm._v("etc. Also see “Postapocalyptic Mechanical Darwinism.”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Oscilloscope Fantastic.")]), _vm._v(" Test instruments are used to display Lissajous figures, sine waves, or other meaningless curves and lines to suggest that something mysteriously technical is happening in the laboratory.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Charles Peklenk")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "img ",
    attrs: {
      "alt": "",
      "src": "images/img_56.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Paint and Sufferink.")]), _vm._v(" Violent scenes in a G-rated animated feature which would have guaranteed the film at least a PG if it had been shot in live-action.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Parent/Child Polarity Predictor.")]), _vm._v(" In the movies, if the parents are good the kids will be bad, or vice versa, unless they get along, in which case they’re either both good or both bad.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Steve Wideman, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Birmingham, Ala.")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('em', {
    staticClass: "italic "
  }, [_vm._v("The above entry inspired the following exchange in the Answer Man column:")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Q.")]), _vm._v(" You recently ran the following Movie Glossary entry: “In the movies, if the parents are good, the kids will be bad, or vice versa, unless they get along, in which case they’re either both good or both bad.” What other cases are there? christoper g. johnson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Birmingham, Ala. ")]), _vm._v("The Answer Man replied: “None. This splendid Glossary entry covers the entire range of possibilities.”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Parking Lot Shot.")]), _vm._v(" The long shot toward the end of the movie that causes a third of the audience to stand up, put on their coats, and head for the parking lot, whether or not the film is actually over.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Ed Slota, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Providence, R.I.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Party Movie.")]), _vm._v(" The gathering of a loose affiliation of stock players, friends, relatives, star wanna-bes, hangers-on, and professional acquaintances making cameo appearances under the vague notion that a movie is being made. At best, the host is Robert Altman and the end result is art "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Nashville, The Player). ")]), _vm._v("At worst, the host is Andy Warhol and the result is junk "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Lonesome Cowboys). ")]), _vm._v("Usually the host is like Burt Reynolds and the result is lowbrow entertainment "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Smoky and the Bandit, Hooper, The Best Little Whorehouse in Texas, Cannonball Run, Stroker Ace). ")]), _vm._v("Woody Allen is king of the A-list Party Movies.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Pass Bypass Principle.")]), _vm._v(" Any theater that accepts passes will invariably exclude their use for any movie worth seeing.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Mike Silverman, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Holliston, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Pathetic Fallacy, Demon Seed Division.")]), _vm._v(" There is a high correlation between thunderstorms and the births of children who will grow up to be evil. The storms grow more violent as the contractions get closer. When the child is born, the mother dies, thunder booms, and lightning reflects from the walls onto the face of the horrified midwife, who screams at the monstrous infant.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jerry D. Roberts, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hoover, Ala.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Pavarotti Syndrome.")]), _vm._v(" When a superstar in one area tries to extend his success into movies by starring in a specially conceived vanity project. Examples: Luciano Pavarotti in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yes, Giorgio, ")]), _vm._v("Kurt Thomas in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gymkata, ")]), _vm._v("Mitch Gaylord in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("American Anthem, ")]), _vm._v("Evel Knievel in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Viva Knievel!, ")]), _vm._v("Liberace in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sincerely Yours, ")]), _vm._v("Olivia Newton-John in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Xanadu, ")]), _vm._v("Bruce Jenner and the Village People in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Can’t Stop the Music, ")]), _vm._v("Paul Simon in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("One Trick Pony, ")]), _vm._v("Bob Dylan in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Renaldo and Clara, ")]), _vm._v("Neil Diamond in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Jazz Singer, ")]), _vm._v("Madonna’s film career.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Peacenik Placard Rule.")]), _vm._v(" The person who paints the slogans must ensure that the peace sign is rendered without the vertical downward stroke. This ensures that the sign resembles the Mercedes-Benz logo as closely as possible.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Matthew Cope, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Montreal")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Pee Principle.")]), _vm._v(" Containers of urine in the movies have a surprisingly good change of being either spilled or drunk. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Slums of Beverly Hills, Holy Man, ")]), _vm._v("and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dead Man on Campus.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_vm._v("Tom Meyer, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Penguin Error.")]), _vm._v(" Bad guy keeps good guy alive to witness the great evil he will commit, allowing good guy to prevent it. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Under Siege, ")]), _vm._v("where the evil genius played by Tommy Lee Jones makes the fatal mistake of keeping Steven Seagal alive to witness the destruction of Honolulu. Named for the Penguin and all the other Batman enemies, who made this error weekly in the old series. See also “Fallacy of the Talking Killer.”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Joseph Holmes")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Pentimento Paradigm.")]), _vm._v(" Pentimento is when images from an old painting seep through and become visible in a newer picture that has been painted over the old. The Pentimento Paradigm is when what we know about a filmmaker or actor seeps into our perception of his film work. Example: Any old Rock Hudson movie, now that his private life is no longer private. Being aware of the reality behind the fiction may add to the complexity of the drama (Taylor and Burton in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who’s Afraid of Virginia Woolf?")]), _vm._v(") or distract from its intentions (Woody and Mia in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Husbands and Wives")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('img', {
    staticClass: "img ",
    staticStyle: {
      "page-break-before": "always"
    },
    attrs: {
      "alt": "",
      "src": "images/img_30.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Perfectly Alternated Vehicle Rule.")]), _vm._v(" During all car chases through traffic, all of the vehicles not directly involved in the chase are arranged so that the chase vehicles can weave left and right continuously, as in a “Road and Track” handling test.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Tom Ratcliffe, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Toronto")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Perk Girl.")]), _vm._v(" Used as an emblem of the hero’s power. Appears in early scene, usually unclothed, with fashionable body. We usually do not see her face. She has no dialogue. She walks across the frame, a possession he takes for granted. Even though it seems from the context that they have an easy intimacy, we never see her again in the movie, nor is she ever referred to. See opening of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wall Street.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Michael E. Isbell")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Perot Principle. ")]), _vm._v("The tendency of movie Texas billionaires to do the wackiest things. If they’re not running for president, they’re making loudmouthed fans the coach of their NBA team or willing a total stranger $10 million provided they find and marry any woman named Constantia Ruble by the end of the month.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Personal Interest Rule.")]), _vm._v(" Any sequel using the advertising line, “. . . And this time, it’s personal!” will have essentially the same plot as the first movie.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Mark McDermott, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Park Forest, Ill.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Pet Homosexual.")]), _vm._v(" The lone gay man who establishes the characters’ liberal tolerance as either the heroine’s best friend (David Wayne in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Adam’s Rib, ")]), _vm._v("Roddy MacDowell in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Funny Lady, ")]), _vm._v("James Coco in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Only When I Laugh, ")]), _vm._v("George Carlin in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Prince of Tides, ")]), _vm._v("Rupert Everett in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("My Best Friend’s Wedding, ")]), _vm._v("Nathan Lane in anything, etc.) or the sensitive extra person in a group (Greg Kinnear in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("As Good as It Gets, ")]), _vm._v("Steve Zahn in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reality Bites, ")]), _vm._v("Kris Kamm in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("When the Party’s Over, ")]), _vm._v("Paul McCrane in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fame, ")]), _vm._v("Larry B. Scott in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Revenge of the Nerds, ")]), _vm._v("etc.). He can talk incessantly about sex (Meshach Taylor in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mannequin")]), _vm._v("), as long as he never actually has any.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Phantom Karaoke Machine.")]), _vm._v(" Unseen electronic prompter which explains how a small group of people who spontaneously take to a stage happen to know an entire number by heart, including harmonies and stage choreography. . . . Especially useful when the performers come from an era which precedes the song by decades.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Phantom Phantom Rule.")]), _vm._v(" In any case where a movie crew member or unauthorized person accidentially appears in the background of a shot, a legend will develop to explain the appearance—usually involving suicide, a shotgun, and the spirit of the deceased haunting the set. Examples: the folklore surrounding "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Wizard of Oz ")]), _vm._v("and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Three Men and a Baby.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Colin M. Chisholm")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Phantom Photographer. ")]), _vm._v("A family’s vacation snapshots always include every family member, even if they were twenty miles from the nearest neighbor. Who took the picture, the family dog?")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Alessandra Kelley, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Phone Trace Game.")]), _vm._v(" When a criminal phones the police, he is kept talking as long as possible. However, since he always knows when to hang up, this process is never successful.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Max Thompson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kent, England")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Physician, Heal Thyself.")]), _vm._v(" Any doctor taking on a tough case also has a problem of his own that the treatment of the patient will cure. Especially true of psychiatrists. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Good Will Hunting.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Lee Fyock, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Natick, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Pig Skin Movie.")]), _vm._v(" Any direct-to-video film about a female police officer going undercover in any sex-related industry (prostitute, stripper, phone-sex operator, etc.). Such movies usually feature Lorenzo Lamas or Leo Rossi in a costarring role.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dawson Rambo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tucson, Ariz.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Pillow Effect.")]), _vm._v(" When we see what is apparently a body under the covers of a bed, and the body is then fired at, the odds are good it’s only carefully arranged pillows. This discovery often leads to a jailbreak, sneak attack, etc., by the person thought to be in the bed.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Pill Rule.")]), _vm._v(" When a character is forced to take a pill, a later scene will show the character spitting the pill out.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("John Gekle "), _c('span', {
    staticClass: "city-state"
  }, [_vm._v("Jr., ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Whiting, N.J.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Ping Effect.")]), _vm._v(" When there is a movie close-up of a famous diamond, it inevitably emits a computer-generated sparkling flash, while there is a bright little “ping” on the sound track.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Plot Pointer.")]), _vm._v(" Character who appears, delivers no more than a half-dozen lines of dialogue crucial to the plot, and then disappears for good. Plot Pointers are raised and trained exclusively for the movie industry on a free-range farm in Vermont, and descend from a breeding pair originally developed in 1932 for MGM musicals.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Plugola Warning.")]), _vm._v(" If a movie trailer ends with a list of the artists on the film’s sound track, there is an 80 percent chance the film will be terrible.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Scott Held, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dearborn, Mich.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Plumber’s Friend Rule.")]), _vm._v(" When a movie pans across a room while featuring the offscreen sound of energetic lovemaking, the actual source of the sound is invariably revealed as non–sex-related.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Pocket Baffle.")]), _vm._v(" Handy liner that prevents a movie character’s keys, coins, etc., from jingling until they are actually removed from his or her pocket. Never actually seen, but a theoretical necessity.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Brannon Moore, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Seattle")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Pointy Object Principle.")]), _vm._v(" If the bad guy attacks the good guy with a sharp object during a fight and it gets embedded in the wall or floor, the bad guy will be killed by it, generally by falling on it.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Eric Amick, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Columbia, Md.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Poisoned Phone Booth.")]), _vm._v(" Any time the hero, on the run, stops at a phone booth to call for help, he inevitably reaches the person trying to kill him. The villain tells the hero to stay right there, then sends killers to finish him off. The hero wanders away and an unsuspecting extra enters the phone booth, where "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he’s")]), _vm._v(" the one machine-gunned instead. Cut to: the hero, the horrified look on his face showing us he now understands The Full Extent of the Conspiracy.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("David Daniel, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Smyrna, Ga.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Police Escort Pause.")]), _vm._v(" Two police officers taking away an apprehended criminal will always pause as they pass the protagonist in order to allow the criminal to say something really nasty, vow revenge, or perhaps just spit.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Joseph Holmes")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Polite Killer Rule.")]), _vm._v(" It is a rule of horror etiquette that a monster must wait—all night if necessary—by a window in the intended victim’s home until such time as he is effectively invited in by said victim opening a curtain and looking out of this window. Then and only then does the glass become breakable, and the monster or mad slasher is able to crash through and attack the intended target. This is an extension of the child’s Monster under the Bed Rule (monsters under the bed cannot pull you off the bed unless you dangle a limb over the edge).")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Frank P. Scalfano")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Poor Phone Manners.")]), _vm._v(" No one ever says “good-bye” when talking on the phone in the movies. The conversation ends, according to the script, and the character just hangs up the phone.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dawson E. Rambo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pelham Manor, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Pops Principle, The.")]), _vm._v(" In movies with teenage characters, there is usually a character named Pops who runs the local hangout or dance club.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Donald Munsch, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sherman, Tex.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Portentous Porter Prognostication.")]), _vm._v(" In any movie featuring a mountain-climbing or jungle expedition employing native porters, the porters inevitably quit midway through the trek because of bad jou-jou, evil spirits, or some other seemingly silly portent of doom. The porters are inevitably proven to be right on the money.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Karl McBurnett, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Euless, Tex.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("PO Rule.")]), _vm._v(" No matter how many car chases, action set pieces, shoot-outs, or explosions have occurred, the villain is never really ready to be captured or killed until the hero picks himself up, dusts the broken glass off, sniffs the cordite in the air, and says, “Now he’s really beginning to piss me off!”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dawson E. Rambo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pelham Manor, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Possessed Golf Cart.")]), _vm._v(" Any layperson who gets behind the wheel of a golf cart will eventually drive the vehicle into the nearest body of water. (Cf. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Legal Eagles, Stakeout, ")]), _vm._v("etc.) Dan Gutowsky, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lansing, Mich.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Possible Implausible Rule.")]), _vm._v(" Movie audiences are quicker to accept the impossible than the implausible.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("David Burd, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("East Stroudsburg, Pa.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Postapocalyptic Mechanical Darwinism.")]), _vm._v(" Doctrine that holds that in any movie set in the postapocalyptic future only the most destructive products of society will survive, i.e., guns, explosives, fast cars, nuclear devices, cigarettes. Common, plentiful, and beneficial things (toasters, telephones, indoor plumbing) will have perished from Earth. Example: In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Waterworld, ")]), _vm._v("clumsy, impractical jet skis survived while millions of other boats, from dinghies to ocean liners, apparently did not.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Preemptive Nudity Ratio.")]), _vm._v(" The probability of the female star being seen nude decreases in inverse proportion to the number of other nude women in the movie. See “Female Star in a Topless Bar Rule.”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("David Stevens, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Irving, Tex.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Premature Disarmament (1).")]), _vm._v(" Movie heroes have a habit of optimistically tossing away their weapons too soon. This act is usually preceded by the Instant Diagnosis Syndrome, where the hero, after a first strike/punch/hit, wrongly decides after a cursory glance that the bad guy is unconscious, dead, or disabled.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Harrison Cheung")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Premature Disarmament (2).")]), _vm._v(" In horror films, after the monster has apparently been killed, the heroine inevitably drops her weapon, usually flinging it away in disgust. The monster is, of course, still alive.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Prematurely Lightened Loads (aka, the “Leave It, It’s Too Heavy and Besides it Might Save My Life” Syndrome).")]), _vm._v(" Situations where the good guy disables the first of many bad guys and when given the choice to take the bad guy’s guns and ammo, doesn’t do so. Also applies to water, radios, flare guns, car keys, maps, and the like.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Eric M. Davitt, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Toronto")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Premature Tune Out Rule.")]), _vm._v(" Guilty characters listening to reports of their escape always angrily switch off the news in midreport instead of listening for valuable information. ")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Tom Kuennen, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lincolnshire, Ill.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Pre-1980 Matutinal Nonnudity Rule.")]), _vm._v(" Even if they have had four hours of rumpy-pumpy the previous night, when people get out of bed the next morning they always prudishly cover their exits with a sheet.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Hilary Potts, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("West Ealing, London")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Principle of Evil Marksmanship.")]), _vm._v(" The bad guys are always lousy shots in the movies. Three villains with Uzis will go after the hero, spraying thousands of rounds which miss him, after which he picks them off with a handgun.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jim Murphy, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York City")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Principle of Inverse Critical Plausibility.")]), _vm._v(" The proven inverse relationship between the quality of a film and the number of rave reviews in its ads which originated from publications and TV shows with the word “Hollywood” in their titles.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Principle of Pedestrian Pathology.")]), _vm._v(" Whenever a character on foot is being pursued by one in a car, the pedestrian inevitably makes the mistake of running down the middle of the street, instead of ducking down a narrow alley, into a building, behind a telephone pole, etc. All that saves such pedestrians is the fact that in such scenes the character on foot can always outrun the car.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Stuart Cleland, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Principle of Selective Lethality.")]), _vm._v(" The lethality of a weapon varies, depending on the situation. A single arrow will drop a stampeding bison in its tracks, but it takes five or six to kill an important character. A single bullet will always kill an extra on the spot, but it takes dozens to bring down the hero.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Barry Zimmerman")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Product Displacement.")]), _vm._v(" The opposite of product placement: Peculiar practice in old movies and TV shows of disguising the brand names of products. A cereal box on the breakfast table might have a brightly colored rooster and the words “Corn Flakes” on it, but the word “Kellogg’s” is absent, painted over so that the top third of the box is mysteriously blank. A police radio might announce an APB on a “1963 four-door gray sedan,” but leave out the important fact that it is a Ford Fairlane.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Projection Rejection.")]), _vm._v(" Any scene taking place in a movie theater projection booth will feature old-fashioned, nostalgic reel-to-reel projectors, even though they have been out of date for at least two decades. No movie has ever shown modern automated platters. The projectionist will be a slow-moving old-timer, rather than an underpaid teenager.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Prop Recycling.")]), _vm._v(" Sci-fi/fantasy movies sometimes borrow futuristic devices from each other because of low budgets. Example: The ghost detectors in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ghostbusters II ")]), _vm._v("became motion detectors in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("They Live.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Terry Fox")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Proxy Plastic Surgery Rule. ")]), _vm._v("When a female star "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("uses")]), _vm._v(" a body double for her nude scenes, the double will always have larger, firmer breasts.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("David Stevens, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Irving, Tex.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Psychic Flip.")]), _vm._v(" Amazing ability of any actor or actress to open a book to within five pages of the one they are looking for. If the proper page is not found on the first try, it will take no more than three flips to find it.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Kyle Sipples")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Psychic Geographical Position Finder.")]), _vm._v(" When characters in a movie invite people they have just met over to their houses, they almost never give them their addresses, so they must have some sort of inner sensors that collect this information for them.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Amy Cash, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Elmont, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Psychic Partner.")]), _vm._v(" In countless cop movies: (1) Hero comes in the door of his apartment/house to a ringing phone. (2) Answering it, he hears his partner say something like, “You’d better turn on channel 3 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("right now! ")]), _vm._v("(3) The hero does so, only to see a news report "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("just beginning ")]), _vm._v("that brings a crucial development or clue to the plot. Since the news report is just beginning, how did the partner know about it?")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dawson E. Rambo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pelham Manor, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Pull Over Rule.")]), _vm._v(" Whenever a cop pulls someone over in movie, he’s nearly as certain to be killed as if he had just announced the number of days until his retirement.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Ian Mantgani, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Liverpool, England")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Punkwear Syndrome.")]), _vm._v(" In any movie in which a gang of toughs suddenly jumps or in some way menaces the hero, one of them will always be wearing a tight knit shirt with horizontal black and white stripes, and a black vest.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Fran Pelzman Liscio, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Upper Montclair, N.J.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Push! Push! Scene.")]), _vm._v(" Obligatory natural childbirth scene, which is to boomer movies what the chase is in a Dirty Harry picture. Modern version of the old “boil water, hot water, and lots of it!” scene.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("QT Kiss of Death.")]), _vm._v(" If a hot new director is called “The next Quentin Tarantino,” his next release will sink. This is very much akin to a singer being proclaimed “The next Dylan,” or the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sports Illustrated ")]), _vm._v("cover jinx. Also applies to Tarantino.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Mark McDermott, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Park Forest, Ill.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Quick Recovery Syndrome.")]), _vm._v(" Any person critical to the movie’s sequel (such as the hero’s buddy) can be on the edge of death throughout the film, but by the end of the movie recovers fully. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beverly Hills Cop II, ")]), _vm._v("where Ronny Cox is shot in the heart at point-blank range but is ready to leave the hospital within seventy-two hours, or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Licence to Kill, ")]), _vm._v("where Bond’s newlywed buddy loses the lower half of his body to a shark, but is joking at the film’s end.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Ted Miller, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Green Bay, Wis.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Radar Bullet Phenomenon.")]), _vm._v(" A mysterious force which ensures that if a bullet does not hit a major character in an instantly lethal place (i.e., the head or heart), it won’t hit any bones or vital organs, and will rarely do serious damage. In the truck chase in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Raiders of the Lost Ark, ")]), _vm._v("for example, Indy is shot in the upper arm, from the side. The bullet doesn’t break his arm, though from that angle it should, and he retains full use of his arm. Near the end of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("RoboCop, ")]), _vm._v("the bad guy shoots Murphy’s partner Lewis half a dozen times with a large-caliber pistol, but she’s still able to crawl twenty or thirty feet, and then lift, aim, and fire a huge rifle.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jon Woolf, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Beavercreek, Ohio")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Radio Pictures.")]), _vm._v(" A character’s dialogue describes what we can clearly see happening on the screen. Critic Rich Elias tags an all-time classic when he observes that Jack, in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Titanic, ")]), _vm._v("says, “Let’s get out of here! This place is flooded!”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Tom Norris, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Braintree, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Rain as Emotion Syndrome.")]), _vm._v(" When an actor is unable to register shock, the director calls for rain and instructs the actor to make no attempt to avoid getting wet.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Nigel Searle, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Venice, Fla.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Rattlesnake Rectal Regulation.")]), _vm._v(" In any comedy set in the Old West, if a character lowers his pants to move his bowels, he will be horrified to find he has chosen a secluded spot that is home to a rattlesnake. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("City Slickers II ")]), _vm._v("and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lightning Jack.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('img', {
    staticClass: "img ",
    staticStyle: {
      "page-break-before": "always"
    },
    attrs: {
      "alt": "",
      "src": "images/img_31.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Real Cut-Up.")]), _vm._v(" Medical examiners in the movies take great pleasure in displaying gallows humor when civilians (usually cops) come to visit. They’re usually snacking or making very graphic comments in an effort to make the visitor sick. Examples: Gregory Hines in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfen, ")]), _vm._v("John Sayles in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Howling, ")]), _vm._v("M. Emmet Walsh in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("White Sands, ")]), _vm._v("Clint Howard in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Backdraft, ")]), _vm._v("and one of the funniest examples, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Enforcer.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Lee Stoneman, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("El Reno, Okla.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Rebellious Teenage Daughters.")]), _vm._v(" The teenage daughters of police officers/federal agents/private investigators always dress up like little tramps until the end of the movie, where they will reemerge as wholesome-girl-next-door types. See"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" The Last Boy Scout, True Lies, Face/Off.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Christopher M. Terry, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Atlanta, Ga.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Relevant Telephone Syndrome.")]), _vm._v(" In police headquarters, all calls are directly relevant to the case at hand. There is never a scene where the phone rings and the detective speaks, hangs up, and says, “That was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Better Homes and Gardens ")]), _vm._v("magazine. They wanted to know if I wanted to renew my subscription.”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Rick Benge, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Vienna, Austria")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Remote Clicking Syndrome.")]), _vm._v(" Whenever anyone in a movie points a remote at the TV, the Foley artists always feel compelled to add clicks to the sound track so that we all know that they are changing channels. “Clicking” remotes disappeared around 1970.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Michael G. Murashko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Los Angeles")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Retreads.")]), _vm._v(" In many car chase scenes, skid marks already exist on the road before the car spins out, indicating either that the vehicle was moving so fast that its tires got there four seconds before the rest of the car, or that we’re watching a third, fourth, or fifth take of the stunt.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Reverse Discrimination.")]), _vm._v(" Whoever backs up in a horror movie is about to die.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Don Howard, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("San Jose, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Reverse Doppler Effect.")]), _vm._v(" Phenomenon only found in movies where an incoming artillery shell is heard decreasing in pitch. I was quite surprised in Vietnam when, during the course of a mortar attack, the shells were heard to increase in pitch, as any physics student could have predicted.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("John D. McCluskey")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Reynolds Ramp.")]), _vm._v(" Heavy steel sewer pipes, railroad ties, or piles of dirt left in the road which cause cars to jump, flip, and/or barrel-roll in spectacular slow-motion fashion when they pass over them. N.B.: Force of attraction between a car and a Reynolds Ramp increases geometrically with the value, age, and scarcity of the car in question. No car driven by Burt Reynolds can avoid one.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Rising Sidewalk.")]), _vm._v(" No female character in an action film can flee more than fifty feet before falling flat on her face. Someone then has to go back and help her up, while the monster/villain/enemy gains ground.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("James Portanova, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fresh Meadows, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Rock Candy Postulate.")]), _vm._v(" No hero is ever cut by glass while leaping through windows.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Daniel Alvarado, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Arleta, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Rock ’n’ Roll Lite Rule.")]), _vm._v(" Whenever a fictitious rock star sings or plays, the music will be wildly cheered by thousands of screaming fans, even though it isn’t fit for a Kmart opening.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Sam Waas, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Houston")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Rock ’n’ Roll Rule.")]), _vm._v(" At a pivotal moment in an action movie when the hero is about to jet into space or attack the bad guys, he will shout, “Let’s rock and roll!”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Will Griffin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bristol, England")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Rolling Stone Star Turn.")]), _vm._v(" A star accepts a big paycheck, doesn’t like the movie he or she made, and publicly blames the director, writer, other actors, producer, agent, manager, etc. By dissociating self with picture, the actor hopes to reduce the number of viewers who will actually witness their halfhearted performance. Named for Sharon Stone’s dissing of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Diabolique ")]), _vm._v("prior to its release. Also see Sylvester Stallone re: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Judge Dredd ")]), _vm._v("and Marlon Brando before "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Freshman.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Tom Colgan, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Algonquin, Ill.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Roll Over, Beethoven.")]), _vm._v(" Any character seen intently enjoying classical music (especially opera) will do evil. Any character seen dancing and grooving to rock and roll will redeem and enlighten.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Neil Milsted, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('img', {
    staticClass: "img ",
    staticStyle: {
      "page-break-before": "always"
    },
    attrs: {
      "alt": "",
      "src": "images/img_32.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Roto-Rooter Rule.")]), _vm._v(" The badness of a movie is directly proportional to the number of helicopters in it.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dave Barry, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("from ")]), _c('span', {
    staticClass: "city-state"
  }, [_vm._v("25 Things I Have Learned in 50 Years")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Rotten Teeth Display.")]), _vm._v(" Characters with really bad teeth spend most of their time with their mouths gaping open and their lips pulled back, as if to say “Hey—these teeth took three hours of makeup, so we might as well get our money’s worth!”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Rover, Dead Rover Rule.")]), _vm._v(" In any movie that begins with lowering skies and ominous music, all dogs being taken on walks in the countryside discover dead bodies.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Rubbing It In.")]), _vm._v(" If a character has been injured earlier, the wound will be punched during the final fight, causing great but short-lived pain.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Anna Laux, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ft. Wayne, Ind.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Rube Goldberg Breakfast Device.")]), _vm._v(" Device that automatically makes breakfast as the hero is waking up. This appears early in films (usually children’s films) to establish a wacky or eccentric inventor/scientist. For example: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chitty Chitty Bang Bang. ")]), _vm._v("In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Back to the Future, ")]), _vm._v("it even fed the dog. Other examples: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Honey, I Shrunk the Kids ")]), _vm._v("(only American one with an oatmeal maker); "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pee-wee’s Big Adventure")]), _vm._v(" (cracked an egg with toy bobbing bird; all flapjacks stayed on ceiling); "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Casper ")]), _vm._v("(established Casper’s father, never seen, as inventor; had Personal Grooming Device); "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Wrong Trousers ")]), _vm._v("(also had PGD, and foreshadowed technology gone wrong); "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Close Shave ")]), _vm._v("(had semiautomatic porridge shooter); "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Flubber ")]), _vm._v("(ground the coffee beans in nice yuppie touch, cracked egg with laser).")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v(" Betsy Lawlor and Colin Lawlor Sanders, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Riverside, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Rule of Chronic Tunnel Vision.")]), _vm._v(" In a horror movie, the character being stalked has vision limited to the camera’s field of view. Therefore, anyone coming at any angle not directly ahead will invariably scare the living daylights out of him or her.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Daniel Alvarado, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Arleta, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Rule of Concurrent Gestation.")]), _vm._v(" Any two women who are pregnant in the same movie will deliver at the same time. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Father of the Bride II, Micki and Maude, Nine Months, Junior.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Doug Thomas, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Seattle")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Rule of Detective’s Girlfriend’s ESP.")]), _vm._v(" Whenever another woman kisses a detective, his girlfriend picks this moment to walk in and see them. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who Framed Roger Rabbit, Dick Tracy.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Luis Jacobo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tulare, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Rule of Reverse Explosive Proportionality.")]), _vm._v(" The quality of a movie containing an explosion is in roughly reverse proportion to the number of times that same explosion is shown from different angles. Example: The exploding van is shown four times in the movie "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dead Heat, ")]), _vm._v("earning it a one-star rating.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Martin Vasko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("San Francisco")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Rule of the Hallucinogenic Carousel.")]), _vm._v(" Any time the hero or heroine is being pursued and the chase leads to a merry-go-round, the villain will be unable to catch his prey. Rather than wait ten seconds for the carousel to complete a revolution, the villain will immediately hop on in hot pursuit. During the chase the audience is often treated to weird calliope music. No real carousel uses such music; it sounds as if the sound track was switched with the fun house.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("John E. Roche, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("San Francisco")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Rule of the Purloined Letter.")]), _vm._v(" When a character’s mail has been regularly intercepted, all letters will be carefully preserved by the interceptor. There will be a heart-touching scene at the end where the character finally gets all of those letters and reads them one by one.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "img ",
    attrs: {
      "alt": "",
      "src": "images/img_58.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Saliva Syndrome.")]), _vm._v(" Heroines who are tied up have an uncanny compulsion to spit in the villain’s face. In response, the villain inevitably smiles.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Sarandon-Mirren Rule.")]), _vm._v(" The best nude scenes are done by women who no longer have to do them for career reasons.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("David Stevens, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Irving, Tex.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Satin Static Cling Phenomenon.")]), _vm._v(" The heroine, after spending the night cavorting with a man she met only a few hours earlier, carefully pulls up the bedsheet to modestly cover herself when he says good-bye the next morning. Amazingly, the sheets stay in place even while she is sitting up. This rule does not apply in movies in which Madonna or Sharon Stone appear.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Alan Johnson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Phoenix")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Scary Old Man (or Woman).")]), _vm._v(" Used in horror movies to warn the young people to stay away from the old house, castle, woods, etc. Usually portrayed as a homeless person or someone that all the townspeople regard as crazy. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Friday the 13th ")]), _vm._v("movies.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Eugene Accardo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Brooklyn, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Sci-Fi Currency Conversion.")]), _vm._v(" In any science-fiction movie, anywhere in the galaxy, currency is refered to as “credits.”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Sam Humphries")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Screech in Time.")]), _vm._v(" When the protagonist in a movie needs to get across the street in a hurry, he or she inevitably comes within an eyelash of getting hit by the obligatory car which screeches to a halt only two inches away. Once this phenomena has occurred, the hero has no more problems getting to the other side.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Rusty Southwick, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Orem, Utah")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Seagal Severity Scale.")]), _vm._v(" The closer together Steven Seagal’s eyebrows are, the more violent the next scene.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dawson Rambo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tucson, Ariz.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Sean Connery Exception.")]), _vm._v(" Bald men are not allowed to perform romantic kissing in the movies unless they are later revealed to be villains, or are Sean Connery.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Second Car Rule:")]), _vm._v(" Any fruit cart, plate-glass window, slow-moving camel, or other impediment not encountered by the first car in a chase must necessarily be encountered by the second one, usually to cheap comic effect. (First car narrowly misses two guys carrying plate-glass window. They breathe a sigh of relief. Then second car smashes it.)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Tim Carvell, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Secretary Rule.")]), _vm._v(" In any scene where a character barges into someone else’s office (boss, coworker, enemy), the bargee’s secretary will always scold the character, warning him or her not to go into the office. The character will then disregard the warning and go in anyway, which leaves the secretary trying to stop the intrusion to no avail.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Rob Wolejsza, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Astoria, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Seeing-Eye Man.")]), _vm._v(" Function performed by most men in Hollywood feature films. Involves a series of shots in which (1) the man sees something, (2) he points it out to the woman, (3) she then sees it too, often nodding in agreement, gratitude, amusement, or relief.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("First identified by ")]), _vm._v("Linda Williams")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "img ",
    attrs: {
      "alt": "",
      "src": "images/img_33.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Seeing Stars.")]), _vm._v(" In any space movie, stars must be visible in the background of all exterior space shots—even though, in reality, there is no camera or film sensitive enough to pick them up without overexposing whatever is in the foreground.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Gerald Fitzgerald, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dallas")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("“See You Next Wednesday.”")]), _vm._v(" This line was used in the telephone call from space in Stanley Kubrick’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("2001,")]), _vm._v(" and has since been used in every single film directed by John Landis. For that matter, Kubrick had a scene involving a bathroom in every one of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("his")]), _vm._v(" films.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Self-Help Lane.")]), _vm._v(" When movie heroes crash a high-society party, they head straight for a beautiful lady, and are always able to trap two drinks from the tray of a passing waiter before reaching their lovely destination.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Alexis S. Mendez, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aguadilla, Puerto Rico")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Self-Orchestrating Piano.")]), _vm._v(" When the musician hero starts dreaming up a piano concerto, the piano can somehow summon up a full orchestra to accompany itself within twenty-five seconds. Some singers can also do this.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Hilary Potts, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("West Ealing, London")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Semi-Obligatory Lyrical Interlude (Semi-OLI).")]), _vm._v(" Scene in which soft focus and slow motion are used while a would-be hit song is performed on the sound track and the lovers run through a pastoral setting. Common from the mid-1960s to the mid-1970s; replaced in 1980s with the Semi-Obligatory Music Video (q.v.).")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Semi-Obligatory Music Video (Semi-OMV).")]), _vm._v(" Three-minute sequence within otherwise ordinary narrative structure, in which a song is played at top volume while movie characters experience spasms of hyperkinetic behavior and stick their faces into the camera lens. If a band is seen, the Semi-OMV is inevitably distinguished by the director’s inability to find a fresh cinematic approach to the challenge of filming a slack-jawed drummer.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Send in the Clones.")]), _vm._v(" If a computer is used early in a film, every subsequent computer will have exactly the same operating system, display typeface, and command structure, and will conform to any special hardware or software modifications or enhancements made to any computer prior to that point in the movie.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Brannon Moore, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Seattle")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Sequel.")]), _vm._v(" A filmed deal.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Seven Minute Rule.")]), _vm._v(" In the age of the seven-minute attention span (inspired by the average length between TV commercials), action movies aimed at teenagers are constructed out of several seven-minute segments. At the end of each segment, another teenager is dead. When all the teenagers are dead (or, if you arrived in the middle, when the same dead teenager turns up twice), the movie is over.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Sex-Specific Disintegrating Outfit.")]), _vm._v(" When the male and female characters in a trashy action movie go to hell and back, only the woman’s clothing begins to disintegrate.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dave Polsky, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ottawa, Canada")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Sex-Specific Sticky Sheet Technique.")]), _vm._v(" The large seam at the top edge of sheets used in movies is covered with a sex-specific adhesive, causing the sheet to stick firmly to the upper breast area of women, while inches away, the same sheet clings above the man’s waist.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("David Stevens, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Irving, Tex.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Shelley Winters Index.")]), _vm._v(" In scenes where a character must hold his or her breath and swim underwater, the elapsed time in seconds between the “pfoooahh!” of the last audience member giving up trying to match the time, and the character’s finally reaching a supply of air. For instance, in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Abyss, ")]), _vm._v("Ed Harris’s SWI is 3.2; in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Star Trek IV ")]), _vm._v("William Shatner’s is 40.0; and in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Poseidon Adventure ")]), _vm._v("Shelley Winters herself racks up an impressive SWI of 149.9.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Shoe of Threat.")]), _vm._v(" When a POV shot shows a victim crawling toward the camera on the floor, chances are he will eventually come upon a shoe. As he looks up, the camera will tilt to show a menacing figure towering above him.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Short Life Syndrome.")]), _vm._v(" Night watchmen in horror movies have a life expectancy of twelve seconds.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Sam Waas, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Houston")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Short Time Syndrome.")]), _vm._v(" Applies to prison, war, or police movies, where the hero only has a few more days until he is free, his tour is over, or he can retire with full pension. Whenever such a character makes the mistake of mentioning his remaining time (“Three days and I’m outta here!”) he will die before the end of that time.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Silent Death Rule.")]), _vm._v(" Whenever movie characters are shot with a gun with a silencer, they cooperate by dying quietly. ")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Nate Marmur, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rochester, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Simultaneous Recovery Syndrome.")]), _vm._v(" When a group of movie characters is rendered unconscious, all characters awake at approximately the same time.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jeff Braun, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Seattle, ")]), _c('span', {
    staticClass: "city-state"
  }, [_vm._v("and")]), _c('em', {
    staticClass: "italic"
  }), _vm._v("Bill Russell,"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Richmond, Ind.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Sinatra’s Law.")]), _vm._v(" In any Odd Couple Formula movie, the buddies will run into a situation in which the normal partner is unable to function successfully. The other partner, representing the eccentric, abnormal, and supposedly wrong way of doing things, will invariably say, “Let’s try doing it . . . my way.” (E.g., Eddie Murphy in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("48 HRS, ")]), _vm._v("Mel Gibson in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lethal Weapon, ")]), _vm._v("etc.)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Patrick Dorsey, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Huntington, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Single Bullet Rule:")]), _vm._v(" Whenever two characters are struggling for a gun, it must discharge one (1) bullet before the struggle is resolved. No more, no less.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Tim Carvell, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Sinister Stretch Limo Rule.")]), _vm._v(" Movie villians are often chauffeured in black stretch limos with darkly tinted windows. This does not make them an object of curiosity in the rundown warehouse districts or dangerous inner city streets where they usually are found. See also “Limo Exclusion Law.”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Siskel’s Test.")]), _vm._v(" “Is this film more interesting than a documentary of the same actors having lunch?”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Gene Siskel")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Siskel’s Theory of Relativity.")]), _vm._v(" The movie is moving slowly when you begin to look at your watch. It is moving very slowly when you begin to tap your watch to be sure it hasn’t stopped.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Gene Siskel")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Skoal Rule.")]), _vm._v(" Any non–sports-related character who chews tobacco is evil. All sports-related characters who chew tobacco are good.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dawson Rambo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tucson, Ariz.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Slap of Commitment.")]), _vm._v(" Moment in any film when the hero and heroine argue heatedly about how much they hate one another, escalating to the point when the heroine slaps the hero—followed by their passionate embrace.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Patrick Roduin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Seattle")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Slide Show Rule.")]), _vm._v(" During briefings about the search for a sinister international criminal, the chief good guy will hold a magic lantern show, projecting a blurry picture of the bad guy and intoning, “He’s a former member of the KGB/IRA/Red Brigade.” (Cf. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nighthawks, In the Line of Fire.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Chris Fisanick, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Barnesboro, Pa.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("SloMo Team Saunter.")]), _vm._v(" Depending on when in the movie this occurs, this sequence has two meanings. At the beginning of the movie, over the title credits, the SloMo Team Saunter is designed for us to see “The Team” as a single unit, so that later, we know who the Good Guys are. In an action/adventure movie, the SloMo Team Saunter will let us know that training has finished, and that some serious butt-kicking is about to commence. In sports, especially kid-based sports movies, the SMTS is designed to let us know that the disparite collection of misfits has come together as one, and also, serious butt-kicking is about to commence. Any movie made after "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reservoir Dogs, ")]), _vm._v("with saunter will resemble the gait and placement of the characters in that movie.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dawson Rambo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tucson, Ariz.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Smoothly Gliding Death.")]), _vm._v(" Any time the movie leaves a scene by cutting to a slow tracking shot looking at the back of a supporting character sitting at a desk or table while working hard on some task or project critical to the good guys’ victory, that character is about to die.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Brannon Moore, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Seattle")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Snicker-Snack Effect.")]), _vm._v(" In horror movies, whenever we see a knife with a big, shiny blade, we inevitably hear the scrape of metal against metal, even if it touches nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Snoozers’ Synopsis.")]), _vm._v(" For the convenience of audience members who slept through part of a film, there is usually a loud noise in association with the climax, followed by a speech in which the hero explains what the movie was all about. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Stripes ")]), _vm._v("(Murray to the troops), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The ’Burbs ")]), _vm._v("(Hanks on his lawn), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Purple Rose of Cairo ")]), _vm._v("(Tom’s movie “self” before he reenters the movie screen). Especially true of stories that end in a courtroom or similar setting: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Quiz Show ")]), _vm._v("(the hearing), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ghosts of Mississippi ")]), _vm._v("(the trial), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Scent of a Woman ")]), _vm._v("(the hearing).")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Paul Wieder, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Snore-Snort Syndrome.")]), _vm._v(" When the hero absolutely, positively, has to stay awake during a critical stakeout he’ll inevitably fall asleep. But his nodding head will jolt him back awake at just the right moment, five seconds before the crisis.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Chris Troise, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Sorceresses’ Cackle.")]), _vm._v(" All movie characters who play witches, voodoo priestesses, black magic practitioners, etc., end enigmatic statements with an evil cackle.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Sound Track Cautionary Rule.")]), _vm._v(" Don’t bother with any movie where the ads devote more attention to the performers whose music is on the sound track than to the plot or the actors.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Steven Stien, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Buffalo Grove, Ill.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Sound Track Surprise.")]), _vm._v(" Occurs when the audience members think the song they are hearing is just part of the sound track and not being heard by the characters, but it suddenly ends when a character turns off the stereo or radio.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Kyle L. Cain, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sugar Land, Tex.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Space Alien Rule.")]), _vm._v(" No matter how strange a space alien looks or how far away he comes from, he will always be a binaural, bipedal humanoid with two arms.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Gerald Fitzgerald, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dallas")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Spacious Poverty Rule.")]), _vm._v(" “Cramped quarters” in a film (cramped big-city studio apartments, college dorm rooms, hospital and motel rooms) are invariably much more spacious than any available in real life.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Kris Corradetti, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Youngstown, Ohio")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Sparks and Steam Factory.")]), _vm._v(" In action movies, the chase inevitably leads to the interior of a factory where showers of sparks fall to the floor, and great clouds of steam billow up from below. As nearly as the audience can determine, these are the factory’s only products.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Spinning Image Flipover.")]), _vm._v(" The use of an optical printer to spin the picture to create the unconvincing illusion that a car is rolling over in a car accident.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Split the Difference Ending.")]), _vm._v(" Movies about exaggeratedly masculine main characters caught in a moral dilemma in which there’s no clear-cut “right” answer usually end by splitting the difference so that the hero can be right and wrong at the same time. This satisfies the emotional needs of the audience at the expense of logic, realism, or morality. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("White Squall, Crimson Tide.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Rich Elias, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Delaware, Ohio")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Stab the Priest and Shoot the Blind Man Syndrome.")]), _vm._v(" When moviemakers are afraid their villain is becoming too sympathetic, they have him perform a dastardly act immediately before he is killed. That is the only reason Kirk Douglas stabs a priest in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Vikings ")]), _vm._v("and Gene Hackman shoots a blind man in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Quick and the Dead.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Wayne Klatt,"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Stalled Truck Technique.")]), _vm._v(" Whenever a cop is chasing quarry in an alley, a truck will back into the alley, cutting off the cop. The truck then mysteriously becomes rooted to the spot, and the cop jumps out of the car. Cut to: the quarry getting away. Cut back to: the cop pounding the roof of his car. (In rural movies, substitute narrow dirt road for alley, and farm tractor for truck.) See also “Camel, Slow-Moving.”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Michael J. Pilling, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maple Ridge, B.C., Canada")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Stanton-Walsh Rule.")]), _vm._v(" No movie featuring either Harry Dean Stanton or M. Emmet Walsh in a supporting role can be altogether bad. Exceptions are "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chattahoochee, ")]), _vm._v("starring Walsh, and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wild at Heart, ")]), _vm._v("starring Stanton.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Stardom Uncertainty Principle.")]), _vm._v(" The introduction of a major star into a perfect screenplay will diminish it in unpredictable ways.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Stealth Helicopters.")]), _vm._v(" Although the helicopter is one of the loudest machines in existence, movie characters never hear a helicopter until they actually see it appearing in the window, rising over a bridge, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Shari C. Parker, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('img', {
    staticClass: "img ",
    staticStyle: {
      "page-break-before": "always"
    },
    attrs: {
      "alt": "",
      "src": "images/img_34.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Stepford Babe.")]), _vm._v(" In any movie in which the protagonist is a moron who farts, curses, swears, stumbles, trips over things, and grows warts on his forehead, the serene Babe he falls for never notices how repulsive and idiotic he constantly appears, except to occasionally evince mild surprise. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Happy Gilmore, Beverly Hills Ninja, The Nutty Professor, High School High, Ace Ventura, The Waterboy,")]), _vm._v(" etc.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v(" Fran Pelzman Liscio, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Upper Montclair, N.J.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Still Out There Somewhere.")]), _vm._v(" Obligatory phrase in Dead Teenager and Mad Slasher Movies, where it is triggered by the words, “The body was never found. They say he/she is . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Stinking Badges Drawer.")]), _vm._v(" Special drawer in the desk of every police chief where he keeps the badges of cops he’s put on suspension. Usually has only one badge in it, though, because he can always reach into it and, without looking, grab the badge of the cop who is the hero of the movie.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Brian Jones")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Stompworthies.")]), _vm._v(" Interchangeable movie extras, usually appearing in ethnically mixed groupings of three or more, whose job is to act unruly and obnoxious in a public place, thus necessitating a photogenic pummeling (invariably topped with a zippy one-liner) by the film’s action-hero.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jeff Levin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rochester, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Stradivarius Rule.")]), _vm._v(" Whenever a violin is an important part of a movie plot, it is a Stradivarius. Whenever such an instrument does appear on the screen, it is, of course, doomed.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Bob Goodman, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York University")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("“Stranger in a Strange Land” Principle.")]), _vm._v(" When a star of a movie shows up in a new town, that person will be famous in that town by the end of the movie.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Streep Throat.")]), _vm._v(" Malady affecting vocal chords of movie characters. Symptoms commence at the point at which an actor decides that keeping up a difficult Brooklyn (or South Boston, Irish, Hungarian, etc.) accent is more trouble than it is worth.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Street Furniture Rules.")]), _vm._v(" (1) All movies set prior to 1955 should have yellow and black stop signs. (2) All movies set prior to 1982 should lack "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("USA Today ")]), _vm._v("boxes.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Hank Ottery, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Stupid Adult Rule.")]), _vm._v(" In any situation where a child or teenager finds that the group is in danger, or has the solution to a problem that stumps all the adults, the adults will invariably refuse to listen to the kid. This continues either until it’s almost too late, or until the kid takes matters into his or her own hands. Especially likely in any episode of “Star Trek” where Wesley Crusher appears.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andrew Coles, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Toronto")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Sturgeon’s Law.")]), _vm._v(" “Ninety percent of everything is crap.” (First formulated in the 1950s by the science-fiction author Theodore Sturgeon; quoted here because it so manifestly applies to motion pictures.)")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Substandard Movie Tires.")]), _vm._v(" Movie characters have worn tires on their cars. Even an easy stop from five miles an hour produces a skidding sound as if the brakes were locked from thirty miles an hour. Comfortably rounding a corner causes tire squealing. Even the wimpiest of cars makes a brief burning-rubber sound as it gently accelerates from a stop.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jim Collier, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dallas")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Superfluous Loudspeaker Rule.")]), _vm._v(" Automated announcements in movies exist only for atmosphere, and say useless things: “This is the third floor. This is the third floor.” Hanno Mueller,")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Hamburg, Germany")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Superfluous Pump.")]), _vm._v(" Dramatic effect in gun movies. The gunman has fired multiple shots and then when he has his victim cornered, unnecessarily pumps (cocks) his weapon, an action that would eject an unused shell.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("J. Ferguson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Elmhurst, Ill.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Supporting Sweat.")]), _vm._v(" Whenever a main character is in a steam room, a supporting character will have to enter the steam room while still wearing a suit and a tie. This will lead to the usual sweating, fidgeting, loosening of the tie, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Frank Mouton, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sacramento, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Surprise Gender Switch.")]), _vm._v(" In any competition where one of the opponents is wearing a garment that conceals body and face, if that opponent wins, in the next shot the head-covering is pulled off to reveal—gasp!—that the opponent was a woman!")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Surround Sound Reciprocal Principle.")]), _vm._v(" The amount of surround sound track usage is inversely proportional to the amount of dialogue worth hearing.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("David Kalin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("San Francisco")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("SWAT Movie.")]), _vm._v(" Sinks Without a Trace.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Rich Elias, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Delaware, Ohio")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "img ",
    attrs: {
      "alt": "",
      "src": "images/img_59.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Technopyromania.")]), _vm._v(" Affliction that compels filmmakers and special effects people to depict the malfunction of computers as being accompanied by smoke, flames, showers of pyrotechnic sparks, frenzied flashing lights, and wildly spinning tape drives spewing tape into the air.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Paul A. Lee, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Germantown, Wis.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Teeny-Prole.")]), _vm._v(" An actor who looks like a handsome teenage model, playing a character who is allegedly a hardened proletarian (e.g., Johnny Depp in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Donnie Brasco, ")]), _vm._v("Keanu Reeves in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Speed, ")]), _vm._v("etc.).")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Teetotaler Relapse Syndrome.")]), _vm._v(" Any character introduced as a recovering alcoholic who’s been off the bottle for an extended period will go back to drinking sometime during the film. Examples: Michael Douglas in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Basic Instinct,")]), _vm._v(" Kenneth Branagh in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Peter’s Friends, ")]), _vm._v("Claire Danes in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Mod Squad.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jeff Levin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rochester, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("“Tell Me Where You Are and I’ll Come and Get You.” ")]), _vm._v("Telltale line that finally makes obvious to everyone (except the hero) that the hero’s trusted friend or supervisor has gone over to the bad guys.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jim Lee, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cary, N.C.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Telltale File Giveaway.")]), _vm._v(" Any time the good guy surreptitiously pilfers from a file cabinet, something will happen to force him to flee the scene shortly after discovering the needed secret information. His hasty departure will cause him to leave the file in a state that allows the bad guy to deduce who was there.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Rick Newby, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("College Place, Wash.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Ten Kickboxing Movies Still to Be Made: (1)")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Kickboxer Christmas; ")]), _vm._v("(2) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kalifornia Kickboxer; ")]), _vm._v("(3) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Where the Kickboxers Are; ")]), _vm._v("(4) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kickboxing in Fruit; ")]), _vm._v("(5) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kickboxer Karwash; ")]), _vm._v("(6) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oh to be Kickboxing; ")]), _vm._v("(7) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nick: The Kickboxer Who Couldn’t Read; ")]), _vm._v("(8) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("So Many Kickboxers; ")]), _vm._v("(9) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jaws VII: The Kickboxer; ")]), _vm._v("(10) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kickboxer VI, Jaws II.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Adam Plantinga, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Grand Rapids, Mich., "), _c('br')]), _c('span', {
    staticClass: "city-state"
  }, [_vm._v("and")]), _c('em', {
    staticClass: "italic"
  }), _vm._v("Hadley Beth, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Urbana, Ill.")])]), _vm._v(" "), _c('img', {
    staticClass: "img ",
    staticStyle: {
      "page-break-before": "always"
    },
    attrs: {
      "alt": "",
      "src": "images/img_35.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Thanks, but No Thanks.")]), _vm._v(" When two people have just had a heart-to-heart conversation, as Person A starts to leave room, Person B says (tentatively) “Bob?” A pauses, turns, and says “Yes?” B says, “Thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Betsey Brunk")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Thanks for Nothing!")]), _vm._v(" Of all the holidays on the calendar, Thanksgiving is the one most often chosen by the movies to show dysfunctional families in meltdown. The title card “Thanksgiving,” indeed, is almost a guarantee that shameful secrets, towering rages, and massive depression will be presented, along with a vast amount of alcohol abuse. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Home for the Holidays, The Ice Storm, The House of Yes, Unhook the Stars, The Myth of Fingerprints.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Theological Revisionism, Angel Division.")]), _vm._v(" Movies seem unaware that all world religions teach that angels are disembodied spirits without gender. They consistently confuse angels with reincarnated souls and with ghosts, leading to the problem of angels who take physical form, fall in love, eat hot dogs, decide to become human, etc. All "), _c('br'), _vm._v("of these actions are against the angel rules. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Preacher’s Wife, City of Angels, ")]), _vm._v("etc.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('img', {
    staticClass: "img ",
    staticStyle: {
      "page-break-before": "always"
    },
    attrs: {
      "alt": "",
      "src": "images/img_36.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Theory of Movie Relativity.")]), _vm._v(" If you watch the credits to the very end you will see at least one person listed who has the same last name as the director or one of the producers.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("David Burd, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("East Stroudsburg, Pa.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Therapeutic Child Law.")]), _vm._v(" If a character is introduced as hating children, he or she will like them by the end, and probably will have saved one from a life-threatening situation somewhere along the line.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Tom Cammalleri, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Santa Barbara, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("There-Goes-the-Neighborhood Rule.")]), _vm._v(" In horror movies, no matter how many ghostly apparitions or psychokillers appear in a house, the owners will not leave it. In fact, the more scared they get, the more determined they are to stay put. Apparently they’re earning some kind of “scream equity.” See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Amityville Horror, ")]), _vm._v("etc.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Raphael Carter, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tempe, Ariz.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Third Hand.")]), _vm._v(" Invisible appendage used by Rambo in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rambo, ")]), _vm._v("in the scene where he hides from the enemy by completely plastering himself inside a mud bank. Since it is impossible to cover yourself with mud without at least one hand free to do the job, Rambo must have had a third, invisible hand. This explains a lot about the movie.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Thirty-Minute Nudity Rule.")]), _vm._v(" If there is no female nudity in the first thirty minutes of a movie, there won’t be any later. This rule is inviolable in made-for-cable movies.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("David Stevens, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Irving, Tex.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "page-break-before": "always"
    }
  }, [_c('img', {
    staticClass: "img ",
    attrs: {
      "alt": "",
      "src": "images/img_37.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Three-Bill, No Change, Five-Second Rule.")]), _vm._v(" In movies, when paying for an item in a store, the customer always pays the clerk with no more than three bills. The clerk never offers change, even if the charge is $17.63. The whole transaction takes no more than five seconds.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Clay Waldrop "), _c('span', {
    staticClass: "city-state"
  }, [_vm._v("Jr., ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Garland, Tex.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Three Little Words.")]), _vm._v(" When someone says, “I’ve never seen him before in my life,” those last three words guarantee it’s a lie.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Greg Brown, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago, Ill.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Three-Minute Mark.")]), _vm._v(" No matter how empty a theater is, someone will take the seat directly in front of you within three minutes after the lights are dimmed, thus partially obstructing your previously clear view of the screen.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Three’s a Crowd Rule.")]), _vm._v(" In any movie where the protagonist, his sidekick, and another character are all working to solve a mystery, the third person will usually betray the other two (or will have been working against them all along). See Tom Sizemore’s character in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Strange Days, ")]), _vm._v("the taxi driver in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Total Recall, ")]), _vm._v("many others.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Gregor Gilliom, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Columbus, Ohio")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Throw ’em Back Syndrome.")]), _vm._v(" Whenever characters in a movie catch a fish they have been after for at least fifteen years, they always let it go because it has been a worthy opponent. Of course nobody believes them when they say they caught him. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Grumpier Old Men, On Golden Pond,")]), _vm._v(" etc.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jon Pietrowski, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Genoa, Ohio")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Tic Reversi.")]), _vm._v(" Nervous disorder that causes an actor to repeatedly pick up and put down an item upon each cut between reverse shots in a scene.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Paul A. Lee, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Germantown, Wis.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Tijuana.")]), _vm._v(" In modern Horny Teenager Movies, performs the same symbolic function as California did for the beatniks, Marakech did for the hippies, and Paris did for the Lost Generation.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Timely Bladder Syndrome.")]), _vm._v(" When hero is one of a group of people, he goes off to the toilet or other secluded room just as the villains attack. Glimpsing the action from the bathroom, he is unknown to the bad guys and thus still free to respond. See "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Die Hard ")]), _vm._v("(back room), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Under Siege ")]), _vm._v("(meat locker), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Passenger 57 ")]), _vm._v("(airplane toilet).")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Kevin Wan, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Seattle")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Time Waits for No Director.")]), _vm._v(" The minute hand on a clock always clicks the moment the camera cuts to it.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Title Tease Warning.")]), _vm._v(" Movies that alternate long passages of plot with opening credits for lengthy periods of screen time reflect the attention span of their creators and should be avoided.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. R. Kunz")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Tonight Show Validation.")]), _vm._v(" Public humiliation is always represented in the movies by Jay Leno’s jokes.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Ian Mantgani, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Liverpool, England")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Too-Soon Apology.")]), _vm._v(" Whenever one character seems to have died, and his best friend arrives just seconds too late to have saved him, the best friend must stand over his buddy’s body and confess to wronging his dead friend in some way (“Remember when Bettylou stood you up for the prom? Well, she was actually sneaking off to see me!”). The dead friend will inevitably turn out to have been merely wounded. Wacky hijinks ensue.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Tim Carvell, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Traction Action Rule.")]), _vm._v(" Whenever there’s a patient in traction with a cast on his leg and ropes attached to a pulley system, a visitor will inevitably cause the cast to go up into the air and the patient to experience severe pain.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Raul H. Marquez, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maryland")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Training Sequence.")]), _vm._v(" In any movie culminating in a competition, this is the montage during which the hero is turned from a loser into a winner through the inspired but merciless tutelage of the Coach Figure, who alternates between wisdom and sadism. See Pat Morita in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Karate Kid, ")]), _vm._v("Burgess Meredith in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rocky, ")]), _vm._v("John Candy in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cool Runnings, ")]), _vm._v("etc. The training inevitably includes one lesson that will be remembered in a flashback during a crucial moment of the competition, giving the hero fresh inspiration.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Treasure Map Thunderstorm Rule.")]), _vm._v(" In any film involving a treasure hunt, the characters find the map in an old dusty attic while it is raining outside. The characters stand with their backs to a window, looking at the map. When they realize its importance, there is always a thunderous boom and a bolt of lightning in the window. See"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" The Goonies ")]), _vm._v("and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("City Slickers II")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jeanne Kennelly, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('img', {
    staticClass: "img ",
    staticStyle: {
      "page-break-before": "always"
    },
    attrs: {
      "alt": "",
      "src": "images/img_38.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("TRISHA Phenomenon.")]), _vm._v(" The ability of the technical names of all movie computers to improbably collapse into a cute acronym, usually a female name (e.g., “Triply-Recursive Iteratively Symbolic Hierarchical Analyzer”).")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Tucco’s Advice.")]), _vm._v(" Named for the character played by Eli Wallach in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Good, the Bad and the Ugly. ")]), _vm._v("It comes in the scene where Tucco is taking a bath, and a guy bursts in the room, promising Tucco he will have vengeance on him. At that moment, Tucco kills him. Tucco then advises the corpse, “If you have to shoot, shoot! Don’t talk.” See also “Fallacy of the Talking Killer.”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Stephen J. Baughman")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Turning a Deaf Ear. ")]), _vm._v("Movie heroes squeeze off hundreds of rounds of ammo but suffer no hearing loss. For example, in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rambo III, ")]), _vm._v("Rambo enters a metal warehouse and runs an entire belt of ammo through his M-60 machine gun. Afterward he carries on a whispered conversation with the evil CIA man in another room.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Joseph Holmes")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Turn It Off Rule.")]), _vm._v(" Immediately after the radio or TV reports something important to the plot, someone must always reach over and turn it off.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Kyle L. Cain, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sugar Land, Tex.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Turtle Effect.")]), _vm._v(" Once characters are knocked down, they just lie there as if unable to get up (e.g., Sigourney Weaver in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Alien")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("James Portanova, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fresh Meadows, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Two-Faced Blouse.")]), _vm._v(" In movie scenes where an actress is auditioning for a director, one of the standard demands is that she take off her blouse and expose her breasts. Typically, the actress does not want to do this because she feels it violates her as a person. There are two possible outcomes: (1) she refuses, and stalks out; (2) she agrees, and bares her breasts. If the choice is (2), it’s interesting how many filmmakers allow the audience to see her breasts, instead of choosing a different angle. That means the filmmaker is going along with the humiliation, and expects us to enjoy it too.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Two-Hat Trick.")]), _vm._v(" Hero wears cool hat, sidekick wears goofy hat.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Two Sentence Rule.")]), _vm._v(" Any character who is introduced more than halfway through an action movie and (a) has a dialogue of more than two sentences with a major character, or (b) reveals to a major character that he or she has reached a milestone (twenty-first birthday, just got married, gets out of prison tomorrow, etc.) will die a tragic death before the end of the movie, cradled in the arms of that same character.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Sean Collins")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Tyro Transmission Rule.")]), _vm._v(" When an inexperienced driver gets behind the wheel for the first time, a special sensor automatically puts the car into reverse gear. This device seems to be a luxury item, since it is often found on expensive cars. It is especially effective near shrubbery, trees, swimming pools, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Adam Schindler, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "img ",
    attrs: {
      "alt": "",
      "src": "images/img_62.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Ultimate B-Western Cliché.")]), _vm._v(" It’s not “They went that-a-way.” It’s not “We’ll head ’em off at the pass.” No, it’s “We’ll give him a fair trial.” (Pause) “And then we’ll hang ’em.”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Michael Schlesinger, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Culver City, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Unattributed Critical Quotation.")]), _vm._v(" Words of praise for "), _c('br'), _vm._v("a film, contained within quotation marks and looking exactly like an excerpt from a review, but with their source curiously missing. There is a reason for that: They do not have a source, but have been written for the occasion by a movie publicist, who hopes that since they look like quotes from real critics, a hasty reader or TV viewer will be fooled.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Undead Dead.")]), _vm._v(" In horror movies, whenever the killer is killed, he is never dead. This rule is as old as the movies, but was given its modern shape in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Halloween ")]), _vm._v("(1978) when the killer arose from apparent destruction to jump up behind Jamie Lee Curtis. Since then, all of the Dead Teenager Movies, most of the Bond pictures, and many other thrillers have used a false climax, in which the villain is killed—only to spring up for a final threat. In an ordinary thriller, the cliché of the Undead Dead is part of the game—but its use in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fatal Attraction ")]), _vm._v("was unforgivable.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v(" R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Unheld Peace Rule.")]), _vm._v(" The words “speak now, or forever hold your peace” are never used in movie wedding ceremonies unless someone is not going to hold his or her peace.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v(" Alex Teich, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Universal Movie Computer Operating Laws.")]), _vm._v(" (1) All computers in a hi-tech movie have digitized speech and/or a personality. (2) The person typing on a computer speaks aloud what is on the screen, no matter how secret the information is. (3) Every teenage computer user is a hacker and owns a modem (see "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("WarGames, ")]), _vm._v("etc.). (4) Teenage hackers use computers to pick up girls who don’t have a clue about computers.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Olli Lehto, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Helsinki, Finland")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Universal Translator.")]), _vm._v(" Device carried by all spaceships, allowing instantaneous translation from any alien language into the local language. The most incredible thing about this device is the way it can alter any accompanying visual transmission from the aliens. If you look closely you will see the perfect synchronization of the speaking alien’s lips to the lip movements of the local language.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Richard Rohrdanz, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("West Kennebunk, Maine")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Unknown Team Member.")]), _vm._v(" Used in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Star Trek ")]), _vm._v("movies, cop movies, war movies, etc., whenever a team is on a dangerous mission. The unknown team member, not a recognizable actor, will be dead within forty-five seconds. “Jones is dead, sir” is a standard epitaph.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Sam Waas, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Houston")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Unmotivated Close-up.")]), _vm._v(" A character is given a close-up in a scene where there seems to be no reason for it. This is an infallible tip-off that this character is more significant than at first appears, and is most likely the killer. See the lingering close-up of the undercover KGB agent near the beginning of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Hunt for Red October.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Stuart Cleland, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Unselected Short Subjects.")]), _vm._v(" Although most sex scenes begin with the characters taking off some of their clothes, there is always a cut before they complete the process, because no male actor can seem sexy while taking off his shorts and socks.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Eugene Accardo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Brooklyn, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Unsilenced Revolver.")]), _vm._v(" Despite dozens of movies which think otherwise, a revolver cannot be silenced, because the sound escapes, not from the barrel where they fit the silencer, but from the gap between the frame and the cylinder. Only closed-breech weapons, like pistols with magazines in the grip, can be silenced—unless you wrap them in a pillow.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dawson E. Rambo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Las Vegas")])]), _vm._v(" "), _c('img', {
    staticClass: "img",
    staticStyle: {
      "page-break-before": "always"
    },
    attrs: {
      "alt": "",
      "src": "images/img_39.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Unsuspecting Students Law.")]), _vm._v(" At every high school dance that takes place in the fifties, some ruffian and his greasy-haired friends spike the punch.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Rhys Southan, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Richardson, Tex.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Unwise Trust Movie.")]), _vm._v(" A new genre in which an unsuspecting baby boomer confides in a psychopathic stranger. Started in recent years by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fatal Attraction ")]), _vm._v("(casual sex), it has expanded to other areas such as tenants "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Pacific Heights), ")]), _vm._v("baby-sitters "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(The Hand That Rocks the Cradle), ")]), _vm._v("roommates "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Single White Female), ")]), _vm._v("policemen "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Unlawful Entry), ")]), _vm._v("and office workers "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(The Temp).")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Dave Kalin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("San Francisco")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "img ",
    attrs: {
      "alt": "",
      "src": "images/img_63.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Vacuum Sound Effects.")]), _vm._v(" Most movies set in space, with the notable exception of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("2001, A Space Odyssey, ")]), _vm._v("treat the viewer to a full range of sound effects. Without a medium (air) to transport the sound waves there would, of course, be no sound.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("John D. McCluskey")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Vanishing Time Rule.")]), _vm._v(" If characters in a movie say they have plenty of time, they will either miss the train/exam/wedding or only get to it by the skin of their teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Hilary Potts, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("West Ealing, London")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("V-Barricade.")]), _vm._v(" Police cars try to stop getaways by forming a V-shaped barricade that the bad guy can easily bust through. See the end of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Drop Zone, ")]), _vm._v("where the eighteen-wheeler zips through the police obstacle.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Greg Brown, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Viewable Remains Regulation.")]), _vm._v(" Even if a test aircraft plunges 50,000 feet before crashing, the hero pilot lives long enough for the ground crew to pull him free and lie him on the tarmac so he can say good-bye to the heroine. No heroine has yet had to bid a tearful good-bye to a little pool of smoking grease.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Richard R. Kunz, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Vinny Rule.")]), _vm._v(" In every movie with Italian-American characters, one must be named Vinny.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Donald Munsch, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sherman, Tex.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Visiting Hours Factor.")]), _vm._v(" A hospital visit in a movie will "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("always ")]), _vm._v("end with a nurse informing the characters that visiting hours are over. If the nurse did not appear, the characters would not know when to end the scene and resume the movie.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("David Fleischer, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Toronto")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Voice Transplant Syndrome.")]), _vm._v(" Aural shock of hearing "), _c('br'), _vm._v("an actor lip-synching to the voice of a better singer, when you’ve heard that actor sing in his/her own voice in other movies (e.g., Audrey Hepburn, who warbles in her tolerable mezzo in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Funny Face ")]), _vm._v("and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Breakfast at Tiffany’s, ")]), _vm._v("but suddenly becomes a brilliant coloratura in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("My Fair Lady, ")]), _vm._v("courtesy of the singing voice of Marnie Nixon).")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Anthony Bruce Gilpin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Riverside, Calif.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "img ",
    attrs: {
      "alt": "",
      "src": "images/img_64.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("“Wait Right Here!” Rule.")]), _vm._v(" One character, usually male, tells another character, usually female, to “Wait right here. Do "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not ")]), _vm._v("follow me into the warehouse, cave, house, etc.” The woman inevitably does so, is captured, and must be rescued. Often inspires the line, “I thought I told you to wait outside.”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Donna A. Higgins, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Prairie du Chien, Wis.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Wash and Wax Rule.")]), _vm._v(" In the movies, only the good guys get to drive dirty cars. Any “villain” in a dirty car will be revealed later as having secretly been a good guy.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Don Howard, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("San Jose, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Watch Your Step Rule.")]), _vm._v(" Suicides always choose the ledge with the pigeon.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Matthew Cope, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westmont, Quebec")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Waterfall Rule.")]), _vm._v(" If character falls into a river, it is inevitably just upstream of a major waterfall or series of rapids. This is true no matter how flat the terrain has been to this point or how gentle the stream. No one ever falls into a river downstream from rough water.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Joe DiCostanzo, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York City")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Wayne’s World ")]), _c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Rule.")]), _vm._v(" In any movie based on a television show, at least a quarter of the audience will be involutarily trying to change the channel.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Bill Becwar, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wauwatosa, Wis.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Weak-Ankled Female Syndrome, The.")]), _vm._v(" Whenever a man and woman are on the run, the woman inevitably falls and sprains her ankle. As a result, the man must drag or carry her and their progress is slowed, stalled, or halted.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Bridgette Clark, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Moundsville, W.Va.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Wedding Cake Rule.")]), _vm._v(" In any movie comedy involving a wedding, the cake will be destroyed.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("John Weckmueller, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Menomonie, Wis.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("We’re Alive! Let’s Kiss! ")]), _vm._v("Inevitable conclusion to any scene in which hero and heroine take cover from danger in each other’s arms. (Cf. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("High Road to China, Die Hard")]), _vm._v("—where Bruce Willis kisses his wife, forgetting that he is in a burning building.)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Wet Road Rule.")]), _vm._v(" Any road seen in a film, no matter how hot or dry the day has been, will be wet, slick, and reflecting headlights after nightfall. This is most commonly seen in deserts and drought-stricken cities like Los Angeles.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Edward Savio, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("San Francisco")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Wet Star Rule.")]), _vm._v(" In Hollywood story conferences, suggested alternative to nude, as in: “If she won’t take off her clothes, can we wet her down?” Suggested by Harry Cohn’s remark about swimming star Esther Williams: “Dry, she ain’t much. Wet, she’s a star.”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("“We’ve Got Company.”")]), _vm._v(" These words are always used to inform the driver of a vehicle that it is being followed by the police.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Wharton’s Law.")]), _vm._v(" If you were forced to read the book in high school, you’ll probably hate the movie too.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("What Befits a Legend Least.")]), _vm._v(" Any film with the word “legend” in the title won’t be legendary. Consider "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Legend, The Legend of Billie Jean, The Legend of Lylah Clare, The Legend of Boggy Creek, The Legend of the Lone Ranger, Legends of the Fall, Geronimo: An American Legend, Legend of Tom Dooley, When the Legends Die. ")]), _vm._v("Sole exception: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Legend of Hell House, ")]), _vm._v("a legendary little thriller.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("What Happened to Our Dreams of Changing the World? ")]), _vm._v("A genre first identified by Adam Mars-Jones, in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("London Independent, ")]), _vm._v("1992. Examples: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Four Corners, Return of the Secaucus Seven, The Big Chill, Indian Summer, Peter’s Friends.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("“What’s That Supposed to Mean?”")]), _vm._v(" Dialogue invariably used by accused party in romantic argument. Win bets with your friends while watching made-for-TV melodramas: phrase occurs in every single one.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Michael J. Pilling, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maple Ridge, B.C., Canada")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Wheels Heels.")]), _vm._v(" Movie characters can own rare classic automobiles, but only if they are oblivious to their uniqueness and value, i.e., the Thunderbird in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Thelma and Louise, ")]), _vm._v("the Nash Metropolitan in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Big Picture, ")]), _vm._v("the Ford Fairlane convertible in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Adventures of Ford Fairlane, ")]), _vm._v("the old Mercury used as a getaway car in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Thunderbolt and Lightfoot, ")]), _vm._v("the Studebaker Golden Hawk in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Hot Spot, ")]), _vm._v("the Buick in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rain Man, ")]), _vm._v("and virtually any pink Cadillac.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Merwyn Grote, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Where’s Daddy Rule.")]), _vm._v(" If two people are having an extramarital affair and one of the partners has a child, the kid will enter the room and ask about the victim parent, to make the lovers feel guilty. See"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" The Great Gatsby.")])]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Rhys Southan,"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Richardson, Tex.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Who Guards the Guards?")]), _vm._v(" Anyone who utters the words, “Don’t worry—it can’t possibly escape!” will be the first to die.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Michael Schlesinger, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Culver City, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Wild Kingdom Phenomenon.")]), _vm._v(" No interesting animal is limited to its natural range. This mismatching probably started with Tarzan films, in which Tarzan rode Asian elephants, fought tigers (Asia only) and cougars (Americas only), wrestled American alligators, and avoided boa constrictors (tropical America only).")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Steve W. Zack")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Willis Duct.")]), _vm._v(" In all movies about a lone hero who battles terrorists on a boat/building/plane, there is always one duct which doesn’t appear on the terrorists’ copy of the blueprints but which the hero immediately locates and uses to escape from the floor/deck/room where the terrorists think the hero is trapped and can do no harm.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Andy Ihnatko, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Westwood, Mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Windows of the Soul.")]), _vm._v(" Any main character who wears glasses will, at least once, take the glasses off to express some deep emotion or give an impassioned speech.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jerry Ritcey")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Women’s Battling Backpack Stance.")]), _vm._v(" In any fight scene involving a woman and a man, the woman will leap onto the man’s back, wrap her legs around his waist, and flail at his head with her pocketbook. The woman is ineffectual and the man lurches around like a bewildered ox. Directors think this is hilarious.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Frances Pelzman Liscio, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Upper Montclair, N.J.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Women’s Shower Syndrome.")]), _vm._v(" Movies with scenes set in women’s showers inevitably portray them as brightly lit, open playrooms where nude women laugh, frolic, and snap each other with towels. Those not participating in high jinks are slowly and seductively soaping themselves under the shower spray.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("James Moore, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("San Jose, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Wrongheaded Commanding Officer.")]), _vm._v(" In modern police movies, the commanding officer exists solely for the purpose of taking the hero off the case, calling him on the carpet, issuing dire warnings, asking him to hand over his badge and gun, etc. (Cf. the Dirty Harry series, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blue Steel, ")]), _vm._v("etc.)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Tony Whitehouse, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Verbier, Switzerland")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Wrong Twin Maxim.")]), _vm._v(" Whenever there is a chase scene in a crowd of people, the chasers have their hands on the quarry before realizing their captive is not the person they are looking for, but someone who sports the exact same outfit and haircut from the back. That is why it is important for heroes to always shop at popular retail outlets.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Benjamin Sage, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York, N.Y.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Wunza Movie.")]), _vm._v(" Any film using a plot which can be summarized by saying “One’s a . . .” For example, “One’s a cop. One’s an actor.” Or “One’s a saint. One’s a sinner.”")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("David King, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Los Angeles")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "img ",
    attrs: {
      "alt": "",
      "src": "images/img_67.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("X-Ray Driver.")]), _vm._v(" In many thrillers, the hero crashes his car or truck through the window or wall of a building at the precise time and place to allow him to rescue a victim or kill the bad guys. How can he see through the walls to know exactly where his car will emerge? Why doesn’t he ever drive into a load-bearing beam?")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "img ",
    attrs: {
      "alt": "",
      "src": "images/img_65.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Yakima Canute Rule.")]), _vm._v(" Any chase scene involving a fistfight between the hero and bad guys while they are speeding in a truck or wagon requires the hero to fall over the front of the vehicle, slide between the wheels to the rear, and pull himself up onto the back, surprising the bad guys. (Named after the famous stuntman who originated this move in stagecoach chase scenes.)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Sam Waas, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Houston")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("You Can Go Home Again.")]), _vm._v(" In all small-town settings, there is always (a) a parade taking place; (b) a carnival; (c) a shooting gallery, where the girl always outshoots the boy; (d) a picnic basket raffle, always won by the second male and female leads; and (e) a sheriff with the most pronounced accent in town.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Michael Kunkle, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Santa Rosa, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Youngblood Rule.")]), _vm._v(" No movie with a hero named “Youngblood” has ever been any good. (Cf. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Youngblood Hawke, Youngblood, ")]), _vm._v("etc.)")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Your Body Is Waiting.")]), _vm._v(" Whenever somebody dies in a hospital, the closest relative or lover finds out by arriving at the hospital and seeing either: (1) orderlies placing a covered body in a waiting hearse or (2) orderlies making the bed of the deceased person. In real life, no covered body is ever loaded into a hearse outside the front door! That’s done somewhere out back near the electrical generator.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Jim Simon, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Villa Park, Calif.")])]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("“You’ve Got to Believe Me!” Rule.")]), _vm._v(" The character who is seeing and hearing things is invariably the only one who knows what is really going on.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("Benjamin Johnson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Provo, Utah")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticClass: "img ",
    attrs: {
      "alt": "",
      "src": "images/img_66.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paragraph-1"
  }, [_c('span', {
    staticClass: "bold-text"
  }, [_vm._v("Z.")]), _vm._v(" Pronounced “zed” in British movies, something most American audiences do not know.")]), _vm._v(" "), _c('p', {
    staticClass: "small-cap"
  }, [_vm._v("R. E.")])])])])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9780740792465',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(100)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(102);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 102 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.d7f9b854f5a84d0dd4ea.js